// AUTO-GENERATED by scripts/gen-scene-data.mjs — do not edit by hand
// Regenerate: node scripts/gen-scene-data.mjs
// Seed: 275616998  Nodes: 678  Chains: 200

export interface Cube {
  cx: number
  cy: number
  cz: number
  half: number
}
export type VerifyState = 'positive' | 'negative'

/** All fractal nodes — position + half-size. */
export const STATIC_CUBES: Cube[] = [
  { cx: 0, cy: 0, cz: 0, half: 0.6 },
  {
    cx: 0.7732050807568877,
    cy: 0.7732050807568877,
    cz: -0.7732050807568877,
    half: 0.3,
  },
  {
    cx: 0.38660254037844377,
    cy: 1.1598076211353314,
    cz: -0.38660254037844377,
    half: 0.15,
  },
  {
    cx: 0.5799038105676657,
    cy: 0.9665063509461096,
    cz: -0.5799038105676657,
    half: 0.075,
  },
  {
    cx: 0.19330127018922183,
    cy: 1.3531088913245533,
    cz: -0.19330127018922183,
    half: 0.075,
  },
  {
    cx: 0.09665063509461086,
    cy: 1.449759526419164,
    cz: -0.09665063509461086,
    half: 0.0375,
  },
  {
    cx: 0.14497595264191634,
    cy: 1.4980848439664696,
    cz: -0.14497595264191634,
    half: 0.01875,
  },
  {
    cx: 0.12081329386826362,
    cy: 1.5222475027401223,
    cz: -0.12081329386826362,
    half: 0.009375,
  },
  {
    cx: 0.10873196448143724,
    cy: 1.510166173353296,
    cz: -0.10873196448143724,
    half: 0.0046875,
  },
  {
    cx: 0.13289462325509,
    cy: 1.5343288321269486,
    cz: -0.13289462325509,
    half: 0.0046875,
  },
  {
    cx: 0.14497595264191634,
    cy: 1.4980848439664696,
    cz: -0.04832531754730539,
    half: 0.01875,
  },
  {
    cx: 0.12081329386826362,
    cy: 1.5222475027401223,
    cz: -0.024162658773652652,
    half: 0.009375,
  },
  {
    cx: 0.13289462325509,
    cy: 1.5343288321269486,
    cz: -0.012081329386826274,
    half: 0.0046875,
  },
  {
    cx: 0.13893528794850318,
    cy: 1.5403694968203616,
    cz: -0.006040664693413086,
    half: 0.00234375,
  },
  {
    cx: 0.10873196448143724,
    cy: 1.5343288321269486,
    cz: -0.03624398816047903,
    half: 0.0046875,
  },
  {
    cx: 0.11477262917485043,
    cy: 1.5282881674335356,
    cz: -0.04228465285389222,
    half: 0.00234375,
  },
  {
    cx: 0.04832531754730539,
    cy: 1.4980848439664696,
    cz: -0.04832531754730539,
    half: 0.01875,
  },
  {
    cx: 0.07248797632095813,
    cy: 1.5222475027401223,
    cz: -0.07248797632095813,
    half: 0.009375,
  },
  {
    cx: 0.08456930570778451,
    cy: 1.5343288321269486,
    cz: -0.06040664693413176,
    half: 0.0046875,
  },
  {
    cx: 0.0906099704011977,
    cy: 1.5403694968203616,
    cz: -0.05436598224071857,
    half: 0.00234375,
  },
  {
    cx: 0.06040664693413176,
    cy: 1.510166173353296,
    cz: -0.06040664693413176,
    half: 0.0046875,
  },
  {
    cx: 0.06644731162754496,
    cy: 1.516206838046709,
    cz: -0.05436598224071857,
    half: 0.00234375,
  },
  {
    cx: 0.04832531754730539,
    cy: 1.4014342088718585,
    cz: -0.04832531754730539,
    half: 0.01875,
  },
  {
    cx: 0.024162658773652652,
    cy: 1.4255968676455113,
    cz: -0.07248797632095813,
    half: 0.009375,
  },
  {
    cx: 0.03624398816047903,
    cy: 1.413515538258685,
    cz: -0.08456930570778451,
    half: 0.0046875,
  },
  {
    cx: 0.04228465285389222,
    cy: 1.407474873565272,
    cz: -0.07852864101437132,
    half: 0.00234375,
  },
  {
    cx: 0.03624398816047903,
    cy: 1.4376781970323376,
    cz: -0.08456930570778451,
    half: 0.0046875,
  },
  {
    cx: 0.03624398816047903,
    cy: 1.4376781970323376,
    cz: -0.06040664693413176,
    half: 0.0046875,
  },
  {
    cx: 0.012081329386826274,
    cy: 1.413515538258685,
    cz: -0.06040664693413176,
    half: 0.0046875,
  },
  {
    cx: 0.006040664693413085,
    cy: 1.407474873565272,
    cz: -0.05436598224071857,
    half: 0.00234375,
  },
  {
    cx: 0.04832531754730539,
    cy: 1.4014342088718585,
    cz: -0.14497595264191634,
    half: 0.01875,
  },
  {
    cx: 0.024162658773652652,
    cy: 1.4255968676455113,
    cz: -0.12081329386826362,
    half: 0.009375,
  },
  {
    cx: 0.012081329386826274,
    cy: 1.4376781970323376,
    cz: -0.13289462325509,
    half: 0.0046875,
  },
  {
    cx: 0.006040664693413086,
    cy: 1.4437188617257506,
    cz: -0.13893528794850318,
    half: 0.00234375,
  },
  {
    cx: 0.018121994080239463,
    cy: 1.4316375323389245,
    cz: -0.1268539585616768,
    half: 0.00234375,
  },
  {
    cx: 0.14497595264191634,
    cy: 1.4014342088718585,
    cz: -0.14497595264191634,
    half: 0.01875,
  },
  {
    cx: 0.09665063509461086,
    cy: 1.2564582562299424,
    cz: -0.2899519052838328,
    half: 0.0375,
  },
  {
    cx: 0.04832531754730539,
    cy: 1.304783573777248,
    cz: -0.33827722283113826,
    half: 0.01875,
  },
  {
    cx: 0.024162658773652652,
    cy: 1.2806209150035952,
    cz: -0.36243988160479096,
    half: 0.009375,
  },
  {
    cx: 0.012081329386826276,
    cy: 1.268539585616769,
    cz: -0.37452121099161734,
    half: 0.0046875,
  },
  {
    cx: 0.018121994080239463,
    cy: 1.274580250310182,
    cz: -0.3805618756850305,
    half: 0.00234375,
  },
  {
    cx: 0.14497595264191634,
    cy: 1.208132938682637,
    cz: -0.24162658773652734,
    half: 0.01875,
  },
  {
    cx: 0.14497595264191634,
    cy: 1.208132938682637,
    cz: -0.33827722283113826,
    half: 0.01875,
  },
  {
    cx: 0.12081329386826362,
    cy: 1.1839702799089842,
    cz: -0.36243988160479096,
    half: 0.009375,
  },
  {
    cx: 0.10873196448143725,
    cy: 1.171888950522158,
    cz: -0.37452121099161734,
    half: 0.0046875,
  },
  {
    cx: 0.13289462325509,
    cy: 1.171888950522158,
    cz: -0.37452121099161734,
    half: 0.0046875,
  },
  {
    cx: 0.13289462325509,
    cy: 1.1960516092958104,
    cz: -0.3503585522179646,
    half: 0.0046875,
  },
  {
    cx: 0.10873196448143725,
    cy: 1.171888950522158,
    cz: -0.3503585522179646,
    half: 0.0046875,
  },
  {
    cx: 0.2899519052838328,
    cy: 1.2564582562299424,
    cz: -0.09665063509461086,
    half: 0.0375,
  },
  {
    cx: 0.24162658773652734,
    cy: 1.208132938682637,
    cz: -0.14497595264191634,
    half: 0.01875,
  },
  {
    cx: 0.3866025403784438,
    cy: 0.3866025403784438,
    cz: -0.3866025403784438,
    half: 0.15,
  },
  {
    cx: 0.5799038105676657,
    cy: 0.19330127018922189,
    cz: -0.19330127018922189,
    half: 0.075,
  },
  {
    cx: 0.4832531754730548,
    cy: 0.28995190528383286,
    cz: -0.09665063509461091,
    half: 0.0375,
  },
  {
    cx: 0.5315784930203602,
    cy: 0.2416265877365274,
    cz: -0.1449759526419164,
    half: 0.01875,
  },
  {
    cx: 0.5074158342467074,
    cy: 0.2657892465101801,
    cz: -0.12081329386826367,
    half: 0.009375,
  },
  {
    cx: 0.49533450485988106,
    cy: 0.2778705758970065,
    cz: -0.10873196448143731,
    half: 0.0046875,
  },
  {
    cx: 0.5194971636335338,
    cy: 0.2778705758970065,
    cz: -0.13289462325509002,
    half: 0.0046875,
  },
  {
    cx: 0.525537828326947,
    cy: 0.2718299112035933,
    cz: -0.12685395856167683,
    half: 0.00234375,
  },
  {
    cx: 0.5134564989401207,
    cy: 0.2718299112035933,
    cz: -0.1389352879485032,
    half: 0.00234375,
  },
  {
    cx: 0.49533450485988106,
    cy: 0.2778705758970065,
    cz: -0.13289462325509002,
    half: 0.0046875,
  },
  {
    cx: 0.5013751695532942,
    cy: 0.2718299112035933,
    cz: -0.12685395856167683,
    half: 0.00234375,
  },
  {
    cx: 0.5074158342467074,
    cy: 0.21746392896287467,
    cz: -0.12081329386826367,
    half: 0.009375,
  },
  {
    cx: 0.49533450485988106,
    cy: 0.20538259957604832,
    cz: -0.13289462325509002,
    half: 0.0046875,
  },
  {
    cx: 0.5013751695532942,
    cy: 0.2114232642694615,
    cz: -0.12685395856167683,
    half: 0.00234375,
  },
  {
    cx: 0.49533450485988106,
    cy: 0.22954525834970102,
    cz: -0.10873196448143731,
    half: 0.0046875,
  },
  {
    cx: 0.5013751695532942,
    cy: 0.2355859230431142,
    cz: -0.10269129978802412,
    half: 0.00234375,
  },
  {
    cx: 0.4892938401664679,
    cy: 0.2355859230431142,
    cz: -0.11477262917485048,
    half: 0.00234375,
  },
  {
    cx: 0.5194971636335338,
    cy: 0.20538259957604832,
    cz: -0.10873196448143731,
    half: 0.0046875,
  },
  {
    cx: 0.525537828326947,
    cy: 0.2114232642694615,
    cz: -0.10269129978802412,
    half: 0.00234375,
  },
  {
    cx: 0.5134564989401207,
    cy: 0.19934193488263513,
    cz: -0.10269129978802412,
    half: 0.00234375,
  },
  {
    cx: 0.5194971636335338,
    cy: 0.20538259957604832,
    cz: -0.13289462325509002,
    half: 0.0046875,
  },
  {
    cx: 0.43492785792574934,
    cy: 0.3382772228311383,
    cz: -0.1449759526419164,
    half: 0.01875,
  },
  {
    cx: 0.4590905166994021,
    cy: 0.31411456405748556,
    cz: -0.12081329386826367,
    half: 0.009375,
  },
  {
    cx: 0.4711718460862285,
    cy: 0.32619589344431194,
    cz: -0.13289462325509002,
    half: 0.0046875,
  },
  {
    cx: 0.4711718460862285,
    cy: 0.32619589344431194,
    cz: -0.10873196448143731,
    half: 0.0046875,
  },
  {
    cx: 0.47721251077964166,
    cy: 0.32015522875089875,
    cz: -0.10269129978802413,
    half: 0.00234375,
  },
  {
    cx: 0.4651311813928153,
    cy: 0.32015522875089875,
    cz: -0.10269129978802413,
    half: 0.00234375,
  },
  {
    cx: 0.4651311813928153,
    cy: 0.32015522875089875,
    cz: -0.11477262917485048,
    half: 0.00234375,
  },
  {
    cx: 0.4470091873125757,
    cy: 0.32619589344431194,
    cz: -0.13289462325509002,
    half: 0.0046875,
  },
  {
    cx: 0.5315784930203602,
    cy: 0.2416265877365274,
    cz: -0.04832531754730543,
    half: 0.01875,
  },
  {
    cx: 0.5315784930203602,
    cy: 0.3382772228311383,
    cz: -0.1449759526419164,
    half: 0.01875,
  },
  {
    cx: 0.6765544456622766,
    cy: 0.09665063509461091,
    cz: -0.28995190528383286,
    half: 0.0375,
  },
  {
    cx: 0.6282291281149712,
    cy: 0.1449759526419164,
    cz: -0.3382772228311383,
    half: 0.01875,
  },
  {
    cx: 0.652391786888624,
    cy: 0.16913861141556913,
    cz: -0.3141145640574856,
    half: 0.009375,
  },
  {
    cx: 0.6403104575017976,
    cy: 0.18121994080239548,
    cz: -0.30203323467065923,
    half: 0.0046875,
  },
  {
    cx: 0.6403104575017976,
    cy: 0.15705728202874278,
    cz: -0.326195893444312,
    half: 0.0046875,
  },
  {
    cx: 0.6644731162754504,
    cy: 0.15705728202874278,
    cz: -0.326195893444312,
    half: 0.0046875,
  },
  {
    cx: 0.6584324515820372,
    cy: 0.1510166173353296,
    cz: -0.3201552287508988,
    half: 0.00234375,
  },
  {
    cx: 0.6403104575017976,
    cy: 0.18121994080239548,
    cz: -0.326195893444312,
    half: 0.0046875,
  },
  {
    cx: 0.6040664693413185,
    cy: 0.12081329386826367,
    cz: -0.3141145640574856,
    half: 0.009375,
  },
  {
    cx: 0.6161477987281448,
    cy: 0.13289462325509002,
    cz: -0.326195893444312,
    half: 0.0046875,
  },
  {
    cx: 0.622188463421558,
    cy: 0.12685395856167683,
    cz: -0.3201552287508988,
    half: 0.00234375,
  },
  {
    cx: 0.5919851399544921,
    cy: 0.13289462325509002,
    cz: -0.326195893444312,
    half: 0.0046875,
  },
  {
    cx: 0.5980258046479052,
    cy: 0.12685395856167683,
    cz: -0.3322365581377252,
    half: 0.00234375,
  },
  {
    cx: 0.5919851399544921,
    cy: 0.10873196448143731,
    cz: -0.30203323467065923,
    half: 0.0046875,
  },
  {
    cx: 0.585944475261079,
    cy: 0.10269129978802412,
    cz: -0.3080738993640724,
    half: 0.00234375,
  },
  {
    cx: 0.5980258046479052,
    cy: 0.10269129978802412,
    cz: -0.3080738993640724,
    half: 0.00234375,
  },
  {
    cx: 0.4832531754730548,
    cy: 0.09665063509461091,
    cz: -0.28995190528383286,
    half: 0.0375,
  },
  {
    cx: 0.43492785792574934,
    cy: 0.1449759526419164,
    cz: -0.3382772228311383,
    half: 0.01875,
  },
  {
    cx: 0.4590905166994021,
    cy: 0.12081329386826367,
    cz: -0.31411456405748556,
    half: 0.009375,
  },
  {
    cx: 0.4470091873125757,
    cy: 0.13289462325509002,
    cz: -0.32619589344431194,
    half: 0.0046875,
  },
  {
    cx: 0.4470091873125757,
    cy: 0.10873196448143731,
    cz: -0.3020332346706592,
    half: 0.0046875,
  },
  {
    cx: 0.4711718460862285,
    cy: 0.10873196448143731,
    cz: -0.3020332346706592,
    half: 0.0046875,
  },
  {
    cx: 0.4711718460862285,
    cy: 0.13289462325509002,
    cz: -0.3020332346706592,
    half: 0.0046875,
  },
  {
    cx: 0.47721251077964166,
    cy: 0.12685395856167683,
    cz: -0.295992569977246,
    half: 0.00234375,
  },
  {
    cx: 0.4651311813928153,
    cy: 0.12685395856167683,
    cz: -0.295992569977246,
    half: 0.00234375,
  },
  {
    cx: 0.43492785792574934,
    cy: 0.1449759526419164,
    cz: -0.2416265877365274,
    half: 0.01875,
  },
  {
    cx: 0.43492785792574934,
    cy: 0.04832531754730543,
    cz: -0.3382772228311383,
    half: 0.01875,
  },
  {
    cx: 0.45909051669940204,
    cy: 0.024162658773652687,
    cz: -0.3141145640574856,
    half: 0.009375,
  },
  {
    cx: 0.4711718460862284,
    cy: 0.03624398816047906,
    cz: -0.30203323467065923,
    half: 0.0046875,
  },
  {
    cx: 0.4772125107796416,
    cy: 0.04228465285389224,
    cz: -0.3080738993640724,
    half: 0.00234375,
  },
  {
    cx: 0.44700918731257566,
    cy: 0.03624398816047906,
    cz: -0.326195893444312,
    half: 0.0046875,
  },
  {
    cx: 0.44700918731257566,
    cy: 0.012081329386826321,
    cz: -0.326195893444312,
    half: 0.0046875,
  },
  {
    cx: 0.41076519915209664,
    cy: 0.07248797632095817,
    cz: -0.3141145640574856,
    half: 0.009375,
  },
  {
    cx: 0.39868386976527026,
    cy: 0.060406646934131815,
    cz: -0.30203323467065923,
    half: 0.0046875,
  },
  {
    cx: 0.39264320507185707,
    cy: 0.05436598224071863,
    cz: -0.29599256997724605,
    half: 0.00234375,
  },
  {
    cx: 0.422846528538923,
    cy: 0.060406646934131815,
    cz: -0.30203323467065923,
    half: 0.0046875,
  },
  {
    cx: 0.4168058638455098,
    cy: 0.05436598224071863,
    cz: -0.3080738993640724,
    half: 0.00234375,
  },
  {
    cx: 0.5315784930203602,
    cy: 0.04832531754730543,
    cz: -0.3382772228311383,
    half: 0.01875,
  },
  {
    cx: 0.5315784930203602,
    cy: 0.1449759526419164,
    cz: -0.2416265877365274,
    half: 0.01875,
  },
  {
    cx: 0.5074158342467074,
    cy: 0.16913861141556913,
    cz: -0.21746392896287467,
    half: 0.009375,
  },
  {
    cx: 0.49533450485988106,
    cy: 0.18121994080239548,
    cz: -0.22954525834970102,
    half: 0.0046875,
  },
  {
    cx: 0.49533450485988106,
    cy: 0.15705728202874278,
    cz: -0.20538259957604832,
    half: 0.0046875,
  },
  {
    cx: 0.5013751695532942,
    cy: 0.16309794672215597,
    cz: -0.2114232642694615,
    half: 0.00234375,
  },
  {
    cx: 0.4892938401664679,
    cy: 0.16309794672215597,
    cz: -0.19934193488263513,
    half: 0.00234375,
  },
  {
    cx: 0.555741151794013,
    cy: 0.16913861141556913,
    cz: -0.21746392896287467,
    half: 0.009375,
  },
  {
    cx: 0.5678224811808393,
    cy: 0.15705728202874278,
    cz: -0.20538259957604832,
    half: 0.0046875,
  },
  {
    cx: 0.5738631458742525,
    cy: 0.16309794672215597,
    cz: -0.2114232642694615,
    half: 0.00234375,
  },
  {
    cx: 0.5738631458742525,
    cy: 0.1510166173353296,
    cz: -0.2114232642694615,
    half: 0.00234375,
  },
  {
    cx: 0.5678224811808393,
    cy: 0.18121994080239548,
    cz: -0.20538259957604832,
    half: 0.0046875,
  },
  {
    cx: 0.5738631458742525,
    cy: 0.1751792761089823,
    cz: -0.2114232642694615,
    half: 0.00234375,
  },
  {
    cx: 0.5436598224071866,
    cy: 0.18121994080239548,
    cz: -0.20538259957604832,
    half: 0.0046875,
  },
  {
    cx: 0.5799038105676657,
    cy: 0.19330127018922189,
    cz: -0.5799038105676657,
    half: 0.075,
  },
  {
    cx: 0.6765544456622766,
    cy: 0.09665063509461091,
    cz: -0.6765544456622766,
    half: 0.0375,
  },
  {
    cx: 0.6282291281149712,
    cy: 0.1449759526419164,
    cz: -0.6282291281149712,
    half: 0.01875,
  },
  {
    cx: 0.724879763209582,
    cy: 0.1449759526419164,
    cz: -0.6282291281149712,
    half: 0.01875,
  },
  {
    cx: 0.7007171044359293,
    cy: 0.12081329386826369,
    cz: -0.6040664693413185,
    half: 0.009375,
  },
  {
    cx: 0.7127984338227557,
    cy: 0.10873196448143732,
    cz: -0.6161477987281448,
    half: 0.0046875,
  },
  {
    cx: 0.6886357750491029,
    cy: 0.13289462325509005,
    cz: -0.5919851399544921,
    half: 0.0046875,
  },
  {
    cx: 0.6886357750491029,
    cy: 0.13289462325509005,
    cz: -0.6161477987281448,
    half: 0.0046875,
  },
  {
    cx: 0.6825951103556898,
    cy: 0.12685395856167683,
    cz: -0.6101071340347317,
    half: 0.00234375,
  },
  {
    cx: 0.694676439742516,
    cy: 0.12685395856167683,
    cz: -0.622188463421558,
    half: 0.00234375,
  },
  {
    cx: 0.694676439742516,
    cy: 0.13893528794850327,
    cz: -0.622188463421558,
    half: 0.00234375,
  },
  {
    cx: 0.7127984338227557,
    cy: 0.13289462325509005,
    cz: -0.6161477987281448,
    half: 0.0046875,
  },
  {
    cx: 0.4832531754730548,
    cy: 0.28995190528383286,
    cz: -0.6765544456622766,
    half: 0.0375,
  },
  {
    cx: 0.5315784930203603,
    cy: 0.3382772228311383,
    cz: -0.7248797632095821,
    half: 0.01875,
  },
  {
    cx: 0.5557411517940131,
    cy: 0.362439881604791,
    cz: -0.7007171044359294,
    half: 0.009375,
  },
  {
    cx: 0.5436598224071867,
    cy: 0.3745212109916174,
    cz: -0.7127984338227558,
    half: 0.0046875,
  },
  {
    cx: 0.5497004871005998,
    cy: 0.3684805462982042,
    cz: -0.7067577691293426,
    half: 0.00234375,
  },
  {
    cx: 0.5678224811808394,
    cy: 0.3745212109916174,
    cz: -0.688635775049103,
    half: 0.0046875,
  },
  {
    cx: 0.5617818164874263,
    cy: 0.3684805462982042,
    cz: -0.6946764397425161,
    half: 0.00234375,
  },
  {
    cx: 0.6765544456622766,
    cy: 0.28995190528383286,
    cz: -0.4832531754730548,
    half: 0.0375,
  },
  {
    cx: 0.6282291281149711,
    cy: 0.2416265877365274,
    cz: -0.5315784930203603,
    half: 0.01875,
  },
  {
    cx: 0.6040664693413184,
    cy: 0.21746392896287467,
    cz: -0.5074158342467076,
    half: 0.009375,
  },
  {
    cx: 0.591985139954492,
    cy: 0.22954525834970102,
    cz: -0.5194971636335339,
    half: 0.0046875,
  },
  {
    cx: 0.591985139954492,
    cy: 0.20538259957604832,
    cz: -0.5194971636335339,
    half: 0.0046875,
  },
  {
    cx: 0.591985139954492,
    cy: 0.22954525834970102,
    cz: -0.4953345048598812,
    half: 0.0046875,
  },
  {
    cx: 0.5859444752610788,
    cy: 0.23558592304311424,
    cz: -0.5013751695532943,
    half: 0.00234375,
  },
  {
    cx: 0.19330127018922189,
    cy: 0.5799038105676657,
    cz: -0.5799038105676657,
    half: 0.075,
  },
  {
    cx: 0.28995190528383286,
    cy: 0.4832531754730548,
    cz: -0.4832531754730548,
    half: 0.0375,
  },
  {
    cx: 0.3382772228311383,
    cy: 0.5315784930203603,
    cz: -0.43492785792574934,
    half: 0.01875,
  },
  {
    cx: 0.3382772228311383,
    cy: 0.43492785792574934,
    cz: -0.5315784930203603,
    half: 0.01875,
  },
  {
    cx: 0.3141145640574856,
    cy: 0.45909051669940204,
    cz: -0.5074158342467076,
    half: 0.009375,
  },
  {
    cx: 0.30203323467065923,
    cy: 0.4711718460862284,
    cz: -0.4953345048598812,
    half: 0.0046875,
  },
  {
    cx: 0.326195893444312,
    cy: 0.4711718460862284,
    cz: -0.5194971636335339,
    half: 0.0046875,
  },
  {
    cx: 0.3322365581377252,
    cy: 0.4772125107796416,
    cz: -0.5134564989401208,
    half: 0.00234375,
  },
  {
    cx: 0.30203323467065923,
    cy: 0.44700918731257566,
    cz: -0.5194971636335339,
    half: 0.0046875,
  },
  {
    cx: 0.29599256997724605,
    cy: 0.4409685226191625,
    cz: -0.5255378283269471,
    half: 0.00234375,
  },
  {
    cx: 0.326195893444312,
    cy: 0.4711718460862284,
    cz: -0.4953345048598812,
    half: 0.0046875,
  },
  {
    cx: 0.362439881604791,
    cy: 0.45909051669940204,
    cz: -0.5074158342467076,
    half: 0.009375,
  },
  {
    cx: 0.35035855221796464,
    cy: 0.44700918731257566,
    cz: -0.4953345048598812,
    half: 0.0046875,
  },
  {
    cx: 0.35035855221796464,
    cy: 0.44700918731257566,
    cz: -0.5194971636335339,
    half: 0.0046875,
  },
  {
    cx: 0.3141145640574856,
    cy: 0.45909051669940204,
    cz: -0.5557411517940131,
    half: 0.009375,
  },
  {
    cx: 0.326195893444312,
    cy: 0.4711718460862284,
    cz: -0.5436598224071867,
    half: 0.0046875,
  },
  {
    cx: 0.3322365581377252,
    cy: 0.4772125107796416,
    cz: -0.5497004871005998,
    half: 0.00234375,
  },
  {
    cx: 0.3322365581377252,
    cy: 0.46513118139281523,
    cz: -0.5376191577137736,
    half: 0.00234375,
  },
  {
    cx: 0.326195893444312,
    cy: 0.4711718460862284,
    cz: -0.5678224811808394,
    half: 0.0046875,
  },
  {
    cx: 0.362439881604791,
    cy: 0.41076519915209664,
    cz: -0.5557411517940131,
    half: 0.009375,
  },
  {
    cx: 0.3745212109916174,
    cy: 0.39868386976527026,
    cz: -0.5436598224071867,
    half: 0.0046875,
  },
  {
    cx: 0.3684805462982042,
    cy: 0.40472453445868345,
    cz: -0.5497004871005998,
    half: 0.00234375,
  },
  {
    cx: 0.35035855221796464,
    cy: 0.422846528538923,
    cz: -0.5678224811808394,
    half: 0.0046875,
  },
  {
    cx: 0.35035855221796464,
    cy: 0.39868386976527026,
    cz: -0.5678224811808394,
    half: 0.0046875,
  },
  {
    cx: 0.34431788752455145,
    cy: 0.40472453445868345,
    cz: -0.5738631458742526,
    half: 0.00234375,
  },
  {
    cx: 0.34431788752455145,
    cy: 0.39264320507185707,
    cz: -0.5738631458742526,
    half: 0.00234375,
  },
  {
    cx: 0.3382772228311383,
    cy: 0.5315784930203603,
    cz: -0.5315784930203603,
    half: 0.01875,
  },
  {
    cx: 0.09665063509461091,
    cy: 0.4832531754730548,
    cz: -0.6765544456622766,
    half: 0.0375,
  },
  {
    cx: 0.1449759526419164,
    cy: 0.5315784930203602,
    cz: -0.6282291281149712,
    half: 0.01875,
  },
  {
    cx: 0.16913861141556913,
    cy: 0.555741151794013,
    cz: -0.652391786888624,
    half: 0.009375,
  },
  {
    cx: 0.15705728202874278,
    cy: 0.5436598224071866,
    cz: -0.6403104575017976,
    half: 0.0046875,
  },
  {
    cx: 0.18121994080239548,
    cy: 0.5436598224071866,
    cz: -0.6644731162754504,
    half: 0.0046875,
  },
  {
    cx: 0.1872606054958087,
    cy: 0.5497004871005997,
    cz: -0.6584324515820372,
    half: 0.00234375,
  },
  {
    cx: 0.04832531754730543,
    cy: 0.43492785792574934,
    cz: -0.724879763209582,
    half: 0.01875,
  },
  {
    cx: 0.07248797632095817,
    cy: 0.41076519915209664,
    cz: -0.7490424219832348,
    half: 0.009375,
  },
  {
    cx: 0.060406646934131815,
    cy: 0.422846528538923,
    cz: -0.7369610925964084,
    half: 0.0046875,
  },
  {
    cx: 0.08456930570778454,
    cy: 0.39868386976527026,
    cz: -0.7369610925964084,
    half: 0.0046875,
  },
  {
    cx: 0.07852864101437135,
    cy: 0.40472453445868345,
    cz: -0.7309204279029953,
    half: 0.00234375,
  },
  {
    cx: 0.08456930570778454,
    cy: 0.422846528538923,
    cz: -0.7611237513700612,
    half: 0.0046875,
  },
  {
    cx: 0.024162658773652694,
    cy: 0.45909051669940204,
    cz: -0.7007171044359293,
    half: 0.009375,
  },
  {
    cx: 0.036243988160479065,
    cy: 0.44700918731257566,
    cz: -0.6886357750491029,
    half: 0.0046875,
  },
  {
    cx: 0.03020332346706588,
    cy: 0.4409685226191625,
    cz: -0.6825951103556898,
    half: 0.00234375,
  },
  {
    cx: 0.03020332346706588,
    cy: 0.4409685226191625,
    cz: -0.694676439742516,
    half: 0.00234375,
  },
  {
    cx: 0.036243988160479065,
    cy: 0.4711718460862284,
    cz: -0.6886357750491029,
    half: 0.0046875,
  },
  {
    cx: 0.03020332346706588,
    cy: 0.4772125107796416,
    cz: -0.6825951103556898,
    half: 0.00234375,
  },
  {
    cx: 0.024162658773652694,
    cy: 0.41076519915209664,
    cz: -0.7007171044359293,
    half: 0.009375,
  },
  {
    cx: 0.012081329386826328,
    cy: 0.39868386976527026,
    cz: -0.7127984338227557,
    half: 0.0046875,
  },
  {
    cx: 0.018121994080239515,
    cy: 0.40472453445868345,
    cz: -0.7188390985161688,
    half: 0.00234375,
  },
  {
    cx: 0.012081329386826328,
    cy: 0.422846528538923,
    cz: -0.7127984338227557,
    half: 0.0046875,
  },
  {
    cx: 0.018121994080239515,
    cy: 0.4168058638455098,
    cz: -0.7067577691293425,
    half: 0.00234375,
  },
  {
    cx: 0.036243988160479065,
    cy: 0.39868386976527026,
    cz: -0.6886357750491029,
    half: 0.0046875,
  },
  {
    cx: 0.04228465285389225,
    cy: 0.39264320507185707,
    cz: -0.6825951103556898,
    half: 0.00234375,
  },
  {
    cx: 0.1449759526419164,
    cy: 0.5315784930203602,
    cz: -0.724879763209582,
    half: 0.01875,
  },
  {
    cx: 0.16913861141556913,
    cy: 0.5074158342467074,
    cz: -0.7490424219832348,
    half: 0.009375,
  },
  {
    cx: 0.15705728202874278,
    cy: 0.49533450485988106,
    cz: -0.7369610925964084,
    half: 0.0046875,
  },
  {
    cx: 0.18121994080239548,
    cy: 0.5194971636335338,
    cz: -0.7611237513700612,
    half: 0.0046875,
  },
  {
    cx: 0.1872606054958087,
    cy: 0.5134564989401207,
    cz: -0.755083086676648,
    half: 0.00234375,
  },
  {
    cx: 0.17517927610898226,
    cy: 0.5134564989401207,
    cz: -0.7671644160634743,
    half: 0.00234375,
  },
  {
    cx: 0.16913861141556913,
    cy: 0.555741151794013,
    cz: -0.7007171044359293,
    half: 0.009375,
  },
  {
    cx: 0.15705728202874278,
    cy: 0.5436598224071866,
    cz: -0.7127984338227557,
    half: 0.0046875,
  },
  {
    cx: 0.163097946722156,
    cy: 0.5497004871005997,
    cz: -0.7067577691293425,
    half: 0.00234375,
  },
  {
    cx: 0.18121994080239548,
    cy: 0.5678224811808393,
    cz: -0.6886357750491029,
    half: 0.0046875,
  },
  {
    cx: 0.38660254037844377,
    cy: 0.38660254037844377,
    cz: -1.1598076211353314,
    half: 0.15,
  },
  {
    cx: 0.19330127018922183,
    cy: 0.5799038105676657,
    cz: -0.9665063509461096,
    half: 0.075,
  },
  {
    cx: 0.09665063509461086,
    cy: 0.6765544456622766,
    cz: -1.0631569860407204,
    half: 0.0375,
  },
  {
    cx: 0.04832531754730539,
    cy: 0.724879763209582,
    cz: -1.111482303588026,
    half: 0.01875,
  },
  {
    cx: 0.2899519052838328,
    cy: 0.6765544456622766,
    cz: -1.0631569860407204,
    half: 0.0375,
  },
  {
    cx: 0.19330127018922183,
    cy: 0.19330127018922183,
    cz: -0.9665063509461096,
    half: 0.075,
  },
  {
    cx: 0.09665063509461086,
    cy: 0.2899519052838328,
    cz: -1.0631569860407204,
    half: 0.0375,
  },
  {
    cx: 0.14497595264191634,
    cy: 0.24162658773652734,
    cz: -1.111482303588026,
    half: 0.01875,
  },
  {
    cx: 0.16913861141556907,
    cy: 0.21746392896287461,
    cz: -1.1356449623616787,
    half: 0.009375,
  },
  {
    cx: 0.1570572820287427,
    cy: 0.20538259957604824,
    cz: -1.1235636329748524,
    half: 0.0046875,
  },
  {
    cx: 0.16309794672215588,
    cy: 0.19934193488263505,
    cz: -1.1296042976682654,
    half: 0.00234375,
  },
  {
    cx: 0.18121994080239545,
    cy: 0.229545258349701,
    cz: -1.147726291748505,
    half: 0.0046875,
  },
  {
    cx: 0.2899519052838328,
    cy: 0.2899519052838328,
    cz: -0.8698557158514987,
    half: 0.0375,
  },
  {
    cx: 0.5799038105676657,
    cy: 0.5799038105676657,
    cz: -0.9665063509461096,
    half: 0.075,
  },
  {
    cx: 0.6765544456622766,
    cy: 0.6765544456622766,
    cz: -0.8698557158514987,
    half: 0.0375,
  },
  {
    cx: 0.38660254037844377,
    cy: 1.1598076211353314,
    cz: -1.1598076211353314,
    half: 0.15,
  },
  {
    cx: 0.19330127018922183,
    cy: 1.3531088913245533,
    cz: -1.3531088913245533,
    half: 0.075,
  },
  {
    cx: 0.2899519052838328,
    cy: 1.2564582562299424,
    cz: -1.449759526419164,
    half: 0.0375,
  },
  {
    cx: 0.5799038105676657,
    cy: 0.9665063509461096,
    cz: -1.3531088913245533,
    half: 0.075,
  },
  {
    cx: 0.4832531754730548,
    cy: 0.8698557158514987,
    cz: -1.4497595264191643,
    half: 0.0375,
  },
  {
    cx: 0.43492785792574934,
    cy: 0.9181810333988041,
    cz: -1.4980848439664698,
    half: 0.01875,
  },
  {
    cx: 0.5315784930203602,
    cy: 0.8215303983041933,
    cz: -1.4014342088718588,
    half: 0.01875,
  },
  {
    cx: 0.555741151794013,
    cy: 0.845693057077846,
    cz: -1.4255968676455115,
    half: 0.009375,
  },
  {
    cx: 0.5678224811808393,
    cy: 0.8577743864646724,
    cz: -1.4376781970323378,
    half: 0.0046875,
  },
  {
    cx: 0.5738631458742525,
    cy: 0.8638150511580855,
    cz: -1.443718861725751,
    half: 0.00234375,
  },
  {
    cx: 0.5436598224071866,
    cy: 0.8577743864646724,
    cz: -1.4376781970323378,
    half: 0.0046875,
  },
  {
    cx: 0.43492785792574934,
    cy: 0.8215303983041933,
    cz: -1.4980848439664698,
    half: 0.01875,
  },
  {
    cx: 0.43492785792574934,
    cy: 0.8215303983041933,
    cz: -1.4014342088718588,
    half: 0.01875,
  },
  {
    cx: -0.7732050807568877,
    cy: -0.7732050807568877,
    cz: -0.7732050807568877,
    half: 0.3,
  },
  {
    cx: -0.7732050807568877,
    cy: -0.7732050807568877,
    cz: 0.7732050807568877,
    half: 0.3,
  },
  {
    cx: -1.1598076211353314,
    cy: -1.1598076211353314,
    cz: 1.1598076211353314,
    half: 0.15,
  },
  {
    cx: -1.3531088913245533,
    cy: -1.3531088913245533,
    cz: 0.9665063509461096,
    half: 0.075,
  },
  {
    cx: -1.2564582562299422,
    cy: -1.2564582562299422,
    cz: 1.0631569860407206,
    half: 0.0375,
  },
  {
    cx: -1.2081329386826367,
    cy: -1.3047835737772477,
    cz: 1.014831668493415,
    half: 0.01875,
  },
  {
    cx: -1.183970279908984,
    cy: -1.3289462325509005,
    cz: 0.9906690097197624,
    half: 0.009375,
  },
  {
    cx: -1.3047835737772477,
    cy: -1.2081329386826367,
    cz: 1.1114823035880261,
    half: 0.01875,
  },
  {
    cx: -1.2564582562299422,
    cy: -1.4497595264191643,
    cz: 1.0631569860407206,
    half: 0.0375,
  },
  {
    cx: -1.3047835737772477,
    cy: -1.4980848439664698,
    cz: 1.1114823035880261,
    half: 0.01875,
  },
  {
    cx: -1.280620915003595,
    cy: -1.473922185192817,
    cz: 1.0873196448143734,
    half: 0.009375,
  },
  {
    cx: -1.2685395856167687,
    cy: -1.4618408558059908,
    cz: 1.075238315427547,
    half: 0.0046875,
  },
  {
    cx: -1.2624989209233555,
    cy: -1.4558001911125775,
    cz: 1.0812789801209604,
    half: 0.00234375,
  },
  {
    cx: -1.274580250310182,
    cy: -1.4558001911125775,
    cz: 1.0812789801209604,
    half: 0.00234375,
  },
  {
    cx: -1.2927022443904213,
    cy: -1.4860035145796433,
    cz: 1.0994009742011996,
    half: 0.0046875,
  },
  {
    cx: -1.3531088913245533,
    cy: -1.3531088913245533,
    cz: 1.3531088913245533,
    half: 0.075,
  },
  {
    cx: -0.9665063509461096,
    cy: -0.9665063509461096,
    cz: 1.3531088913245533,
    half: 0.075,
  },
  {
    cx: -0.8698557158514987,
    cy: -0.8698557158514987,
    cz: 1.2564582562299422,
    half: 0.0375,
  },
  {
    cx: -0.8698557158514987,
    cy: -1.0631569860407206,
    cz: 1.4497595264191643,
    half: 0.0375,
  },
  {
    cx: -1.1598076211353314,
    cy: -0.38660254037844377,
    cz: 0.38660254037844377,
    half: 0.15,
  },
  {
    cx: -0.3866025403784438,
    cy: -0.3866025403784438,
    cz: 0.3866025403784438,
    half: 0.15,
  },
  {
    cx: -0.5799038105676657,
    cy: -0.19330127018922189,
    cz: 0.19330127018922189,
    half: 0.075,
  },
  {
    cx: -0.4832531754730548,
    cy: -0.09665063509461091,
    cz: 0.09665063509461091,
    half: 0.0375,
  },
  {
    cx: -0.5315784930203602,
    cy: -0.04832531754730543,
    cz: 0.04832531754730543,
    half: 0.01875,
  },
  {
    cx: -0.555741151794013,
    cy: -0.07248797632095817,
    cz: 0.07248797632095817,
    half: 0.009375,
  },
  {
    cx: -0.5678224811808393,
    cy: -0.08456930570778454,
    cz: 0.06040664693413181,
    half: 0.0046875,
  },
  {
    cx: -0.5617818164874262,
    cy: -0.07852864101437135,
    cz: 0.066447311627545,
    half: 0.00234375,
  },
  {
    cx: -0.5738631458742525,
    cy: -0.07852864101437135,
    cz: 0.05436598224071862,
    half: 0.00234375,
  },
  {
    cx: -0.5678224811808393,
    cy: -0.06040664693413181,
    cz: 0.08456930570778454,
    half: 0.0046875,
  },
  {
    cx: -0.5617818164874262,
    cy: -0.066447311627545,
    cz: 0.09060997040119773,
    half: 0.00234375,
  },
  {
    cx: -0.43492785792574934,
    cy: -0.04832531754730543,
    cz: 0.04832531754730543,
    half: 0.01875,
  },
  {
    cx: -0.45909051669940204,
    cy: -0.024162658773652687,
    cz: 0.024162658773652687,
    half: 0.009375,
  },
  {
    cx: -0.44700918731257566,
    cy: -0.03624398816047906,
    cz: 0.01208132938682632,
    half: 0.0046875,
  },
  {
    cx: -0.41076519915209664,
    cy: -0.024162658773652687,
    cz: 0.07248797632095817,
    half: 0.009375,
  },
  {
    cx: -0.39868386976527026,
    cy: -0.01208132938682632,
    cz: 0.08456930570778454,
    half: 0.0046875,
  },
  {
    cx: -0.39868386976527026,
    cy: -0.03624398816047906,
    cz: 0.06040664693413181,
    half: 0.0046875,
  },
  {
    cx: -0.5315784930203602,
    cy: -0.1449759526419164,
    cz: 0.1449759526419164,
    half: 0.01875,
  },
  {
    cx: -0.5074158342467074,
    cy: -0.12081329386826367,
    cz: 0.12081329386826367,
    half: 0.009375,
  },
  {
    cx: -0.5194971636335338,
    cy: -0.13289462325509002,
    cz: 0.13289462325509002,
    half: 0.0046875,
  },
  {
    cx: -0.525537828326947,
    cy: -0.12685395856167683,
    cz: 0.1389352879485032,
    half: 0.00234375,
  },
  {
    cx: -0.525537828326947,
    cy: -0.12685395856167683,
    cz: 0.12685395856167683,
    half: 0.00234375,
  },
  {
    cx: -0.5194971636335338,
    cy: -0.13289462325509002,
    cz: 0.10873196448143731,
    half: 0.0046875,
  },
  {
    cx: -0.49533450485988106,
    cy: -0.13289462325509002,
    cz: 0.13289462325509002,
    half: 0.0046875,
  },
  {
    cx: -0.4892938401664679,
    cy: -0.1389352879485032,
    cz: 0.12685395856167683,
    half: 0.00234375,
  },
  {
    cx: -0.6765544456622766,
    cy: -0.09665063509461091,
    cz: 0.09665063509461091,
    half: 0.0375,
  },
  {
    cx: -0.6282291281149712,
    cy: -0.04832531754730543,
    cz: 0.04832531754730543,
    half: 0.01875,
  },
  {
    cx: -0.6040664693413185,
    cy: -0.024162658773652694,
    cz: 0.07248797632095817,
    half: 0.009375,
  },
  {
    cx: -0.5919851399544921,
    cy: -0.036243988160479065,
    cz: 0.08456930570778454,
    half: 0.0046875,
  },
  {
    cx: -0.5980258046479052,
    cy: -0.042284652853892254,
    cz: 0.07852864101437135,
    half: 0.00234375,
  },
  {
    cx: -0.724879763209582,
    cy: -0.04832531754730543,
    cz: 0.1449759526419164,
    half: 0.01875,
  },
  {
    cx: -0.7007171044359293,
    cy: -0.07248797632095817,
    cz: 0.16913861141556913,
    half: 0.009375,
  },
  {
    cx: -0.7127984338227557,
    cy: -0.08456930570778454,
    cz: 0.18121994080239548,
    half: 0.0046875,
  },
  {
    cx: -0.7188390985161688,
    cy: -0.09060997040119773,
    cz: 0.1751792761089823,
    half: 0.00234375,
  },
  {
    cx: -0.7127984338227557,
    cy: -0.08456930570778454,
    cz: 0.15705728202874278,
    half: 0.0046875,
  },
  {
    cx: -0.7188390985161688,
    cy: -0.07852864101437135,
    cz: 0.1510166173353296,
    half: 0.00234375,
  },
  {
    cx: -0.6886357750491029,
    cy: -0.06040664693413181,
    cz: 0.18121994080239548,
    half: 0.0046875,
  },
  {
    cx: -0.724879763209582,
    cy: -0.04832531754730543,
    cz: 0.04832531754730543,
    half: 0.01875,
  },
  {
    cx: -0.7490424219832348,
    cy: -0.07248797632095817,
    cz: 0.07248797632095817,
    half: 0.009375,
  },
  {
    cx: -0.7611237513700612,
    cy: -0.06040664693413181,
    cz: 0.08456930570778454,
    half: 0.0046875,
  },
  {
    cx: -0.7671644160634743,
    cy: -0.05436598224071862,
    cz: 0.09060997040119773,
    half: 0.00234375,
  },
  {
    cx: -0.755083086676648,
    cy: -0.05436598224071862,
    cz: 0.07852864101437135,
    half: 0.00234375,
  },
  {
    cx: -0.7369610925964084,
    cy: -0.08456930570778454,
    cz: 0.08456930570778454,
    half: 0.0046875,
  },
  {
    cx: -0.7430017572898215,
    cy: -0.07852864101437135,
    cz: 0.09060997040119773,
    half: 0.00234375,
  },
  {
    cx: -0.7611237513700612,
    cy: -0.06040664693413181,
    cz: 0.06040664693413181,
    half: 0.0046875,
  },
  {
    cx: -0.7671644160634743,
    cy: -0.05436598224071862,
    cz: 0.066447311627545,
    half: 0.00234375,
  },
  {
    cx: -0.7671644160634743,
    cy: -0.066447311627545,
    cz: 0.05436598224071862,
    half: 0.00234375,
  },
  {
    cx: -0.6282291281149712,
    cy: -0.04832531754730543,
    cz: 0.1449759526419164,
    half: 0.01875,
  },
  {
    cx: -0.652391786888624,
    cy: -0.024162658773652694,
    cz: 0.16913861141556913,
    half: 0.009375,
  },
  {
    cx: -0.6403104575017976,
    cy: -0.012081329386826326,
    cz: 0.18121994080239548,
    half: 0.0046875,
  },
  {
    cx: -0.6342697928083845,
    cy: -0.006040664693413138,
    cz: 0.1751792761089823,
    half: 0.00234375,
  },
  {
    cx: -0.6644731162754504,
    cy: -0.036243988160479065,
    cz: 0.15705728202874278,
    half: 0.0046875,
  },
  {
    cx: -0.6705137809688635,
    cy: -0.03020332346706588,
    cz: 0.1510166173353296,
    half: 0.00234375,
  },
  {
    cx: -0.6705137809688635,
    cy: -0.04228465285389225,
    cz: 0.1510166173353296,
    half: 0.00234375,
  },
  {
    cx: -0.6644731162754504,
    cy: -0.036243988160479065,
    cz: 0.18121994080239548,
    half: 0.0046875,
  },
  {
    cx: -0.6644731162754504,
    cy: -0.012081329386826326,
    cz: 0.15705728202874278,
    half: 0.0046875,
  },
  {
    cx: -0.5799038105676657,
    cy: -0.5799038105676657,
    cz: 0.5799038105676657,
    half: 0.075,
  },
  {
    cx: -0.4832531754730548,
    cy: -0.4832531754730548,
    cz: 0.4832531754730548,
    half: 0.0375,
  },
  {
    cx: -0.4832531754730548,
    cy: -0.4832531754730548,
    cz: 0.6765544456622766,
    half: 0.0375,
  },
  {
    cx: -0.43492785792574934,
    cy: -0.5315784930203603,
    cz: 0.7248797632095821,
    half: 0.01875,
  },
  {
    cx: -0.45909051669940204,
    cy: -0.5074158342467076,
    cz: 0.7007171044359294,
    half: 0.009375,
  },
  {
    cx: -0.44700918731257566,
    cy: -0.5194971636335339,
    cz: 0.7127984338227558,
    half: 0.0046875,
  },
  {
    cx: -0.4409685226191625,
    cy: -0.5134564989401208,
    cz: 0.7188390985161689,
    half: 0.00234375,
  },
  {
    cx: -0.4711718460862284,
    cy: -0.5194971636335339,
    cz: 0.688635775049103,
    half: 0.0046875,
  },
  {
    cx: -0.4772125107796416,
    cy: -0.5134564989401208,
    cz: 0.6946764397425161,
    half: 0.00234375,
  },
  {
    cx: -0.4711718460862284,
    cy: -0.5194971636335339,
    cz: 0.7127984338227558,
    half: 0.0046875,
  },
  {
    cx: -0.44700918731257566,
    cy: -0.5194971636335339,
    cz: 0.688635775049103,
    half: 0.0046875,
  },
  {
    cx: -0.45304985200598885,
    cy: -0.5255378283269471,
    cz: 0.6946764397425161,
    half: 0.00234375,
  },
  {
    cx: -0.45304985200598885,
    cy: -0.5134564989401208,
    cz: 0.6946764397425161,
    half: 0.00234375,
  },
  {
    cx: -0.41076519915209664,
    cy: -0.5074158342467076,
    cz: 0.7007171044359294,
    half: 0.009375,
  },
  {
    cx: -0.422846528538923,
    cy: -0.5194971636335339,
    cz: 0.7127984338227558,
    half: 0.0046875,
  },
  {
    cx: -0.4288871932323362,
    cy: -0.5134564989401208,
    cz: 0.7067577691293426,
    half: 0.00234375,
  },
  {
    cx: -0.422846528538923,
    cy: -0.4953345048598812,
    cz: 0.7127984338227558,
    half: 0.0046875,
  },
  {
    cx: -0.5315784930203603,
    cy: -0.43492785792574934,
    cz: 0.6282291281149711,
    half: 0.01875,
  },
  {
    cx: -0.4832531754730548,
    cy: -0.6765544456622766,
    cz: 0.4832531754730548,
    half: 0.0375,
  },
  {
    cx: -0.43492785792574934,
    cy: -0.7248797632095821,
    cz: 0.5315784930203603,
    half: 0.01875,
  },
  {
    cx: -0.6765544456622766,
    cy: -0.4832531754730548,
    cz: 0.4832531754730548,
    half: 0.0375,
  },
  {
    cx: -0.7248797632095821,
    cy: -0.5315784930203603,
    cz: 0.43492785792574934,
    half: 0.01875,
  },
  {
    cx: -1.1598076211353314,
    cy: -1.1598076211353314,
    cz: 0.38660254037844377,
    half: 0.15,
  },
  {
    cx: -1.3531088913245533,
    cy: -0.9665063509461096,
    cz: 0.5799038105676657,
    half: 0.075,
  },
  {
    cx: -1.2564582562299422,
    cy: -0.8698557158514987,
    cz: 0.4832531754730548,
    half: 0.0375,
  },
  {
    cx: -0.9665063509461096,
    cy: -0.9665063509461096,
    cz: 0.5799038105676657,
    half: 0.075,
  },
  {
    cx: -0.8698557158514987,
    cy: -0.8698557158514987,
    cz: 0.6765544456622766,
    half: 0.0375,
  },
  {
    cx: -0.8215303983041932,
    cy: -0.9181810333988042,
    cz: 0.6282291281149711,
    half: 0.01875,
  },
  {
    cx: -0.7973677395305404,
    cy: -0.942343692172457,
    cz: 0.6040664693413184,
    half: 0.009375,
  },
  {
    cx: -0.785286410143714,
    cy: -0.9544250215592833,
    cz: 0.591985139954492,
    half: 0.0046875,
  },
  {
    cx: -0.8094490689173668,
    cy: -0.9302623627856306,
    cz: 0.6161477987281447,
    half: 0.0046875,
  },
  {
    cx: -0.8034084042239537,
    cy: -0.9242216980922174,
    cz: 0.6221884634215579,
    half: 0.00234375,
  },
  {
    cx: -0.8698557158514987,
    cy: -1.0631569860407206,
    cz: 0.4832531754730548,
    half: 0.0375,
  },
  {
    cx: -0.8215303983041933,
    cy: -1.014831668493415,
    cz: 0.43492785792574934,
    half: 0.01875,
  },
  {
    cx: -0.8215303983041933,
    cy: -1.1114823035880261,
    cz: 0.5315784930203602,
    half: 0.01875,
  },
  {
    cx: 0.7732050807568877,
    cy: -0.7732050807568877,
    cz: 0.7732050807568877,
    half: 0.3,
  },
  {
    cx: 0.38660254037844377,
    cy: -1.1598076211353314,
    cz: 1.1598076211353314,
    half: 0.15,
  },
  {
    cx: 0.19330127018922183,
    cy: -1.3531088913245533,
    cz: 0.9665063509461096,
    half: 0.075,
  },
  {
    cx: 0.2899519052838328,
    cy: -1.2564582562299424,
    cz: 1.0631569860407204,
    half: 0.0375,
  },
  {
    cx: 0.09665063509461086,
    cy: -1.449759526419164,
    cz: 1.0631569860407204,
    half: 0.0375,
  },
  {
    cx: 0.048325317547305395,
    cy: -1.4014342088718585,
    cz: 1.111482303588026,
    half: 0.01875,
  },
  {
    cx: 0.048325317547305395,
    cy: -1.4980848439664696,
    cz: 1.0148316684934149,
    half: 0.01875,
  },
  {
    cx: 0.07248797632095813,
    cy: -1.5222475027401223,
    cz: 0.9906690097197621,
    half: 0.009375,
  },
  {
    cx: 0.0845693057077845,
    cy: -1.5343288321269486,
    cz: 0.9785876803329357,
    half: 0.0046875,
  },
  {
    cx: 0.09060997040119768,
    cy: -1.5403694968203618,
    cz: 0.9846283450263489,
    half: 0.00234375,
  },
  {
    cx: 0.08456930570778451,
    cy: -1.5343288321269486,
    cz: 1.0027503391065884,
    half: 0.0046875,
  },
  {
    cx: 0.07852864101437132,
    cy: -1.5282881674335353,
    cz: 0.9967096744131753,
    half: 0.00234375,
  },
  {
    cx: 0.06040664693413176,
    cy: -1.510166173353296,
    cz: 0.9785876803329357,
    half: 0.0046875,
  },
  {
    cx: 0.06644731162754496,
    cy: -1.5162068380467093,
    cz: 0.9846283450263489,
    half: 0.00234375,
  },
  {
    cx: 0.06040664693413176,
    cy: -1.5343288321269486,
    cz: 0.9785876803329357,
    half: 0.0046875,
  },
  {
    cx: 0.05436598224071857,
    cy: -1.5403694968203618,
    cz: 0.9846283450263489,
    half: 0.00234375,
  },
  {
    cx: 0.2899519052838328,
    cy: -1.449759526419164,
    cz: 1.0631569860407204,
    half: 0.0375,
  },
  {
    cx: 0.24162658773652737,
    cy: -1.4980848439664696,
    cz: 1.0148316684934149,
    half: 0.01875,
  },
  {
    cx: 0.24162658773652737,
    cy: -1.4980848439664696,
    cz: 1.111482303588026,
    half: 0.01875,
  },
  {
    cx: 0.19330127018922183,
    cy: -0.9665063509461096,
    cz: 1.3531088913245533,
    half: 0.075,
  },
  {
    cx: 0.3866025403784438,
    cy: -0.3866025403784438,
    cz: 0.3866025403784438,
    half: 0.15,
  },
  {
    cx: 0.19330127018922189,
    cy: -0.5799038105676657,
    cz: 0.19330127018922189,
    half: 0.075,
  },
  {
    cx: 0.09665063509461091,
    cy: -0.4832531754730548,
    cz: 0.09665063509461091,
    half: 0.0375,
  },
  {
    cx: 0.1449759526419164,
    cy: -0.5315784930203602,
    cz: 0.1449759526419164,
    half: 0.01875,
  },
  {
    cx: 0.16913861141556913,
    cy: -0.5074158342467074,
    cz: 0.12081329386826367,
    half: 0.009375,
  },
  {
    cx: 0.18121994080239548,
    cy: -0.49533450485988106,
    cz: 0.10873196448143731,
    half: 0.0046875,
  },
  {
    cx: 0.15705728202874278,
    cy: -0.49533450485988106,
    cz: 0.13289462325509002,
    half: 0.0046875,
  },
  {
    cx: 0.1510166173353296,
    cy: -0.4892938401664679,
    cz: 0.1389352879485032,
    half: 0.00234375,
  },
  {
    cx: 0.16309794672215597,
    cy: -0.4892938401664679,
    cz: 0.1389352879485032,
    half: 0.00234375,
  },
  {
    cx: 0.18121994080239548,
    cy: -0.49533450485988106,
    cz: 0.13289462325509002,
    half: 0.0046875,
  },
  {
    cx: 0.1751792761089823,
    cy: -0.4892938401664679,
    cz: 0.12685395856167683,
    half: 0.00234375,
  },
  {
    cx: 0.18726060549580867,
    cy: -0.5013751695532942,
    cz: 0.1389352879485032,
    half: 0.00234375,
  },
  {
    cx: 0.09665063509461091,
    cy: -0.6765544456622766,
    cz: 0.28995190528383286,
    half: 0.0375,
  },
  {
    cx: 0.04832531754730543,
    cy: -0.724879763209582,
    cz: 0.2416265877365274,
    half: 0.01875,
  },
  {
    cx: 0.07248797632095817,
    cy: -0.7490424219832348,
    cz: 0.21746392896287467,
    half: 0.009375,
  },
  {
    cx: 0.08456930570778454,
    cy: -0.7369610925964084,
    cz: 0.22954525834970102,
    half: 0.0046875,
  },
  {
    cx: 0.024162658773652694,
    cy: -0.7490424219832348,
    cz: 0.2657892465101801,
    half: 0.009375,
  },
  {
    cx: 0.012081329386826328,
    cy: -0.7611237513700612,
    cz: 0.2537079171233537,
    half: 0.0046875,
  },
  {
    cx: 0.012081329386826328,
    cy: -0.7369610925964084,
    cz: 0.2778705758970065,
    half: 0.0046875,
  },
  {
    cx: 0.018121994080239515,
    cy: -0.7309204279029953,
    cz: 0.2718299112035933,
    half: 0.00234375,
  },
  {
    cx: 0.018121994080239515,
    cy: -0.7430017572898215,
    cz: 0.2718299112035933,
    half: 0.00234375,
  },
  {
    cx: 0.1449759526419164,
    cy: -0.724879763209582,
    cz: 0.2416265877365274,
    half: 0.01875,
  },
  {
    cx: 0.12081329386826367,
    cy: -0.7490424219832348,
    cz: 0.2657892465101801,
    half: 0.009375,
  },
  {
    cx: 0.10873196448143731,
    cy: -0.7611237513700612,
    cz: 0.2778705758970065,
    half: 0.0046875,
  },
  {
    cx: 0.10873196448143731,
    cy: -0.7369610925964084,
    cz: 0.2537079171233537,
    half: 0.0046875,
  },
  {
    cx: 0.1147726291748505,
    cy: -0.7309204279029953,
    cz: 0.24766725242994053,
    half: 0.00234375,
  },
  {
    cx: 0.5799038105676657,
    cy: -0.5799038105676657,
    cz: 0.5799038105676657,
    half: 0.075,
  },
  {
    cx: 0.4832531754730548,
    cy: -0.6765544456622766,
    cz: 0.4832531754730548,
    half: 0.0375,
  },
  {
    cx: 0.43492785792574934,
    cy: -0.6282291281149711,
    cz: 0.43492785792574934,
    half: 0.01875,
  },
  {
    cx: 0.6765544456622766,
    cy: -0.4832531754730548,
    cz: 0.6765544456622766,
    half: 0.0375,
  },
  {
    cx: 0.4832531754730548,
    cy: -0.4832531754730548,
    cz: 0.6765544456622766,
    half: 0.0375,
  },
  {
    cx: 1.1598076211353314,
    cy: -1.1598076211353314,
    cz: 1.1598076211353314,
    half: 0.15,
  },
  {
    cx: 0.9665063509461096,
    cy: -1.3531088913245533,
    cz: 1.3531088913245533,
    half: 0.075,
  },
  {
    cx: 1.0631569860407206,
    cy: -1.2564582562299422,
    cz: 1.2564582562299422,
    half: 0.0375,
  },
  {
    cx: 1.1114823035880261,
    cy: -1.2081329386826367,
    cz: 1.3047835737772477,
    half: 0.01875,
  },
  {
    cx: 1.014831668493415,
    cy: -1.3047835737772477,
    cz: 1.3047835737772477,
    half: 0.01875,
  },
  {
    cx: 0.8698557158514987,
    cy: -1.2564582562299422,
    cz: 1.2564582562299422,
    half: 0.0375,
  },
  {
    cx: 1.1598076211353314,
    cy: -0.38660254037844377,
    cz: 0.38660254037844377,
    half: 0.15,
  },
  {
    cx: 1.3531088913245533,
    cy: -0.19330127018922183,
    cz: 0.19330127018922183,
    half: 0.075,
  },
  {
    cx: 1.2564582562299424,
    cy: -0.09665063509461086,
    cz: 0.2899519052838328,
    half: 0.0375,
  },
  {
    cx: 1.208132938682637,
    cy: -0.14497595264191634,
    cz: 0.33827722283113826,
    half: 0.01875,
  },
  {
    cx: 1.304783573777248,
    cy: -0.04832531754730539,
    cz: 0.33827722283113826,
    half: 0.01875,
  },
  {
    cx: 1.304783573777248,
    cy: -0.04832531754730539,
    cz: 0.24162658773652734,
    half: 0.01875,
  },
  {
    cx: 1.2564582562299424,
    cy: -0.2899519052838328,
    cz: 0.09665063509461086,
    half: 0.0375,
  },
  {
    cx: 1.208132938682637,
    cy: -0.33827722283113826,
    cz: 0.04832531754730539,
    half: 0.01875,
  },
  {
    cx: 1.304783573777248,
    cy: -0.24162658773652734,
    cz: 0.14497595264191634,
    half: 0.01875,
  },
  {
    cx: 1.304783573777248,
    cy: -0.24162658773652734,
    cz: 0.04832531754730539,
    half: 0.01875,
  },
  {
    cx: 1.2806209150035952,
    cy: -0.26578924651018004,
    cz: 0.07248797632095813,
    half: 0.009375,
  },
  {
    cx: 1.268539585616769,
    cy: -0.2778705758970064,
    cz: 0.06040664693413176,
    half: 0.0046875,
  },
  {
    cx: 1.262498920923356,
    cy: -0.27182991120359323,
    cz: 0.06644731162754496,
    half: 0.00234375,
  },
  {
    cx: 1.3289462325509007,
    cy: -0.21746392896287461,
    cz: 0.024162658773652652,
    half: 0.009375,
  },
  {
    cx: 1.3168649031640745,
    cy: -0.229545258349701,
    cz: 0.03624398816047903,
    half: 0.0046875,
  },
  {
    cx: 1.2564582562299424,
    cy: -0.09665063509461086,
    cz: 0.09665063509461086,
    half: 0.0375,
  },
  {
    cx: 0.9665063509461096,
    cy: -0.5799038105676657,
    cz: 0.5799038105676657,
    half: 0.075,
  },
  {
    cx: 0.8698557158514987,
    cy: -0.6765544456622766,
    cz: 0.6765544456622766,
    half: 0.0375,
  },
  {
    cx: 0.8215303983041932,
    cy: -0.7248797632095821,
    cz: 0.6282291281149711,
    half: 0.01875,
  },
  {
    cx: 0.7973677395305404,
    cy: -0.7007171044359294,
    cz: 0.6040664693413184,
    half: 0.009375,
  },
  {
    cx: 0.8094490689173668,
    cy: -0.7127984338227558,
    cz: 0.591985139954492,
    half: 0.0046875,
  },
  {
    cx: 0.8034084042239537,
    cy: -0.7188390985161689,
    cz: 0.5980258046479051,
    half: 0.00234375,
  },
  {
    cx: 0.785286410143714,
    cy: -0.688635775049103,
    cz: 0.6161477987281447,
    half: 0.0046875,
  },
  {
    cx: 0.8215303983041932,
    cy: -0.6282291281149711,
    cz: 0.6282291281149711,
    half: 0.01875,
  },
  {
    cx: 0.7973677395305404,
    cy: -0.6523917868886239,
    cz: 0.6523917868886239,
    half: 0.009375,
  },
  {
    cx: 0.8094490689173668,
    cy: -0.6644731162754502,
    cz: 0.6403104575017975,
    half: 0.0046875,
  },
  {
    cx: 0.785286410143714,
    cy: -0.6644731162754502,
    cz: 0.6403104575017975,
    half: 0.0046875,
  },
  {
    cx: 0.785286410143714,
    cy: -0.6403104575017975,
    cz: 0.6644731162754502,
    half: 0.0046875,
  },
  {
    cx: 0.7913270748371272,
    cy: -0.6342697928083844,
    cz: 0.6705137809688634,
    half: 0.00234375,
  },
  {
    cx: 0.8094490689173668,
    cy: -0.6403104575017975,
    cz: 0.6644731162754502,
    half: 0.0046875,
  },
  {
    cx: 0.9181810333988042,
    cy: -0.7248797632095821,
    cz: 0.6282291281149711,
    half: 0.01875,
  },
  {
    cx: 0.942343692172457,
    cy: -0.7007171044359294,
    cz: 0.6523917868886239,
    half: 0.009375,
  },
  {
    cx: 0.9302623627856306,
    cy: -0.688635775049103,
    cz: 0.6644731162754502,
    half: 0.0046875,
  },
  {
    cx: 0.9363030274790437,
    cy: -0.6825951103556899,
    cz: 0.6705137809688634,
    half: 0.00234375,
  },
  {
    cx: 0.9363030274790437,
    cy: -0.6825951103556899,
    cz: 0.6584324515820371,
    half: 0.00234375,
  },
  {
    cx: 0.9302623627856306,
    cy: -0.7127984338227558,
    cz: 0.6644731162754502,
    half: 0.0046875,
  },
  {
    cx: 0.9242216980922174,
    cy: -0.7067577691293426,
    cz: 0.6705137809688634,
    half: 0.00234375,
  },
  {
    cx: 0.9544250215592833,
    cy: -0.688635775049103,
    cz: 0.6644731162754502,
    half: 0.0046875,
  },
  {
    cx: 0.9302623627856306,
    cy: -0.688635775049103,
    cz: 0.6403104575017975,
    half: 0.0046875,
  },
  {
    cx: 0.9544250215592833,
    cy: -0.7127984338227558,
    cz: 0.6403104575017975,
    half: 0.0046875,
  },
  {
    cx: 0.9604656862526965,
    cy: -0.7188390985161689,
    cz: 0.6463511221952106,
    half: 0.00234375,
  },
  {
    cx: 0.942343692172457,
    cy: -0.7007171044359294,
    cz: 0.6040664693413184,
    half: 0.009375,
  },
  {
    cx: 0.9544250215592833,
    cy: -0.7127984338227558,
    cz: 0.6161477987281447,
    half: 0.0046875,
  },
  {
    cx: 0.9604656862526965,
    cy: -0.7067577691293426,
    cz: 0.6101071340347316,
    half: 0.00234375,
  },
  {
    cx: 0.9483843568658702,
    cy: -0.7067577691293426,
    cz: 0.6101071340347316,
    half: 0.00234375,
  },
  {
    cx: 0.9302623627856306,
    cy: -0.7127984338227558,
    cz: 0.6161477987281447,
    half: 0.0046875,
  },
  {
    cx: 0.9242216980922174,
    cy: -0.7067577691293426,
    cz: 0.6221884634215579,
    half: 0.00234375,
  },
  {
    cx: 0.9242216980922174,
    cy: -0.7067577691293426,
    cz: 0.6101071340347316,
    half: 0.00234375,
  },
  {
    cx: 0.9544250215592833,
    cy: -0.688635775049103,
    cz: 0.591985139954492,
    half: 0.0046875,
  },
  {
    cx: 0.9604656862526965,
    cy: -0.6825951103556899,
    cz: 0.5859444752610788,
    half: 0.00234375,
  },
  {
    cx: 0.9544250215592833,
    cy: -0.7127984338227558,
    cz: 0.591985139954492,
    half: 0.0046875,
  },
  {
    cx: 0.9483843568658702,
    cy: -0.7067577691293426,
    cz: 0.5980258046479051,
    half: 0.00234375,
  },
  {
    cx: 0.9483843568658702,
    cy: -0.7188390985161689,
    cz: 0.5980258046479051,
    half: 0.00234375,
  },
  {
    cx: 0.9483843568658702,
    cy: -0.7067577691293426,
    cz: 0.5859444752610788,
    half: 0.00234375,
  },
  {
    cx: 0.9181810333988042,
    cy: -0.6282291281149711,
    cz: 0.7248797632095821,
    half: 0.01875,
  },
  {
    cx: 0.8940183746251514,
    cy: -0.6040664693413184,
    cz: 0.7007171044359294,
    half: 0.009375,
  },
  {
    cx: 0.9060997040119778,
    cy: -0.591985139954492,
    cz: 0.7127984338227558,
    half: 0.0046875,
  },
  {
    cx: 0.8819370452383251,
    cy: -0.591985139954492,
    cz: 0.688635775049103,
    half: 0.0046875,
  },
  {
    cx: 0.8940183746251514,
    cy: -0.6040664693413184,
    cz: 0.7490424219832349,
    half: 0.009375,
  },
  {
    cx: 0.8819370452383251,
    cy: -0.591985139954492,
    cz: 0.7369610925964085,
    half: 0.0046875,
  },
  {
    cx: 0.8879777099317382,
    cy: -0.5980258046479051,
    cz: 0.7430017572898217,
    half: 0.00234375,
  },
  {
    cx: 0.8879777099317382,
    cy: -0.5980258046479051,
    cz: 0.7309204279029954,
    half: 0.00234375,
  },
  {
    cx: 0.8758963805449119,
    cy: -0.5980258046479051,
    cz: 0.7309204279029954,
    half: 0.00234375,
  },
  {
    cx: 0.8758963805449119,
    cy: -0.5980258046479051,
    cz: 0.7430017572898217,
    half: 0.00234375,
  },
  {
    cx: 0.8819370452383251,
    cy: -0.6161477987281447,
    cz: 0.7369610925964085,
    half: 0.0046875,
  },
  {
    cx: 0.9060997040119778,
    cy: -0.6161477987281447,
    cz: 0.7369610925964085,
    half: 0.0046875,
  },
  {
    cx: 0.8215303983041932,
    cy: -0.7248797632095821,
    cz: 0.7248797632095821,
    half: 0.01875,
  },
  {
    cx: -0.7732050807568877,
    cy: 0.7732050807568877,
    cz: 0.7732050807568877,
    half: 0.3,
  },
  {
    cx: 0.7732050807568877,
    cy: -0.7732050807568877,
    cz: -0.7732050807568877,
    half: 0.3,
  },
  {
    cx: 0.38660254037844377,
    cy: -0.38660254037844377,
    cz: -1.1598076211353314,
    half: 0.15,
  },
  {
    cx: 0.19330127018922183,
    cy: -0.5799038105676657,
    cz: -1.3531088913245533,
    half: 0.075,
  },
  {
    cx: 0.19330127018922183,
    cy: -0.5799038105676657,
    cz: -0.9665063509461096,
    half: 0.075,
  },
  {
    cx: 0.09665063509461086,
    cy: -0.6765544456622766,
    cz: -0.8698557158514987,
    half: 0.0375,
  },
  {
    cx: 0.14497595264191634,
    cy: -0.724879763209582,
    cz: -0.9181810333988041,
    half: 0.01875,
  },
  {
    cx: 0.048325317547305374,
    cy: -0.6282291281149712,
    cz: -0.8215303983041933,
    half: 0.01875,
  },
  {
    cx: 0.024162658773652642,
    cy: -0.6040664693413185,
    cz: -0.845693057077846,
    half: 0.009375,
  },
  {
    cx: 0.03624398816047901,
    cy: -0.6161477987281448,
    cz: -0.8336117276910197,
    half: 0.0046875,
  },
  {
    cx: 0.03020332346706582,
    cy: -0.6101071340347317,
    cz: -0.8275710629976065,
    half: 0.00234375,
  },
  {
    cx: 0.012081329386826276,
    cy: -0.5919851399544921,
    cz: -0.8336117276910197,
    half: 0.0046875,
  },
  {
    cx: 0.0060406646934130824,
    cy: -0.585944475261079,
    cz: -0.8396523923844328,
    half: 0.00234375,
  },
  {
    cx: 0.0060406646934130824,
    cy: -0.5980258046479052,
    cz: -0.8396523923844328,
    half: 0.00234375,
  },
  {
    cx: 0.14497595264191634,
    cy: -0.724879763209582,
    cz: -0.8215303983041933,
    half: 0.01875,
  },
  {
    cx: 0.2899519052838328,
    cy: -0.6765544456622766,
    cz: -0.8698557158514987,
    half: 0.0375,
  },
  {
    cx: 0.24162658773652734,
    cy: -0.7248797632095821,
    cz: -0.8215303983041932,
    half: 0.01875,
  },
  {
    cx: 0.26578924651018004,
    cy: -0.7007171044359294,
    cz: -0.8456930570778459,
    half: 0.009375,
  },
  {
    cx: 0.2778705758970064,
    cy: -0.688635775049103,
    cz: -0.8577743864646723,
    half: 0.0046875,
  },
  {
    cx: 0.2839112405904196,
    cy: -0.6946764397425161,
    cz: -0.8517337217712592,
    half: 0.00234375,
  },
  {
    cx: 0.25370791712335367,
    cy: -0.688635775049103,
    cz: -0.8336117276910195,
    half: 0.0046875,
  },
  {
    cx: 0.25974858181676685,
    cy: -0.6946764397425161,
    cz: -0.8275710629976064,
    half: 0.00234375,
  },
  {
    cx: 0.25370791712335367,
    cy: -0.7127984338227558,
    cz: -0.8336117276910195,
    half: 0.0046875,
  },
  {
    cx: 0.24766725242994045,
    cy: -0.7188390985161689,
    cz: -0.8396523923844327,
    half: 0.00234375,
  },
  {
    cx: 0.24766725242994045,
    cy: -0.7067577691293426,
    cz: -0.8396523923844327,
    half: 0.00234375,
  },
  {
    cx: 0.2778705758970064,
    cy: -0.688635775049103,
    cz: -0.8336117276910195,
    half: 0.0046875,
  },
  {
    cx: 0.2839112405904196,
    cy: -0.6946764397425161,
    cz: -0.8396523923844327,
    half: 0.00234375,
  },
  {
    cx: 0.2778705758970064,
    cy: -0.7127984338227558,
    cz: -0.8336117276910195,
    half: 0.0046875,
  },
  {
    cx: 0.2839112405904196,
    cy: -0.7067577691293426,
    cz: -0.8275710629976064,
    half: 0.00234375,
  },
  {
    cx: 0.24162658773652734,
    cy: -0.7248797632095821,
    cz: -0.9181810333988042,
    half: 0.01875,
  },
  {
    cx: 1.1598076211353314,
    cy: -0.38660254037844377,
    cz: -0.38660254037844377,
    half: 0.15,
  },
  {
    cx: 0.9665063509461096,
    cy: -0.19330127018922183,
    cz: -0.19330127018922183,
    half: 0.075,
  },
  {
    cx: 1.0631569860407204,
    cy: -0.09665063509461086,
    cz: -0.09665063509461086,
    half: 0.0375,
  },
  {
    cx: 1.111482303588026,
    cy: -0.04832531754730539,
    cz: -0.04832531754730539,
    half: 0.01875,
  },
  {
    cx: 1.1356449623616787,
    cy: -0.07248797632095813,
    cz: -0.07248797632095813,
    half: 0.009375,
  },
  {
    cx: 1.147726291748505,
    cy: -0.08456930570778451,
    cz: -0.06040664693413176,
    half: 0.0046875,
  },
  {
    cx: 1.153766956441918,
    cy: -0.07852864101437132,
    cz: -0.05436598224071857,
    half: 0.00234375,
  },
  {
    cx: 1.111482303588026,
    cy: -0.14497595264191634,
    cz: -0.14497595264191634,
    half: 0.01875,
  },
  {
    cx: 1.1356449623616787,
    cy: -0.16913861141556907,
    cz: -0.12081329386826362,
    half: 0.009375,
  },
  {
    cx: 1.1235636329748524,
    cy: -0.1570572820287427,
    cz: -0.13289462325509,
    half: 0.0046875,
  },
  {
    cx: 1.0631569860407204,
    cy: -0.2899519052838328,
    cz: -0.09665063509461086,
    half: 0.0375,
  },
  {
    cx: 1.111482303588026,
    cy: -0.24162658773652734,
    cz: -0.14497595264191634,
    half: 0.01875,
  },
  {
    cx: 1.111482303588026,
    cy: -0.33827722283113826,
    cz: -0.14497595264191634,
    half: 0.01875,
  },
  {
    cx: 1.1356449623616787,
    cy: -0.36243988160479096,
    cz: -0.16913861141556907,
    half: 0.009375,
  },
  {
    cx: 1.147726291748505,
    cy: -0.3503585522179646,
    cz: -0.1570572820287427,
    half: 0.0046875,
  },
  {
    cx: 1.141685627055092,
    cy: -0.3443178875245514,
    cz: -0.1510166173353295,
    half: 0.00234375,
  },
  {
    cx: 1.141685627055092,
    cy: -0.35639921691137777,
    cz: -0.16309794672215588,
    half: 0.00234375,
  },
  {
    cx: 1.153766956441918,
    cy: -0.35639921691137777,
    cz: -0.16309794672215588,
    half: 0.00234375,
  },
  {
    cx: 1.1235636329748524,
    cy: -0.3503585522179646,
    cz: -0.18121994080239545,
    half: 0.0046875,
  },
  {
    cx: 1.1175229682814394,
    cy: -0.35639921691137777,
    cz: -0.17517927610898226,
    half: 0.00234375,
  },
  {
    cx: 1.111482303588026,
    cy: -0.33827722283113826,
    cz: -0.04832531754730539,
    half: 0.01875,
  },
  {
    cx: 1.0873196448143732,
    cy: -0.31411456405748556,
    cz: -0.07248797632095813,
    half: 0.009375,
  },
  {
    cx: 1.0752383154275469,
    cy: -0.3020332346706592,
    cz: -0.0845693057077845,
    half: 0.0046875,
  },
  {
    cx: 1.0994009742011994,
    cy: -0.3020332346706592,
    cz: -0.06040664693413176,
    half: 0.0046875,
  },
  {
    cx: 1.0933603095077864,
    cy: -0.295992569977246,
    cz: -0.05436598224071858,
    half: 0.00234375,
  },
  {
    cx: 1.1054416388946124,
    cy: -0.295992569977246,
    cz: -0.05436598224071858,
    half: 0.00234375,
  },
  {
    cx: 1.0994009742011994,
    cy: -0.32619589344431194,
    cz: -0.0845693057077845,
    half: 0.0046875,
  },
  {
    cx: 1.1054416388946124,
    cy: -0.3322365581377251,
    cz: -0.09060997040119768,
    half: 0.00234375,
  },
  {
    cx: 1.1054416388946124,
    cy: -0.3322365581377251,
    cz: -0.0785286410143713,
    half: 0.00234375,
  },
  {
    cx: 1.0752383154275469,
    cy: -0.32619589344431194,
    cz: -0.06040664693413176,
    half: 0.0046875,
  },
  {
    cx: 1.0631569860407204,
    cy: -0.09665063509461086,
    cz: -0.2899519052838328,
    half: 0.0375,
  },
  {
    cx: 1.111482303588026,
    cy: -0.14497595264191634,
    cz: -0.24162658773652734,
    half: 0.01875,
  },
  {
    cx: 1.111482303588026,
    cy: -0.04832531754730539,
    cz: -0.33827722283113826,
    half: 0.01875,
  },
  {
    cx: 1.0873196448143732,
    cy: -0.024162658773652652,
    cz: -0.31411456405748556,
    half: 0.009375,
  },
  {
    cx: 1.0994009742011994,
    cy: -0.012081329386826276,
    cz: -0.3020332346706592,
    half: 0.0046875,
  },
  {
    cx: 1.0933603095077864,
    cy: -0.018121994080239463,
    cz: -0.30807389936407237,
    half: 0.00234375,
  },
  {
    cx: 1.0752383154275469,
    cy: -0.012081329386826276,
    cz: -0.32619589344431194,
    half: 0.0046875,
  },
  {
    cx: 0.9665063509461096,
    cy: -0.5799038105676657,
    cz: -0.19330127018922183,
    half: 0.075,
  },
  {
    cx: 1.0631569860407204,
    cy: -0.4832531754730548,
    cz: -0.2899519052838328,
    half: 0.0375,
  },
  {
    cx: 1.0148316684934149,
    cy: -0.5315784930203602,
    cz: -0.24162658773652734,
    half: 0.01875,
  },
  {
    cx: 0.9906690097197621,
    cy: -0.5074158342467074,
    cz: -0.21746392896287461,
    half: 0.009375,
  },
  {
    cx: 0.9785876803329357,
    cy: -0.49533450485988106,
    cz: -0.20538259957604826,
    half: 0.0046875,
  },
  {
    cx: 0.9846283450263489,
    cy: -0.4892938401664679,
    cz: -0.21142326426946145,
    half: 0.00234375,
  },
  {
    cx: 0.9725470156395226,
    cy: -0.5013751695532942,
    cz: -0.21142326426946148,
    half: 0.00234375,
  },
  {
    cx: 1.0027503391065884,
    cy: -0.5194971636335338,
    cz: -0.20538259957604824,
    half: 0.0046875,
  },
  {
    cx: 0.9967096744131753,
    cy: -0.5134564989401207,
    cz: -0.19934193488263502,
    half: 0.00234375,
  },
  {
    cx: 0.9785876803329357,
    cy: -0.5194971636335338,
    cz: -0.20538259957604826,
    half: 0.0046875,
  },
  {
    cx: 0.9725470156395226,
    cy: -0.525537828326947,
    cz: -0.21142326426946148,
    half: 0.00234375,
  },
  {
    cx: 1.111482303588026,
    cy: -0.43492785792574934,
    cz: -0.24162658773652734,
    half: 0.01875,
  },
  {
    cx: 1.1356449623616787,
    cy: -0.45909051669940204,
    cz: -0.21746392896287461,
    half: 0.009375,
  },
  {
    cx: 1.147726291748505,
    cy: -0.4711718460862284,
    cz: -0.229545258349701,
    half: 0.0046875,
  },
  {
    cx: 1.153766956441918,
    cy: -0.46513118139281523,
    cz: -0.23558592304311418,
    half: 0.00234375,
  },
  {
    cx: 1.141685627055092,
    cy: -0.46513118139281523,
    cz: -0.2235045936562878,
    half: 0.00234375,
  },
  {
    cx: 1.1235636329748524,
    cy: -0.44700918731257566,
    cz: -0.229545258349701,
    half: 0.0046875,
  },
  {
    cx: 1.1296042976682654,
    cy: -0.45304985200598885,
    cz: -0.23558592304311418,
    half: 0.00234375,
  },
  {
    cx: 1.1235636329748524,
    cy: -0.4711718460862284,
    cz: -0.229545258349701,
    half: 0.0046875,
  },
  {
    cx: 1.147726291748505,
    cy: -0.44700918731257566,
    cz: -0.20538259957604824,
    half: 0.0046875,
  },
  {
    cx: 1.147726291748505,
    cy: -0.4711718460862284,
    cz: -0.20538259957604824,
    half: 0.0046875,
  },
  {
    cx: 0.9665063509461096,
    cy: -0.19330127018922183,
    cz: -0.5799038105676657,
    half: 0.075,
  },
  {
    cx: 0.8698557158514987,
    cy: -0.2899519052838328,
    cz: -0.6765544456622766,
    half: 0.0375,
  },
  {
    cx: 0.8215303983041932,
    cy: -0.24162658773652734,
    cz: -0.7248797632095821,
    half: 0.01875,
  },
  {
    cx: 0.8456930570778459,
    cy: -0.21746392896287461,
    cz: -0.7490424219832349,
    half: 0.009375,
  },
  {
    cx: 0.8336117276910195,
    cy: -0.22954525834970096,
    cz: -0.7369610925964085,
    half: 0.0046875,
  },
  {
    cx: 0.8275710629976064,
    cy: -0.23558592304311418,
    cz: -0.7430017572898217,
    half: 0.00234375,
  },
  {
    cx: 0.8396523923844327,
    cy: -0.23558592304311418,
    cz: -0.7430017572898217,
    half: 0.00234375,
  },
  {
    cx: 0.8275710629976064,
    cy: -0.22350459365628775,
    cz: -0.7309204279029954,
    half: 0.00234375,
  },
  {
    cx: 0.8396523923844327,
    cy: -0.22350459365628775,
    cz: -0.7309204279029954,
    half: 0.00234375,
  },
  {
    cx: 0.8577743864646723,
    cy: -0.20538259957604826,
    cz: -0.7369610925964085,
    half: 0.0046875,
  },
  {
    cx: 0.8577743864646723,
    cy: -0.22954525834970096,
    cz: -0.7369610925964085,
    half: 0.0046875,
  },
  {
    cx: 0.7973677395305404,
    cy: -0.26578924651018004,
    cz: -0.7007171044359294,
    half: 0.009375,
  },
  {
    cx: 0.785286410143714,
    cy: -0.2778705758970064,
    cz: -0.688635775049103,
    half: 0.0046875,
  },
  {
    cx: 0.7792457454503009,
    cy: -0.27182991120359323,
    cz: -0.6946764397425161,
    half: 0.00234375,
  },
  {
    cx: 0.7913270748371272,
    cy: -0.2839112405904196,
    cz: -0.6825951103556899,
    half: 0.00234375,
  },
  {
    cx: 0.8094490689173668,
    cy: -0.2778705758970064,
    cz: -0.688635775049103,
    half: 0.0046875,
  },
  {
    cx: 0.7973677395305404,
    cy: -0.26578924651018004,
    cz: -0.7490424219832349,
    half: 0.009375,
  },
  {
    cx: 0.8094490689173668,
    cy: -0.25370791712335367,
    cz: -0.7369610925964085,
    half: 0.0046875,
  },
  {
    cx: 0.8154897336107799,
    cy: -0.24766725242994045,
    cz: -0.7430017572898217,
    half: 0.00234375,
  },
  {
    cx: 0.785286410143714,
    cy: -0.2778705758970064,
    cz: -0.7369610925964085,
    half: 0.0046875,
  },
  {
    cx: 0.7792457454503009,
    cy: -0.27182991120359323,
    cz: -0.7430017572898217,
    half: 0.00234375,
  },
  {
    cx: 0.7792457454503009,
    cy: -0.2839112405904196,
    cz: -0.7309204279029954,
    half: 0.00234375,
  },
  {
    cx: 0.8094490689173668,
    cy: -0.2778705758970064,
    cz: -0.7611237513700613,
    half: 0.0046875,
  },
  {
    cx: 0.8215303983041932,
    cy: -0.33827722283113826,
    cz: -0.7248797632095821,
    half: 0.01875,
  },
  {
    cx: 1.0631569860407204,
    cy: -0.2899519052838328,
    cz: -0.4832531754730548,
    half: 0.0375,
  },
  {
    cx: -0.7732050807568877,
    cy: 0.7732050807568877,
    cz: -0.7732050807568877,
    half: 0.3,
  },
  {
    cx: -1.1598076211353314,
    cy: 0.38660254037844377,
    cz: -0.38660254037844377,
    half: 0.15,
  },
  {
    cx: -0.9665063509461096,
    cy: 0.5799038105676657,
    cz: -0.5799038105676657,
    half: 0.075,
  },
  {
    cx: -0.9665063509461096,
    cy: 0.19330127018922183,
    cz: -0.5799038105676657,
    half: 0.075,
  },
  {
    cx: -1.0631569860407204,
    cy: 0.09665063509461086,
    cz: -0.6765544456622766,
    half: 0.0375,
  },
  {
    cx: -1.111482303588026,
    cy: 0.14497595264191634,
    cz: -0.724879763209582,
    half: 0.01875,
  },
  {
    cx: -1.1356449623616787,
    cy: 0.16913861141556907,
    cz: -0.7007171044359293,
    half: 0.009375,
  },
  {
    cx: -1.1235636329748524,
    cy: 0.18121994080239545,
    cz: -0.7127984338227557,
    half: 0.0046875,
  },
  {
    cx: -1.1235636329748524,
    cy: 0.1570572820287427,
    cz: -0.7127984338227557,
    half: 0.0046875,
  },
  {
    cx: -1.1296042976682656,
    cy: 0.1630979467221559,
    cz: -0.7188390985161688,
    half: 0.00234375,
  },
  {
    cx: -1.1296042976682656,
    cy: 0.1630979467221559,
    cz: -0.7067577691293425,
    half: 0.00234375,
  },
  {
    cx: -1.1356449623616787,
    cy: 0.12081329386826363,
    cz: -0.7007171044359293,
    half: 0.009375,
  },
  {
    cx: -1.147726291748505,
    cy: 0.10873196448143727,
    cz: -0.6886357750491029,
    half: 0.0046875,
  },
  {
    cx: -1.1416856270550917,
    cy: 0.10269129978802408,
    cz: -0.6825951103556898,
    half: 0.00234375,
  },
  {
    cx: -1.147726291748505,
    cy: 0.10873196448143727,
    cz: -0.7127984338227557,
    half: 0.0046875,
  },
  {
    cx: -1.147726291748505,
    cy: 0.13289462325509002,
    cz: -0.6886357750491029,
    half: 0.0046875,
  },
  {
    cx: -1.1235636329748524,
    cy: 0.10873196448143727,
    cz: -0.7127984338227557,
    half: 0.0046875,
  },
  {
    cx: -1.0873196448143732,
    cy: 0.16913861141556907,
    cz: -0.7490424219832348,
    half: 0.009375,
  },
  {
    cx: -1.0752383154275469,
    cy: 0.1570572820287427,
    cz: -0.7611237513700612,
    half: 0.0046875,
  },
  {
    cx: -1.0691976507341336,
    cy: 0.15101661733532948,
    cz: -0.7671644160634743,
    half: 0.00234375,
  },
  {
    cx: -1.0994009742011994,
    cy: 0.1570572820287427,
    cz: -0.7369610925964084,
    half: 0.0046875,
  },
  {
    cx: -1.3531088913245533,
    cy: 0.19330127018922183,
    cz: -0.5799038105676657,
    half: 0.075,
  },
  {
    cx: -1.449759526419164,
    cy: 0.2899519052838328,
    cz: -0.6765544456622766,
    half: 0.0375,
  },
  {
    cx: -1.4980848439664696,
    cy: 0.24162658773652734,
    cz: -0.6282291281149712,
    half: 0.01875,
  },
  {
    cx: -1.5222475027401223,
    cy: 0.21746392896287461,
    cz: -0.6040664693413185,
    half: 0.009375,
  },
  {
    cx: -1.5343288321269486,
    cy: 0.20538259957604824,
    cz: -0.5919851399544921,
    half: 0.0046875,
  },
  {
    cx: -1.510166173353296,
    cy: 0.20538259957604824,
    cz: -0.6161477987281448,
    half: 0.0046875,
  },
  {
    cx: -1.5343288321269486,
    cy: 0.229545258349701,
    cz: -0.5919851399544921,
    half: 0.0046875,
  },
  {
    cx: -1.4014342088718585,
    cy: 0.24162658773652734,
    cz: -0.6282291281149712,
    half: 0.01875,
  },
  {
    cx: -1.1598076211353314,
    cy: 1.1598076211353314,
    cz: -0.38660254037844377,
    half: 0.15,
  },
  {
    cx: -1.3531088913245533,
    cy: 0.9665063509461096,
    cz: -0.5799038105676657,
    half: 0.075,
  },
  {
    cx: -0.38660254037844377,
    cy: 0.38660254037844377,
    cz: -1.1598076211353314,
    half: 0.15,
  },
  {
    cx: -0.5799038105676657,
    cy: 0.5799038105676657,
    cz: -1.3531088913245533,
    half: 0.075,
  },
  {
    cx: -0.6765544456622766,
    cy: 0.4832531754730548,
    cz: -1.2564582562299422,
    half: 0.0375,
  },
  {
    cx: -0.724879763209582,
    cy: 0.43492785792574934,
    cz: -1.3047835737772477,
    half: 0.01875,
  },
  {
    cx: -0.7490424219832348,
    cy: 0.45909051669940204,
    cz: -1.3289462325509005,
    half: 0.009375,
  },
  {
    cx: -0.7611237513700612,
    cy: 0.44700918731257566,
    cz: -1.3410275619377268,
    half: 0.0046875,
  },
  {
    cx: -0.7671644160634743,
    cy: 0.4409685226191625,
    cz: -1.3349868972443135,
    half: 0.00234375,
  },
  {
    cx: -0.7671644160634743,
    cy: 0.45304985200598885,
    cz: -1.34706822663114,
    half: 0.00234375,
  },
  {
    cx: -0.7671644160634743,
    cy: 0.4409685226191625,
    cz: -1.34706822663114,
    half: 0.00234375,
  },
  {
    cx: -0.7369610925964084,
    cy: 0.44700918731257566,
    cz: -1.3168649031640742,
    half: 0.0046875,
  },
  {
    cx: -0.7611237513700612,
    cy: 0.4711718460862284,
    cz: -1.3168649031640742,
    half: 0.0046875,
  },
  {
    cx: -0.755083086676648,
    cy: 0.46513118139281523,
    cz: -1.3229055678574875,
    half: 0.00234375,
  },
  {
    cx: -0.755083086676648,
    cy: 0.4772125107796416,
    cz: -1.310824238470661,
    half: 0.00234375,
  },
  {
    cx: -0.7671644160634743,
    cy: 0.46513118139281523,
    cz: -1.310824238470661,
    half: 0.00234375,
  },
  {
    cx: -0.7611237513700612,
    cy: 0.4711718460862284,
    cz: -1.3410275619377268,
    half: 0.0046875,
  },
  {
    cx: -0.724879763209582,
    cy: 0.5315784930203602,
    cz: -1.2081329386826367,
    half: 0.01875,
  },
  {
    cx: -0.6765544456622766,
    cy: 0.4832531754730548,
    cz: -1.4497595264191643,
    half: 0.0375,
  },
  {
    cx: -0.6282291281149712,
    cy: 0.5315784930203602,
    cz: -1.4980848439664698,
    half: 0.01875,
  },
  {
    cx: -0.6040664693413185,
    cy: 0.555741151794013,
    cz: -1.473922185192817,
    half: 0.009375,
  },
  {
    cx: -0.6161477987281448,
    cy: 0.5678224811808393,
    cz: -1.4860035145796433,
    half: 0.0046875,
  },
  {
    cx: -0.5919851399544921,
    cy: 0.5436598224071866,
    cz: -1.4860035145796433,
    half: 0.0046875,
  },
  {
    cx: -0.5980258046479052,
    cy: 0.5376191577137734,
    cz: -1.47996284988623,
    half: 0.00234375,
  },
  {
    cx: -0.585944475261079,
    cy: 0.5497004871005997,
    cz: -1.47996284988623,
    half: 0.00234375,
  },
  {
    cx: -0.6282291281149712,
    cy: 0.43492785792574934,
    cz: -1.4014342088718588,
    half: 0.01875,
  },
  {
    cx: -0.6040664693413185,
    cy: 0.45909051669940204,
    cz: -1.377271550098206,
    half: 0.009375,
  },
  {
    cx: -0.6161477987281448,
    cy: 0.4711718460862284,
    cz: -1.3651902207113797,
    half: 0.0046875,
  },
  {
    cx: -0.6101071340347317,
    cy: 0.46513118139281523,
    cz: -1.371230885404793,
    half: 0.00234375,
  },
  {
    cx: -0.6161477987281448,
    cy: 0.44700918731257566,
    cz: -1.3893528794850323,
    half: 0.0046875,
  },
  {
    cx: -0.5919851399544921,
    cy: 0.44700918731257566,
    cz: -1.3893528794850323,
    half: 0.0046875,
  },
  {
    cx: -0.652391786888624,
    cy: 0.45909051669940204,
    cz: -1.4255968676455115,
    half: 0.009375,
  },
  {
    cx: -0.6644731162754504,
    cy: 0.44700918731257566,
    cz: -1.4376781970323378,
    half: 0.0046875,
  },
  {
    cx: -0.6705137809688635,
    cy: 0.45304985200598885,
    cz: -1.443718861725751,
    half: 0.00234375,
  },
  {
    cx: -0.6584324515820372,
    cy: 0.4409685226191625,
    cz: -1.4316375323389245,
    half: 0.00234375,
  },
  {
    cx: -0.6705137809688635,
    cy: 0.4409685226191625,
    cz: -1.4316375323389245,
    half: 0.00234375,
  },
  {
    cx: -0.652391786888624,
    cy: 0.41076519915209664,
    cz: -1.377271550098206,
    half: 0.009375,
  },
  {
    cx: -0.6403104575017976,
    cy: 0.422846528538923,
    cz: -1.3651902207113797,
    half: 0.0046875,
  },
  {
    cx: -0.6403104575017976,
    cy: 0.39868386976527026,
    cz: -1.3893528794850323,
    half: 0.0046875,
  },
  {
    cx: -0.6644731162754504,
    cy: 0.39868386976527026,
    cz: -1.3893528794850323,
    half: 0.0046875,
  },
  {
    cx: -0.6705137809688635,
    cy: 0.39264320507185707,
    cz: -1.3953935441784455,
    half: 0.00234375,
  },
  {
    cx: -0.6705137809688635,
    cy: 0.40472453445868345,
    cz: -1.3953935441784455,
    half: 0.00234375,
  },
  {
    cx: -0.6584324515820372,
    cy: 0.39264320507185707,
    cz: -1.383312214791619,
    half: 0.00234375,
  },
  {
    cx: -0.19330127018922183,
    cy: 0.5799038105676657,
    cz: -1.3531088913245533,
    half: 0.075,
  },
  {
    cx: -0.09665063509461086,
    cy: 0.6765544456622766,
    cz: -1.2564582562299424,
    half: 0.0375,
  },
  {
    cx: -0.04832531754730539,
    cy: 0.6282291281149712,
    cz: -1.208132938682637,
    half: 0.01875,
  },
  {
    cx: -0.14497595264191634,
    cy: 0.724879763209582,
    cz: -1.304783573777248,
    half: 0.01875,
  },
  {
    cx: -0.16913861141556907,
    cy: 0.7490424219832348,
    cz: -1.2806209150035952,
    half: 0.009375,
  },
  {
    cx: -0.1570572820287427,
    cy: 0.7611237513700612,
    cz: -1.268539585616769,
    half: 0.0046875,
  },
  {
    cx: -0.1570572820287427,
    cy: 0.7611237513700612,
    cz: -1.2927022443904215,
    half: 0.0046875,
  },
  {
    cx: -0.18121994080239545,
    cy: 0.7611237513700612,
    cz: -1.268539585616769,
    half: 0.0046875,
  },
  {
    cx: -0.04832531754730539,
    cy: 0.724879763209582,
    cz: -1.208132938682637,
    half: 0.01875,
  },
  {
    cx: -0.07248797632095813,
    cy: 0.7490424219832348,
    cz: -1.1839702799089842,
    half: 0.009375,
  },
  {
    cx: -0.0845693057077845,
    cy: 0.7611237513700612,
    cz: -1.1960516092958104,
    half: 0.0046875,
  },
]

/** Parent index per node; root = -1. */
export const STATIC_PARENT_INDICES: number[] = [
  -1, 0, 1, 2, 2, 4, 5, 6, 7, 7, 5, 10, 11, 12, 11, 14, 5, 16, 17, 18, 17, 20,
  5, 22, 23, 24, 23, 23, 23, 28, 5, 30, 31, 32, 32, 5, 4, 36, 37, 38, 39, 36,
  36, 42, 43, 43, 43, 43, 4, 48, 1, 50, 51, 52, 53, 54, 54, 56, 56, 54, 59, 53,
  61, 62, 61, 64, 64, 61, 67, 67, 61, 52, 71, 72, 72, 74, 74, 74, 72, 52, 52,
  51, 81, 82, 83, 83, 83, 86, 83, 82, 89, 90, 89, 92, 89, 94, 94, 51, 97, 98,
  99, 99, 99, 99, 103, 103, 97, 97, 107, 108, 109, 108, 108, 107, 113, 114, 113,
  116, 97, 97, 119, 120, 120, 122, 122, 119, 125, 126, 126, 125, 129, 125, 50,
  132, 133, 133, 135, 136, 136, 136, 139, 139, 139, 136, 132, 144, 145, 146,
  147, 146, 149, 132, 151, 152, 153, 153, 153, 156, 50, 158, 159, 159, 161, 162,
  162, 164, 162, 166, 162, 161, 169, 169, 161, 172, 173, 173, 172, 161, 177,
  178, 177, 177, 181, 181, 159, 158, 185, 186, 187, 187, 189, 185, 191, 192,
  192, 194, 192, 191, 197, 198, 198, 197, 201, 191, 203, 204, 203, 206, 203,
  208, 185, 210, 211, 211, 213, 213, 210, 216, 217, 216, 1, 220, 221, 222, 221,
  220, 225, 226, 227, 228, 229, 228, 225, 220, 233, 1, 235, 236, 235, 238, 239,
  239, 241, 242, 243, 242, 239, 239, 0, 0, 249, 250, 251, 252, 253, 252, 251,
  256, 257, 258, 259, 259, 258, 250, 250, 264, 264, 249, 249, 268, 269, 270,
  271, 272, 273, 273, 272, 276, 270, 278, 279, 278, 281, 281, 270, 284, 285,
  286, 286, 285, 285, 290, 269, 292, 293, 294, 295, 292, 297, 298, 299, 298,
  301, 298, 292, 304, 305, 306, 306, 305, 309, 305, 311, 311, 292, 314, 315,
  316, 315, 318, 318, 315, 315, 268, 323, 323, 325, 326, 327, 328, 327, 330,
  327, 327, 333, 333, 326, 336, 337, 336, 325, 323, 341, 323, 343, 249, 345,
  346, 345, 348, 349, 350, 351, 351, 353, 348, 355, 355, 0, 358, 359, 360, 360,
  362, 362, 364, 365, 366, 365, 368, 365, 370, 365, 372, 360, 374, 374, 359,
  358, 378, 379, 380, 381, 382, 382, 384, 384, 382, 387, 387, 379, 390, 391,
  392, 391, 394, 394, 396, 396, 390, 399, 400, 400, 402, 378, 404, 405, 404,
  404, 358, 409, 410, 411, 411, 410, 358, 415, 416, 417, 417, 417, 416, 421,
  421, 421, 424, 425, 426, 424, 428, 416, 415, 431, 432, 433, 434, 435, 434,
  432, 438, 439, 439, 439, 442, 439, 432, 445, 446, 447, 447, 446, 450, 446,
  446, 446, 454, 445, 456, 457, 457, 456, 460, 460, 456, 463, 456, 465, 465,
  465, 432, 469, 470, 470, 469, 473, 474, 474, 474, 474, 473, 473, 432, 0, 0,
  483, 484, 484, 486, 487, 487, 489, 490, 491, 490, 493, 493, 487, 486, 497,
  498, 499, 500, 499, 502, 499, 504, 504, 499, 507, 499, 509, 497, 483, 512,
  513, 514, 515, 516, 517, 514, 519, 520, 513, 522, 522, 524, 525, 526, 526,
  526, 525, 530, 522, 532, 533, 533, 535, 535, 533, 538, 538, 533, 513, 542,
  542, 544, 545, 546, 545, 512, 549, 550, 551, 552, 553, 553, 552, 556, 552,
  558, 550, 560, 561, 562, 562, 561, 565, 561, 561, 561, 512, 570, 571, 572,
  573, 574, 574, 574, 574, 573, 573, 572, 581, 582, 582, 581, 572, 586, 587,
  586, 589, 589, 586, 571, 570, 0, 595, 596, 596, 598, 599, 600, 601, 601, 603,
  603, 600, 606, 607, 606, 606, 606, 600, 612, 613, 612, 596, 616, 617, 618,
  619, 619, 619, 617, 595, 624, 595, 626, 627, 628, 629, 630, 631, 631, 631,
  630, 630, 636, 636, 636, 630, 628, 627, 642, 643, 644, 644, 646, 646, 642,
  649, 650, 651, 650, 650, 649, 655, 656, 656, 656, 649, 660, 660, 660, 663,
  663, 663, 626, 667, 668, 668, 670, 671, 671, 671, 668, 675, 676,
]

/**
 * Verification chains (root → leaf node index paths).
 * Reorder entries here to control which chains animate first on page load.
 */
export const STATIC_CHAINS: number[][] = [
  [0, 1, 2, 4, 5, 30, 31, 32, 33],
  [0, 1, 2, 4, 5, 30, 31, 32, 34],
  [0, 1, 50, 51, 52, 53, 54, 56, 57],
  [0, 1, 50, 51, 52, 53, 54, 56, 58],
  [0, 1, 50, 51, 52, 53, 61, 64, 65],
  [0, 1, 50, 51, 52, 53, 61, 64, 66],
  [0, 1, 50, 51, 52, 53, 61, 67, 68],
  [0, 1, 50, 51, 52, 53, 61, 67, 69],
  [0, 1, 50, 51, 52, 71, 72, 74, 75],
  [0, 1, 50, 51, 52, 71, 72, 74, 76],
  [0, 1, 50, 51, 52, 71, 72, 74, 77],
  [0, 1, 50, 51, 81, 82, 89, 94, 95],
  [0, 1, 50, 51, 81, 82, 89, 94, 96],
  [0, 1, 50, 51, 97, 98, 99, 103, 104],
  [0, 1, 50, 51, 97, 98, 99, 103, 105],
  [0, 1, 50, 51, 97, 119, 120, 122, 123],
  [0, 1, 50, 51, 97, 119, 120, 122, 124],
  [0, 1, 50, 51, 97, 119, 125, 126, 127],
  [0, 1, 50, 51, 97, 119, 125, 126, 128],
  [0, 1, 50, 132, 133, 135, 136, 139, 140],
  [0, 1, 50, 132, 133, 135, 136, 139, 141],
  [0, 1, 50, 132, 133, 135, 136, 139, 142],
  [0, 1, 50, 158, 159, 161, 172, 173, 174],
  [0, 1, 50, 158, 159, 161, 172, 173, 175],
  [0, 1, 50, 158, 159, 161, 177, 181, 182],
  [0, 1, 50, 158, 159, 161, 177, 181, 183],
  [0, 1, 50, 158, 185, 191, 197, 198, 199],
  [0, 1, 50, 158, 185, 191, 197, 198, 200],
  [0, 1, 50, 158, 185, 210, 211, 213, 214],
  [0, 1, 50, 158, 185, 210, 211, 213, 215],
  [0, 249, 250, 251, 256, 257, 258, 259, 260],
  [0, 249, 250, 251, 256, 257, 258, 259, 261],
  [0, 249, 268, 269, 270, 271, 272, 273, 274],
  [0, 249, 268, 269, 270, 271, 272, 273, 275],
  [0, 249, 268, 269, 270, 284, 285, 286, 287],
  [0, 249, 268, 269, 270, 284, 285, 286, 288],
  [0, 249, 268, 269, 292, 304, 305, 306, 307],
  [0, 249, 268, 269, 292, 304, 305, 306, 308],
  [0, 249, 268, 269, 292, 304, 305, 311, 312],
  [0, 249, 268, 269, 292, 304, 305, 311, 313],
  [0, 249, 268, 269, 292, 314, 315, 318, 319],
  [0, 249, 268, 269, 292, 314, 315, 318, 320],
  [0, 249, 268, 323, 325, 326, 327, 333, 334],
  [0, 249, 268, 323, 325, 326, 327, 333, 335],
  [0, 358, 378, 379, 380, 381, 382, 384, 385],
  [0, 358, 378, 379, 380, 381, 382, 384, 386],
  [0, 358, 378, 379, 380, 381, 382, 387, 388],
  [0, 358, 378, 379, 380, 381, 382, 387, 389],
  [0, 358, 378, 379, 390, 391, 394, 396, 397],
  [0, 358, 378, 379, 390, 391, 394, 396, 398],
  [0, 358, 415, 431, 432, 445, 446, 447, 448],
  [0, 358, 415, 431, 432, 445, 446, 447, 449],
  [0, 358, 415, 431, 432, 445, 456, 457, 458],
  [0, 358, 415, 431, 432, 445, 456, 457, 459],
  [0, 358, 415, 431, 432, 445, 456, 460, 461],
  [0, 358, 415, 431, 432, 445, 456, 460, 462],
  [0, 358, 415, 431, 432, 445, 456, 465, 466],
  [0, 358, 415, 431, 432, 445, 456, 465, 467],
  [0, 358, 415, 431, 432, 445, 456, 465, 468],
  [0, 358, 415, 431, 432, 469, 473, 474, 475],
  [0, 358, 415, 431, 432, 469, 473, 474, 476],
  [0, 358, 415, 431, 432, 469, 473, 474, 477],
  [0, 358, 415, 431, 432, 469, 473, 474, 478],
  [0, 483, 484, 486, 487, 489, 490, 493, 494],
  [0, 483, 484, 486, 487, 489, 490, 493, 495],
  [0, 483, 484, 486, 497, 498, 499, 504, 505],
  [0, 483, 484, 486, 497, 498, 499, 504, 506],
  [0, 483, 512, 513, 522, 524, 525, 526, 527],
  [0, 483, 512, 513, 522, 524, 525, 526, 528],
  [0, 483, 512, 513, 522, 524, 525, 526, 529],
  [0, 483, 512, 513, 522, 532, 533, 535, 536],
  [0, 483, 512, 513, 522, 532, 533, 535, 537],
  [0, 483, 512, 513, 522, 532, 533, 538, 539],
  [0, 483, 512, 513, 522, 532, 533, 538, 540],
  [0, 483, 512, 549, 550, 551, 552, 553, 554],
  [0, 483, 512, 549, 550, 551, 552, 553, 555],
  [0, 483, 512, 549, 550, 560, 561, 562, 563],
  [0, 483, 512, 549, 550, 560, 561, 562, 564],
  [0, 483, 512, 570, 571, 572, 573, 574, 575],
  [0, 483, 512, 570, 571, 572, 573, 574, 576],
  [0, 483, 512, 570, 571, 572, 573, 574, 577],
  [0, 483, 512, 570, 571, 572, 573, 574, 578],
  [0, 483, 512, 570, 571, 572, 581, 582, 583],
  [0, 483, 512, 570, 571, 572, 581, 582, 584],
  [0, 483, 512, 570, 571, 572, 586, 589, 590],
  [0, 483, 512, 570, 571, 572, 586, 589, 591],
  [0, 595, 596, 598, 599, 600, 601, 603, 604],
  [0, 595, 596, 598, 599, 600, 601, 603, 605],
  [0, 595, 626, 627, 628, 629, 630, 631, 632],
  [0, 595, 626, 627, 628, 629, 630, 631, 633],
  [0, 595, 626, 627, 628, 629, 630, 631, 634],
  [0, 595, 626, 627, 628, 629, 630, 636, 637],
  [0, 595, 626, 627, 628, 629, 630, 636, 638],
  [0, 595, 626, 627, 628, 629, 630, 636, 639],
  [0, 595, 626, 627, 642, 643, 644, 646, 647],
  [0, 595, 626, 627, 642, 643, 644, 646, 648],
  [0, 595, 626, 627, 642, 649, 655, 656, 657],
  [0, 595, 626, 627, 642, 649, 655, 656, 658],
  [0, 595, 626, 627, 642, 649, 655, 656, 659],
  [0, 595, 626, 627, 642, 649, 660, 663, 664],
  [0, 595, 626, 627, 642, 649, 660, 663, 665],
  [0, 595, 626, 627, 642, 649, 660, 663, 666],
  [0, 1, 2, 4, 5, 6, 7, 8],
  [0, 1, 2, 4, 5, 6, 7, 9],
  [0, 1, 2, 4, 5, 22, 23, 26],
  [0, 1, 2, 4, 5, 22, 23, 27],
  [0, 1, 2, 4, 36, 42, 43, 44],
  [0, 1, 2, 4, 36, 42, 43, 45],
  [0, 1, 2, 4, 36, 42, 43, 46],
  [0, 1, 2, 4, 36, 42, 43, 47],
  [0, 1, 50, 51, 52, 53, 54, 55],
  [0, 1, 50, 51, 52, 53, 61, 70],
  [0, 1, 50, 51, 52, 71, 72, 73],
  [0, 1, 50, 51, 52, 71, 72, 78],
  [0, 1, 50, 51, 81, 82, 83, 84],
  [0, 1, 50, 51, 81, 82, 83, 85],
  [0, 1, 50, 51, 81, 82, 83, 88],
  [0, 1, 50, 51, 97, 98, 99, 100],
  [0, 1, 50, 51, 97, 98, 99, 101],
  [0, 1, 50, 51, 97, 98, 99, 102],
  [0, 1, 50, 51, 97, 107, 108, 111],
  [0, 1, 50, 51, 97, 107, 108, 112],
  [0, 1, 50, 51, 97, 119, 120, 121],
  [0, 1, 50, 51, 97, 119, 125, 131],
  [0, 1, 50, 132, 133, 135, 136, 137],
  [0, 1, 50, 132, 133, 135, 136, 138],
  [0, 1, 50, 132, 133, 135, 136, 143],
  [0, 1, 50, 132, 151, 152, 153, 154],
  [0, 1, 50, 132, 151, 152, 153, 155],
  [0, 1, 50, 158, 159, 161, 162, 163],
  [0, 1, 50, 158, 159, 161, 162, 168],
  [0, 1, 50, 158, 159, 161, 169, 170],
  [0, 1, 50, 158, 159, 161, 169, 171],
  [0, 1, 50, 158, 159, 161, 172, 176],
  [0, 1, 50, 158, 159, 161, 177, 180],
  [0, 1, 50, 158, 185, 186, 187, 188],
  [0, 1, 50, 158, 185, 191, 192, 193],
  [0, 1, 50, 158, 185, 191, 192, 196],
  [0, 1, 50, 158, 185, 210, 211, 212],
  [0, 1, 50, 158, 185, 210, 216, 219],
  [0, 1, 220, 225, 226, 227, 228, 231],
  [0, 1, 235, 238, 239, 241, 242, 245],
  [0, 249, 250, 251, 256, 257, 258, 262],
  [0, 249, 268, 269, 270, 278, 281, 282],
  [0, 249, 268, 269, 270, 278, 281, 283],
  [0, 249, 268, 269, 270, 284, 285, 289],
  [0, 249, 268, 269, 292, 297, 298, 303],
  [0, 249, 268, 269, 292, 314, 315, 321],
  [0, 249, 268, 269, 292, 314, 315, 322],
  [0, 249, 268, 323, 325, 326, 327, 332],
  [0, 249, 268, 323, 325, 326, 336, 339],
  [0, 249, 345, 348, 349, 350, 351, 352],
  [0, 358, 378, 379, 380, 381, 382, 383],
  [0, 358, 378, 379, 390, 391, 394, 395],
  [0, 358, 378, 379, 390, 399, 400, 401],
  [0, 358, 415, 431, 432, 433, 434, 437],
  [0, 358, 415, 431, 432, 438, 439, 440],
  [0, 358, 415, 431, 432, 438, 439, 441],
  [0, 358, 415, 431, 432, 438, 439, 444],
  [0, 358, 415, 431, 432, 445, 446, 452],
  [0, 358, 415, 431, 432, 445, 446, 453],
  [0, 358, 415, 431, 432, 469, 470, 471],
  [0, 358, 415, 431, 432, 469, 470, 472],
  [0, 358, 415, 431, 432, 469, 473, 479],
  [0, 358, 415, 431, 432, 469, 473, 480],
  [0, 483, 512, 513, 522, 532, 533, 534],
  [0, 483, 512, 513, 522, 532, 533, 541],
  [0, 483, 512, 513, 542, 544, 545, 548],
  [0, 483, 512, 549, 550, 560, 561, 567],
  [0, 483, 512, 549, 550, 560, 561, 568],
  [0, 483, 512, 549, 550, 560, 561, 569],
  [0, 483, 512, 570, 571, 572, 573, 579],
  [0, 483, 512, 570, 571, 572, 573, 580],
  [0, 483, 512, 570, 571, 572, 581, 585],
  [0, 483, 512, 570, 571, 572, 586, 592],
  [0, 595, 596, 598, 599, 600, 601, 602],
  [0, 595, 596, 598, 599, 600, 606, 609],
  [0, 595, 596, 598, 599, 600, 606, 610],
  [0, 595, 596, 598, 599, 600, 606, 611],
  [0, 595, 596, 598, 599, 600, 612, 615],
  [0, 595, 596, 616, 617, 618, 619, 620],
  [0, 595, 596, 616, 617, 618, 619, 621],
  [0, 595, 596, 616, 617, 618, 619, 622],
  [0, 595, 626, 627, 628, 629, 630, 635],
  [0, 595, 626, 627, 628, 629, 630, 640],
  [0, 595, 626, 627, 642, 643, 644, 645],
  [0, 595, 626, 627, 642, 649, 650, 653],
  [0, 595, 626, 627, 642, 649, 650, 654],
  [0, 595, 626, 627, 642, 649, 660, 661],
  [0, 595, 626, 627, 642, 649, 660, 662],
  [0, 595, 626, 667, 668, 670, 671, 672],
  [0, 595, 626, 667, 668, 670, 671, 673],
  [0, 595, 626, 667, 668, 670, 671, 674],
  [0, 1, 2, 4, 5, 35],
  [0, 1, 2, 4, 36, 41],
  [0, 1, 50, 51, 52, 79],
  [0, 1, 50, 51, 52, 80],
  [0, 1, 50, 51, 97, 106],
  [0, 1, 50, 51, 97, 118],
  [0, 1, 50, 132, 133, 134],
]

/** Node indices that participate in at least one chain. */
export const STATIC_BLINK_CUBE_INDICES: number[] = [
  0, 1, 2, 4, 5, 30, 31, 32, 33, 34, 50, 51, 52, 53, 54, 56, 57, 58, 61, 64, 65,
  66, 67, 68, 69, 71, 72, 74, 75, 76, 77, 81, 82, 89, 94, 95, 96, 97, 98, 99,
  103, 104, 105, 119, 120, 122, 123, 124, 125, 126, 127, 128, 132, 133, 135,
  136, 139, 140, 141, 142, 158, 159, 161, 172, 173, 174, 175, 177, 181, 182,
  183, 185, 191, 197, 198, 199, 200, 210, 211, 213, 214, 215, 249, 250, 251,
  256, 257, 258, 259, 260, 261, 268, 269, 270, 271, 272, 273, 274, 275, 284,
  285, 286, 287, 288, 292, 304, 305, 306, 307, 308, 311, 312, 313, 314, 315,
  318, 319, 320, 323, 325, 326, 327, 333, 334, 335, 358, 378, 379, 380, 381,
  382, 384, 385, 386, 387, 388, 389, 390, 391, 394, 396, 397, 398, 415, 431,
  432, 445, 446, 447, 448, 449, 456, 457, 458, 459, 460, 461, 462, 465, 466,
  467, 468, 469, 473, 474, 475, 476, 477, 478, 483, 484, 486, 487, 489, 490,
  493, 494, 495, 497, 498, 499, 504, 505, 506, 512, 513, 522, 524, 525, 526,
  527, 528, 529, 532, 533, 535, 536, 537, 538, 539, 540, 549, 550, 551, 552,
  553, 554, 555, 560, 561, 562, 563, 564, 570, 571, 572, 573, 574, 575, 576,
  577, 578, 581, 582, 583, 584, 586, 589, 590, 591, 595, 596, 598, 599, 600,
  601, 603, 604, 605, 626, 627, 628, 629, 630, 631, 632, 633, 634, 636, 637,
  638, 639, 642, 643, 644, 646, 647, 648, 649, 655, 656, 657, 658, 659, 660,
  663, 664, 665, 666, 6, 7, 8, 9, 22, 23, 26, 27, 36, 42, 43, 44, 45, 46, 47,
  55, 70, 73, 78, 83, 84, 85, 88, 100, 101, 102, 107, 108, 111, 112, 121, 131,
  137, 138, 143, 151, 152, 153, 154, 155, 162, 163, 168, 169, 170, 171, 176,
  180, 186, 187, 188, 192, 193, 196, 212, 216, 219, 220, 225, 226, 227, 228,
  231, 235, 238, 239, 241, 242, 245, 262, 278, 281, 282, 283, 289, 297, 298,
  303, 321, 322, 332, 336, 339, 345, 348, 349, 350, 351, 352, 383, 395, 399,
  400, 401, 433, 434, 437, 438, 439, 440, 441, 444, 452, 453, 470, 471, 472,
  479, 480, 534, 541, 542, 544, 545, 548, 567, 568, 569, 579, 580, 585, 592,
  602, 606, 609, 610, 611, 612, 615, 616, 617, 618, 619, 620, 621, 622, 635,
  640, 645, 650, 653, 654, 661, 662, 667, 668, 670, 671, 672, 673, 674, 35, 41,
  79, 80, 106, 118, 134,
]

/** cubeIdx → [{chainIdx, pos}] — which chains pass through each node and at what position. */
export const STATIC_CUBE_TO_CHAIN_POS: Array<
  [number, Array<{ chainIdx: number; pos: number }>]
> = [
  [
    0,
    [
      { chainIdx: 0, pos: 0 },
      { chainIdx: 1, pos: 0 },
      { chainIdx: 2, pos: 0 },
      { chainIdx: 3, pos: 0 },
      { chainIdx: 4, pos: 0 },
      { chainIdx: 5, pos: 0 },
      { chainIdx: 6, pos: 0 },
      { chainIdx: 7, pos: 0 },
      { chainIdx: 8, pos: 0 },
      { chainIdx: 9, pos: 0 },
      { chainIdx: 10, pos: 0 },
      { chainIdx: 11, pos: 0 },
      { chainIdx: 12, pos: 0 },
      { chainIdx: 13, pos: 0 },
      { chainIdx: 14, pos: 0 },
      { chainIdx: 15, pos: 0 },
      { chainIdx: 16, pos: 0 },
      { chainIdx: 17, pos: 0 },
      { chainIdx: 18, pos: 0 },
      { chainIdx: 19, pos: 0 },
      { chainIdx: 20, pos: 0 },
      { chainIdx: 21, pos: 0 },
      { chainIdx: 22, pos: 0 },
      { chainIdx: 23, pos: 0 },
      { chainIdx: 24, pos: 0 },
      { chainIdx: 25, pos: 0 },
      { chainIdx: 26, pos: 0 },
      { chainIdx: 27, pos: 0 },
      { chainIdx: 28, pos: 0 },
      { chainIdx: 29, pos: 0 },
      { chainIdx: 30, pos: 0 },
      { chainIdx: 31, pos: 0 },
      { chainIdx: 32, pos: 0 },
      { chainIdx: 33, pos: 0 },
      { chainIdx: 34, pos: 0 },
      { chainIdx: 35, pos: 0 },
      { chainIdx: 36, pos: 0 },
      { chainIdx: 37, pos: 0 },
      { chainIdx: 38, pos: 0 },
      { chainIdx: 39, pos: 0 },
      { chainIdx: 40, pos: 0 },
      { chainIdx: 41, pos: 0 },
      { chainIdx: 42, pos: 0 },
      { chainIdx: 43, pos: 0 },
      { chainIdx: 44, pos: 0 },
      { chainIdx: 45, pos: 0 },
      { chainIdx: 46, pos: 0 },
      { chainIdx: 47, pos: 0 },
      { chainIdx: 48, pos: 0 },
      { chainIdx: 49, pos: 0 },
      { chainIdx: 50, pos: 0 },
      { chainIdx: 51, pos: 0 },
      { chainIdx: 52, pos: 0 },
      { chainIdx: 53, pos: 0 },
      { chainIdx: 54, pos: 0 },
      { chainIdx: 55, pos: 0 },
      { chainIdx: 56, pos: 0 },
      { chainIdx: 57, pos: 0 },
      { chainIdx: 58, pos: 0 },
      { chainIdx: 59, pos: 0 },
      { chainIdx: 60, pos: 0 },
      { chainIdx: 61, pos: 0 },
      { chainIdx: 62, pos: 0 },
      { chainIdx: 63, pos: 0 },
      { chainIdx: 64, pos: 0 },
      { chainIdx: 65, pos: 0 },
      { chainIdx: 66, pos: 0 },
      { chainIdx: 67, pos: 0 },
      { chainIdx: 68, pos: 0 },
      { chainIdx: 69, pos: 0 },
      { chainIdx: 70, pos: 0 },
      { chainIdx: 71, pos: 0 },
      { chainIdx: 72, pos: 0 },
      { chainIdx: 73, pos: 0 },
      { chainIdx: 74, pos: 0 },
      { chainIdx: 75, pos: 0 },
      { chainIdx: 76, pos: 0 },
      { chainIdx: 77, pos: 0 },
      { chainIdx: 78, pos: 0 },
      { chainIdx: 79, pos: 0 },
      { chainIdx: 80, pos: 0 },
      { chainIdx: 81, pos: 0 },
      { chainIdx: 82, pos: 0 },
      { chainIdx: 83, pos: 0 },
      { chainIdx: 84, pos: 0 },
      { chainIdx: 85, pos: 0 },
      { chainIdx: 86, pos: 0 },
      { chainIdx: 87, pos: 0 },
      { chainIdx: 88, pos: 0 },
      { chainIdx: 89, pos: 0 },
      { chainIdx: 90, pos: 0 },
      { chainIdx: 91, pos: 0 },
      { chainIdx: 92, pos: 0 },
      { chainIdx: 93, pos: 0 },
      { chainIdx: 94, pos: 0 },
      { chainIdx: 95, pos: 0 },
      { chainIdx: 96, pos: 0 },
      { chainIdx: 97, pos: 0 },
      { chainIdx: 98, pos: 0 },
      { chainIdx: 99, pos: 0 },
      { chainIdx: 100, pos: 0 },
      { chainIdx: 101, pos: 0 },
      { chainIdx: 102, pos: 0 },
      { chainIdx: 103, pos: 0 },
      { chainIdx: 104, pos: 0 },
      { chainIdx: 105, pos: 0 },
      { chainIdx: 106, pos: 0 },
      { chainIdx: 107, pos: 0 },
      { chainIdx: 108, pos: 0 },
      { chainIdx: 109, pos: 0 },
      { chainIdx: 110, pos: 0 },
      { chainIdx: 111, pos: 0 },
      { chainIdx: 112, pos: 0 },
      { chainIdx: 113, pos: 0 },
      { chainIdx: 114, pos: 0 },
      { chainIdx: 115, pos: 0 },
      { chainIdx: 116, pos: 0 },
      { chainIdx: 117, pos: 0 },
      { chainIdx: 118, pos: 0 },
      { chainIdx: 119, pos: 0 },
      { chainIdx: 120, pos: 0 },
      { chainIdx: 121, pos: 0 },
      { chainIdx: 122, pos: 0 },
      { chainIdx: 123, pos: 0 },
      { chainIdx: 124, pos: 0 },
      { chainIdx: 125, pos: 0 },
      { chainIdx: 126, pos: 0 },
      { chainIdx: 127, pos: 0 },
      { chainIdx: 128, pos: 0 },
      { chainIdx: 129, pos: 0 },
      { chainIdx: 130, pos: 0 },
      { chainIdx: 131, pos: 0 },
      { chainIdx: 132, pos: 0 },
      { chainIdx: 133, pos: 0 },
      { chainIdx: 134, pos: 0 },
      { chainIdx: 135, pos: 0 },
      { chainIdx: 136, pos: 0 },
      { chainIdx: 137, pos: 0 },
      { chainIdx: 138, pos: 0 },
      { chainIdx: 139, pos: 0 },
      { chainIdx: 140, pos: 0 },
      { chainIdx: 141, pos: 0 },
      { chainIdx: 142, pos: 0 },
      { chainIdx: 143, pos: 0 },
      { chainIdx: 144, pos: 0 },
      { chainIdx: 145, pos: 0 },
      { chainIdx: 146, pos: 0 },
      { chainIdx: 147, pos: 0 },
      { chainIdx: 148, pos: 0 },
      { chainIdx: 149, pos: 0 },
      { chainIdx: 150, pos: 0 },
      { chainIdx: 151, pos: 0 },
      { chainIdx: 152, pos: 0 },
      { chainIdx: 153, pos: 0 },
      { chainIdx: 154, pos: 0 },
      { chainIdx: 155, pos: 0 },
      { chainIdx: 156, pos: 0 },
      { chainIdx: 157, pos: 0 },
      { chainIdx: 158, pos: 0 },
      { chainIdx: 159, pos: 0 },
      { chainIdx: 160, pos: 0 },
      { chainIdx: 161, pos: 0 },
      { chainIdx: 162, pos: 0 },
      { chainIdx: 163, pos: 0 },
      { chainIdx: 164, pos: 0 },
      { chainIdx: 165, pos: 0 },
      { chainIdx: 166, pos: 0 },
      { chainIdx: 167, pos: 0 },
      { chainIdx: 168, pos: 0 },
      { chainIdx: 169, pos: 0 },
      { chainIdx: 170, pos: 0 },
      { chainIdx: 171, pos: 0 },
      { chainIdx: 172, pos: 0 },
      { chainIdx: 173, pos: 0 },
      { chainIdx: 174, pos: 0 },
      { chainIdx: 175, pos: 0 },
      { chainIdx: 176, pos: 0 },
      { chainIdx: 177, pos: 0 },
      { chainIdx: 178, pos: 0 },
      { chainIdx: 179, pos: 0 },
      { chainIdx: 180, pos: 0 },
      { chainIdx: 181, pos: 0 },
      { chainIdx: 182, pos: 0 },
      { chainIdx: 183, pos: 0 },
      { chainIdx: 184, pos: 0 },
      { chainIdx: 185, pos: 0 },
      { chainIdx: 186, pos: 0 },
      { chainIdx: 187, pos: 0 },
      { chainIdx: 188, pos: 0 },
      { chainIdx: 189, pos: 0 },
      { chainIdx: 190, pos: 0 },
      { chainIdx: 191, pos: 0 },
      { chainIdx: 192, pos: 0 },
      { chainIdx: 193, pos: 0 },
      { chainIdx: 194, pos: 0 },
      { chainIdx: 195, pos: 0 },
      { chainIdx: 196, pos: 0 },
      { chainIdx: 197, pos: 0 },
      { chainIdx: 198, pos: 0 },
      { chainIdx: 199, pos: 0 },
    ],
  ],
  [
    1,
    [
      { chainIdx: 0, pos: 1 },
      { chainIdx: 1, pos: 1 },
      { chainIdx: 2, pos: 1 },
      { chainIdx: 3, pos: 1 },
      { chainIdx: 4, pos: 1 },
      { chainIdx: 5, pos: 1 },
      { chainIdx: 6, pos: 1 },
      { chainIdx: 7, pos: 1 },
      { chainIdx: 8, pos: 1 },
      { chainIdx: 9, pos: 1 },
      { chainIdx: 10, pos: 1 },
      { chainIdx: 11, pos: 1 },
      { chainIdx: 12, pos: 1 },
      { chainIdx: 13, pos: 1 },
      { chainIdx: 14, pos: 1 },
      { chainIdx: 15, pos: 1 },
      { chainIdx: 16, pos: 1 },
      { chainIdx: 17, pos: 1 },
      { chainIdx: 18, pos: 1 },
      { chainIdx: 19, pos: 1 },
      { chainIdx: 20, pos: 1 },
      { chainIdx: 21, pos: 1 },
      { chainIdx: 22, pos: 1 },
      { chainIdx: 23, pos: 1 },
      { chainIdx: 24, pos: 1 },
      { chainIdx: 25, pos: 1 },
      { chainIdx: 26, pos: 1 },
      { chainIdx: 27, pos: 1 },
      { chainIdx: 28, pos: 1 },
      { chainIdx: 29, pos: 1 },
      { chainIdx: 102, pos: 1 },
      { chainIdx: 103, pos: 1 },
      { chainIdx: 104, pos: 1 },
      { chainIdx: 105, pos: 1 },
      { chainIdx: 106, pos: 1 },
      { chainIdx: 107, pos: 1 },
      { chainIdx: 108, pos: 1 },
      { chainIdx: 109, pos: 1 },
      { chainIdx: 110, pos: 1 },
      { chainIdx: 111, pos: 1 },
      { chainIdx: 112, pos: 1 },
      { chainIdx: 113, pos: 1 },
      { chainIdx: 114, pos: 1 },
      { chainIdx: 115, pos: 1 },
      { chainIdx: 116, pos: 1 },
      { chainIdx: 117, pos: 1 },
      { chainIdx: 118, pos: 1 },
      { chainIdx: 119, pos: 1 },
      { chainIdx: 120, pos: 1 },
      { chainIdx: 121, pos: 1 },
      { chainIdx: 122, pos: 1 },
      { chainIdx: 123, pos: 1 },
      { chainIdx: 124, pos: 1 },
      { chainIdx: 125, pos: 1 },
      { chainIdx: 126, pos: 1 },
      { chainIdx: 127, pos: 1 },
      { chainIdx: 128, pos: 1 },
      { chainIdx: 129, pos: 1 },
      { chainIdx: 130, pos: 1 },
      { chainIdx: 131, pos: 1 },
      { chainIdx: 132, pos: 1 },
      { chainIdx: 133, pos: 1 },
      { chainIdx: 134, pos: 1 },
      { chainIdx: 135, pos: 1 },
      { chainIdx: 136, pos: 1 },
      { chainIdx: 137, pos: 1 },
      { chainIdx: 138, pos: 1 },
      { chainIdx: 139, pos: 1 },
      { chainIdx: 140, pos: 1 },
      { chainIdx: 141, pos: 1 },
      { chainIdx: 193, pos: 1 },
      { chainIdx: 194, pos: 1 },
      { chainIdx: 195, pos: 1 },
      { chainIdx: 196, pos: 1 },
      { chainIdx: 197, pos: 1 },
      { chainIdx: 198, pos: 1 },
      { chainIdx: 199, pos: 1 },
    ],
  ],
  [
    2,
    [
      { chainIdx: 0, pos: 2 },
      { chainIdx: 1, pos: 2 },
      { chainIdx: 102, pos: 2 },
      { chainIdx: 103, pos: 2 },
      { chainIdx: 104, pos: 2 },
      { chainIdx: 105, pos: 2 },
      { chainIdx: 106, pos: 2 },
      { chainIdx: 107, pos: 2 },
      { chainIdx: 108, pos: 2 },
      { chainIdx: 109, pos: 2 },
      { chainIdx: 193, pos: 2 },
      { chainIdx: 194, pos: 2 },
    ],
  ],
  [
    4,
    [
      { chainIdx: 0, pos: 3 },
      { chainIdx: 1, pos: 3 },
      { chainIdx: 102, pos: 3 },
      { chainIdx: 103, pos: 3 },
      { chainIdx: 104, pos: 3 },
      { chainIdx: 105, pos: 3 },
      { chainIdx: 106, pos: 3 },
      { chainIdx: 107, pos: 3 },
      { chainIdx: 108, pos: 3 },
      { chainIdx: 109, pos: 3 },
      { chainIdx: 193, pos: 3 },
      { chainIdx: 194, pos: 3 },
    ],
  ],
  [
    5,
    [
      { chainIdx: 0, pos: 4 },
      { chainIdx: 1, pos: 4 },
      { chainIdx: 102, pos: 4 },
      { chainIdx: 103, pos: 4 },
      { chainIdx: 104, pos: 4 },
      { chainIdx: 105, pos: 4 },
      { chainIdx: 193, pos: 4 },
    ],
  ],
  [
    30,
    [
      { chainIdx: 0, pos: 5 },
      { chainIdx: 1, pos: 5 },
    ],
  ],
  [
    31,
    [
      { chainIdx: 0, pos: 6 },
      { chainIdx: 1, pos: 6 },
    ],
  ],
  [
    32,
    [
      { chainIdx: 0, pos: 7 },
      { chainIdx: 1, pos: 7 },
    ],
  ],
  [33, [{ chainIdx: 0, pos: 8 }]],
  [34, [{ chainIdx: 1, pos: 8 }]],
  [
    50,
    [
      { chainIdx: 2, pos: 2 },
      { chainIdx: 3, pos: 2 },
      { chainIdx: 4, pos: 2 },
      { chainIdx: 5, pos: 2 },
      { chainIdx: 6, pos: 2 },
      { chainIdx: 7, pos: 2 },
      { chainIdx: 8, pos: 2 },
      { chainIdx: 9, pos: 2 },
      { chainIdx: 10, pos: 2 },
      { chainIdx: 11, pos: 2 },
      { chainIdx: 12, pos: 2 },
      { chainIdx: 13, pos: 2 },
      { chainIdx: 14, pos: 2 },
      { chainIdx: 15, pos: 2 },
      { chainIdx: 16, pos: 2 },
      { chainIdx: 17, pos: 2 },
      { chainIdx: 18, pos: 2 },
      { chainIdx: 19, pos: 2 },
      { chainIdx: 20, pos: 2 },
      { chainIdx: 21, pos: 2 },
      { chainIdx: 22, pos: 2 },
      { chainIdx: 23, pos: 2 },
      { chainIdx: 24, pos: 2 },
      { chainIdx: 25, pos: 2 },
      { chainIdx: 26, pos: 2 },
      { chainIdx: 27, pos: 2 },
      { chainIdx: 28, pos: 2 },
      { chainIdx: 29, pos: 2 },
      { chainIdx: 110, pos: 2 },
      { chainIdx: 111, pos: 2 },
      { chainIdx: 112, pos: 2 },
      { chainIdx: 113, pos: 2 },
      { chainIdx: 114, pos: 2 },
      { chainIdx: 115, pos: 2 },
      { chainIdx: 116, pos: 2 },
      { chainIdx: 117, pos: 2 },
      { chainIdx: 118, pos: 2 },
      { chainIdx: 119, pos: 2 },
      { chainIdx: 120, pos: 2 },
      { chainIdx: 121, pos: 2 },
      { chainIdx: 122, pos: 2 },
      { chainIdx: 123, pos: 2 },
      { chainIdx: 124, pos: 2 },
      { chainIdx: 125, pos: 2 },
      { chainIdx: 126, pos: 2 },
      { chainIdx: 127, pos: 2 },
      { chainIdx: 128, pos: 2 },
      { chainIdx: 129, pos: 2 },
      { chainIdx: 130, pos: 2 },
      { chainIdx: 131, pos: 2 },
      { chainIdx: 132, pos: 2 },
      { chainIdx: 133, pos: 2 },
      { chainIdx: 134, pos: 2 },
      { chainIdx: 135, pos: 2 },
      { chainIdx: 136, pos: 2 },
      { chainIdx: 137, pos: 2 },
      { chainIdx: 138, pos: 2 },
      { chainIdx: 139, pos: 2 },
      { chainIdx: 195, pos: 2 },
      { chainIdx: 196, pos: 2 },
      { chainIdx: 197, pos: 2 },
      { chainIdx: 198, pos: 2 },
      { chainIdx: 199, pos: 2 },
    ],
  ],
  [
    51,
    [
      { chainIdx: 2, pos: 3 },
      { chainIdx: 3, pos: 3 },
      { chainIdx: 4, pos: 3 },
      { chainIdx: 5, pos: 3 },
      { chainIdx: 6, pos: 3 },
      { chainIdx: 7, pos: 3 },
      { chainIdx: 8, pos: 3 },
      { chainIdx: 9, pos: 3 },
      { chainIdx: 10, pos: 3 },
      { chainIdx: 11, pos: 3 },
      { chainIdx: 12, pos: 3 },
      { chainIdx: 13, pos: 3 },
      { chainIdx: 14, pos: 3 },
      { chainIdx: 15, pos: 3 },
      { chainIdx: 16, pos: 3 },
      { chainIdx: 17, pos: 3 },
      { chainIdx: 18, pos: 3 },
      { chainIdx: 110, pos: 3 },
      { chainIdx: 111, pos: 3 },
      { chainIdx: 112, pos: 3 },
      { chainIdx: 113, pos: 3 },
      { chainIdx: 114, pos: 3 },
      { chainIdx: 115, pos: 3 },
      { chainIdx: 116, pos: 3 },
      { chainIdx: 117, pos: 3 },
      { chainIdx: 118, pos: 3 },
      { chainIdx: 119, pos: 3 },
      { chainIdx: 120, pos: 3 },
      { chainIdx: 121, pos: 3 },
      { chainIdx: 122, pos: 3 },
      { chainIdx: 123, pos: 3 },
      { chainIdx: 195, pos: 3 },
      { chainIdx: 196, pos: 3 },
      { chainIdx: 197, pos: 3 },
      { chainIdx: 198, pos: 3 },
    ],
  ],
  [
    52,
    [
      { chainIdx: 2, pos: 4 },
      { chainIdx: 3, pos: 4 },
      { chainIdx: 4, pos: 4 },
      { chainIdx: 5, pos: 4 },
      { chainIdx: 6, pos: 4 },
      { chainIdx: 7, pos: 4 },
      { chainIdx: 8, pos: 4 },
      { chainIdx: 9, pos: 4 },
      { chainIdx: 10, pos: 4 },
      { chainIdx: 110, pos: 4 },
      { chainIdx: 111, pos: 4 },
      { chainIdx: 112, pos: 4 },
      { chainIdx: 113, pos: 4 },
      { chainIdx: 195, pos: 4 },
      { chainIdx: 196, pos: 4 },
    ],
  ],
  [
    53,
    [
      { chainIdx: 2, pos: 5 },
      { chainIdx: 3, pos: 5 },
      { chainIdx: 4, pos: 5 },
      { chainIdx: 5, pos: 5 },
      { chainIdx: 6, pos: 5 },
      { chainIdx: 7, pos: 5 },
      { chainIdx: 110, pos: 5 },
      { chainIdx: 111, pos: 5 },
    ],
  ],
  [
    54,
    [
      { chainIdx: 2, pos: 6 },
      { chainIdx: 3, pos: 6 },
      { chainIdx: 110, pos: 6 },
    ],
  ],
  [
    56,
    [
      { chainIdx: 2, pos: 7 },
      { chainIdx: 3, pos: 7 },
    ],
  ],
  [57, [{ chainIdx: 2, pos: 8 }]],
  [58, [{ chainIdx: 3, pos: 8 }]],
  [
    61,
    [
      { chainIdx: 4, pos: 6 },
      { chainIdx: 5, pos: 6 },
      { chainIdx: 6, pos: 6 },
      { chainIdx: 7, pos: 6 },
      { chainIdx: 111, pos: 6 },
    ],
  ],
  [
    64,
    [
      { chainIdx: 4, pos: 7 },
      { chainIdx: 5, pos: 7 },
    ],
  ],
  [65, [{ chainIdx: 4, pos: 8 }]],
  [66, [{ chainIdx: 5, pos: 8 }]],
  [
    67,
    [
      { chainIdx: 6, pos: 7 },
      { chainIdx: 7, pos: 7 },
    ],
  ],
  [68, [{ chainIdx: 6, pos: 8 }]],
  [69, [{ chainIdx: 7, pos: 8 }]],
  [
    71,
    [
      { chainIdx: 8, pos: 5 },
      { chainIdx: 9, pos: 5 },
      { chainIdx: 10, pos: 5 },
      { chainIdx: 112, pos: 5 },
      { chainIdx: 113, pos: 5 },
    ],
  ],
  [
    72,
    [
      { chainIdx: 8, pos: 6 },
      { chainIdx: 9, pos: 6 },
      { chainIdx: 10, pos: 6 },
      { chainIdx: 112, pos: 6 },
      { chainIdx: 113, pos: 6 },
    ],
  ],
  [
    74,
    [
      { chainIdx: 8, pos: 7 },
      { chainIdx: 9, pos: 7 },
      { chainIdx: 10, pos: 7 },
    ],
  ],
  [75, [{ chainIdx: 8, pos: 8 }]],
  [76, [{ chainIdx: 9, pos: 8 }]],
  [77, [{ chainIdx: 10, pos: 8 }]],
  [
    81,
    [
      { chainIdx: 11, pos: 4 },
      { chainIdx: 12, pos: 4 },
      { chainIdx: 114, pos: 4 },
      { chainIdx: 115, pos: 4 },
      { chainIdx: 116, pos: 4 },
    ],
  ],
  [
    82,
    [
      { chainIdx: 11, pos: 5 },
      { chainIdx: 12, pos: 5 },
      { chainIdx: 114, pos: 5 },
      { chainIdx: 115, pos: 5 },
      { chainIdx: 116, pos: 5 },
    ],
  ],
  [
    89,
    [
      { chainIdx: 11, pos: 6 },
      { chainIdx: 12, pos: 6 },
    ],
  ],
  [
    94,
    [
      { chainIdx: 11, pos: 7 },
      { chainIdx: 12, pos: 7 },
    ],
  ],
  [95, [{ chainIdx: 11, pos: 8 }]],
  [96, [{ chainIdx: 12, pos: 8 }]],
  [
    97,
    [
      { chainIdx: 13, pos: 4 },
      { chainIdx: 14, pos: 4 },
      { chainIdx: 15, pos: 4 },
      { chainIdx: 16, pos: 4 },
      { chainIdx: 17, pos: 4 },
      { chainIdx: 18, pos: 4 },
      { chainIdx: 117, pos: 4 },
      { chainIdx: 118, pos: 4 },
      { chainIdx: 119, pos: 4 },
      { chainIdx: 120, pos: 4 },
      { chainIdx: 121, pos: 4 },
      { chainIdx: 122, pos: 4 },
      { chainIdx: 123, pos: 4 },
      { chainIdx: 197, pos: 4 },
      { chainIdx: 198, pos: 4 },
    ],
  ],
  [
    98,
    [
      { chainIdx: 13, pos: 5 },
      { chainIdx: 14, pos: 5 },
      { chainIdx: 117, pos: 5 },
      { chainIdx: 118, pos: 5 },
      { chainIdx: 119, pos: 5 },
    ],
  ],
  [
    99,
    [
      { chainIdx: 13, pos: 6 },
      { chainIdx: 14, pos: 6 },
      { chainIdx: 117, pos: 6 },
      { chainIdx: 118, pos: 6 },
      { chainIdx: 119, pos: 6 },
    ],
  ],
  [
    103,
    [
      { chainIdx: 13, pos: 7 },
      { chainIdx: 14, pos: 7 },
    ],
  ],
  [104, [{ chainIdx: 13, pos: 8 }]],
  [105, [{ chainIdx: 14, pos: 8 }]],
  [
    119,
    [
      { chainIdx: 15, pos: 5 },
      { chainIdx: 16, pos: 5 },
      { chainIdx: 17, pos: 5 },
      { chainIdx: 18, pos: 5 },
      { chainIdx: 122, pos: 5 },
      { chainIdx: 123, pos: 5 },
    ],
  ],
  [
    120,
    [
      { chainIdx: 15, pos: 6 },
      { chainIdx: 16, pos: 6 },
      { chainIdx: 122, pos: 6 },
    ],
  ],
  [
    122,
    [
      { chainIdx: 15, pos: 7 },
      { chainIdx: 16, pos: 7 },
    ],
  ],
  [123, [{ chainIdx: 15, pos: 8 }]],
  [124, [{ chainIdx: 16, pos: 8 }]],
  [
    125,
    [
      { chainIdx: 17, pos: 6 },
      { chainIdx: 18, pos: 6 },
      { chainIdx: 123, pos: 6 },
    ],
  ],
  [
    126,
    [
      { chainIdx: 17, pos: 7 },
      { chainIdx: 18, pos: 7 },
    ],
  ],
  [127, [{ chainIdx: 17, pos: 8 }]],
  [128, [{ chainIdx: 18, pos: 8 }]],
  [
    132,
    [
      { chainIdx: 19, pos: 3 },
      { chainIdx: 20, pos: 3 },
      { chainIdx: 21, pos: 3 },
      { chainIdx: 124, pos: 3 },
      { chainIdx: 125, pos: 3 },
      { chainIdx: 126, pos: 3 },
      { chainIdx: 127, pos: 3 },
      { chainIdx: 128, pos: 3 },
      { chainIdx: 199, pos: 3 },
    ],
  ],
  [
    133,
    [
      { chainIdx: 19, pos: 4 },
      { chainIdx: 20, pos: 4 },
      { chainIdx: 21, pos: 4 },
      { chainIdx: 124, pos: 4 },
      { chainIdx: 125, pos: 4 },
      { chainIdx: 126, pos: 4 },
      { chainIdx: 199, pos: 4 },
    ],
  ],
  [
    135,
    [
      { chainIdx: 19, pos: 5 },
      { chainIdx: 20, pos: 5 },
      { chainIdx: 21, pos: 5 },
      { chainIdx: 124, pos: 5 },
      { chainIdx: 125, pos: 5 },
      { chainIdx: 126, pos: 5 },
    ],
  ],
  [
    136,
    [
      { chainIdx: 19, pos: 6 },
      { chainIdx: 20, pos: 6 },
      { chainIdx: 21, pos: 6 },
      { chainIdx: 124, pos: 6 },
      { chainIdx: 125, pos: 6 },
      { chainIdx: 126, pos: 6 },
    ],
  ],
  [
    139,
    [
      { chainIdx: 19, pos: 7 },
      { chainIdx: 20, pos: 7 },
      { chainIdx: 21, pos: 7 },
    ],
  ],
  [140, [{ chainIdx: 19, pos: 8 }]],
  [141, [{ chainIdx: 20, pos: 8 }]],
  [142, [{ chainIdx: 21, pos: 8 }]],
  [
    158,
    [
      { chainIdx: 22, pos: 3 },
      { chainIdx: 23, pos: 3 },
      { chainIdx: 24, pos: 3 },
      { chainIdx: 25, pos: 3 },
      { chainIdx: 26, pos: 3 },
      { chainIdx: 27, pos: 3 },
      { chainIdx: 28, pos: 3 },
      { chainIdx: 29, pos: 3 },
      { chainIdx: 129, pos: 3 },
      { chainIdx: 130, pos: 3 },
      { chainIdx: 131, pos: 3 },
      { chainIdx: 132, pos: 3 },
      { chainIdx: 133, pos: 3 },
      { chainIdx: 134, pos: 3 },
      { chainIdx: 135, pos: 3 },
      { chainIdx: 136, pos: 3 },
      { chainIdx: 137, pos: 3 },
      { chainIdx: 138, pos: 3 },
      { chainIdx: 139, pos: 3 },
    ],
  ],
  [
    159,
    [
      { chainIdx: 22, pos: 4 },
      { chainIdx: 23, pos: 4 },
      { chainIdx: 24, pos: 4 },
      { chainIdx: 25, pos: 4 },
      { chainIdx: 129, pos: 4 },
      { chainIdx: 130, pos: 4 },
      { chainIdx: 131, pos: 4 },
      { chainIdx: 132, pos: 4 },
      { chainIdx: 133, pos: 4 },
      { chainIdx: 134, pos: 4 },
    ],
  ],
  [
    161,
    [
      { chainIdx: 22, pos: 5 },
      { chainIdx: 23, pos: 5 },
      { chainIdx: 24, pos: 5 },
      { chainIdx: 25, pos: 5 },
      { chainIdx: 129, pos: 5 },
      { chainIdx: 130, pos: 5 },
      { chainIdx: 131, pos: 5 },
      { chainIdx: 132, pos: 5 },
      { chainIdx: 133, pos: 5 },
      { chainIdx: 134, pos: 5 },
    ],
  ],
  [
    172,
    [
      { chainIdx: 22, pos: 6 },
      { chainIdx: 23, pos: 6 },
      { chainIdx: 133, pos: 6 },
    ],
  ],
  [
    173,
    [
      { chainIdx: 22, pos: 7 },
      { chainIdx: 23, pos: 7 },
    ],
  ],
  [174, [{ chainIdx: 22, pos: 8 }]],
  [175, [{ chainIdx: 23, pos: 8 }]],
  [
    177,
    [
      { chainIdx: 24, pos: 6 },
      { chainIdx: 25, pos: 6 },
      { chainIdx: 134, pos: 6 },
    ],
  ],
  [
    181,
    [
      { chainIdx: 24, pos: 7 },
      { chainIdx: 25, pos: 7 },
    ],
  ],
  [182, [{ chainIdx: 24, pos: 8 }]],
  [183, [{ chainIdx: 25, pos: 8 }]],
  [
    185,
    [
      { chainIdx: 26, pos: 4 },
      { chainIdx: 27, pos: 4 },
      { chainIdx: 28, pos: 4 },
      { chainIdx: 29, pos: 4 },
      { chainIdx: 135, pos: 4 },
      { chainIdx: 136, pos: 4 },
      { chainIdx: 137, pos: 4 },
      { chainIdx: 138, pos: 4 },
      { chainIdx: 139, pos: 4 },
    ],
  ],
  [
    191,
    [
      { chainIdx: 26, pos: 5 },
      { chainIdx: 27, pos: 5 },
      { chainIdx: 136, pos: 5 },
      { chainIdx: 137, pos: 5 },
    ],
  ],
  [
    197,
    [
      { chainIdx: 26, pos: 6 },
      { chainIdx: 27, pos: 6 },
    ],
  ],
  [
    198,
    [
      { chainIdx: 26, pos: 7 },
      { chainIdx: 27, pos: 7 },
    ],
  ],
  [199, [{ chainIdx: 26, pos: 8 }]],
  [200, [{ chainIdx: 27, pos: 8 }]],
  [
    210,
    [
      { chainIdx: 28, pos: 5 },
      { chainIdx: 29, pos: 5 },
      { chainIdx: 138, pos: 5 },
      { chainIdx: 139, pos: 5 },
    ],
  ],
  [
    211,
    [
      { chainIdx: 28, pos: 6 },
      { chainIdx: 29, pos: 6 },
      { chainIdx: 138, pos: 6 },
    ],
  ],
  [
    213,
    [
      { chainIdx: 28, pos: 7 },
      { chainIdx: 29, pos: 7 },
    ],
  ],
  [214, [{ chainIdx: 28, pos: 8 }]],
  [215, [{ chainIdx: 29, pos: 8 }]],
  [
    249,
    [
      { chainIdx: 30, pos: 1 },
      { chainIdx: 31, pos: 1 },
      { chainIdx: 32, pos: 1 },
      { chainIdx: 33, pos: 1 },
      { chainIdx: 34, pos: 1 },
      { chainIdx: 35, pos: 1 },
      { chainIdx: 36, pos: 1 },
      { chainIdx: 37, pos: 1 },
      { chainIdx: 38, pos: 1 },
      { chainIdx: 39, pos: 1 },
      { chainIdx: 40, pos: 1 },
      { chainIdx: 41, pos: 1 },
      { chainIdx: 42, pos: 1 },
      { chainIdx: 43, pos: 1 },
      { chainIdx: 142, pos: 1 },
      { chainIdx: 143, pos: 1 },
      { chainIdx: 144, pos: 1 },
      { chainIdx: 145, pos: 1 },
      { chainIdx: 146, pos: 1 },
      { chainIdx: 147, pos: 1 },
      { chainIdx: 148, pos: 1 },
      { chainIdx: 149, pos: 1 },
      { chainIdx: 150, pos: 1 },
      { chainIdx: 151, pos: 1 },
    ],
  ],
  [
    250,
    [
      { chainIdx: 30, pos: 2 },
      { chainIdx: 31, pos: 2 },
      { chainIdx: 142, pos: 2 },
    ],
  ],
  [
    251,
    [
      { chainIdx: 30, pos: 3 },
      { chainIdx: 31, pos: 3 },
      { chainIdx: 142, pos: 3 },
    ],
  ],
  [
    256,
    [
      { chainIdx: 30, pos: 4 },
      { chainIdx: 31, pos: 4 },
      { chainIdx: 142, pos: 4 },
    ],
  ],
  [
    257,
    [
      { chainIdx: 30, pos: 5 },
      { chainIdx: 31, pos: 5 },
      { chainIdx: 142, pos: 5 },
    ],
  ],
  [
    258,
    [
      { chainIdx: 30, pos: 6 },
      { chainIdx: 31, pos: 6 },
      { chainIdx: 142, pos: 6 },
    ],
  ],
  [
    259,
    [
      { chainIdx: 30, pos: 7 },
      { chainIdx: 31, pos: 7 },
    ],
  ],
  [260, [{ chainIdx: 30, pos: 8 }]],
  [261, [{ chainIdx: 31, pos: 8 }]],
  [
    268,
    [
      { chainIdx: 32, pos: 2 },
      { chainIdx: 33, pos: 2 },
      { chainIdx: 34, pos: 2 },
      { chainIdx: 35, pos: 2 },
      { chainIdx: 36, pos: 2 },
      { chainIdx: 37, pos: 2 },
      { chainIdx: 38, pos: 2 },
      { chainIdx: 39, pos: 2 },
      { chainIdx: 40, pos: 2 },
      { chainIdx: 41, pos: 2 },
      { chainIdx: 42, pos: 2 },
      { chainIdx: 43, pos: 2 },
      { chainIdx: 143, pos: 2 },
      { chainIdx: 144, pos: 2 },
      { chainIdx: 145, pos: 2 },
      { chainIdx: 146, pos: 2 },
      { chainIdx: 147, pos: 2 },
      { chainIdx: 148, pos: 2 },
      { chainIdx: 149, pos: 2 },
      { chainIdx: 150, pos: 2 },
    ],
  ],
  [
    269,
    [
      { chainIdx: 32, pos: 3 },
      { chainIdx: 33, pos: 3 },
      { chainIdx: 34, pos: 3 },
      { chainIdx: 35, pos: 3 },
      { chainIdx: 36, pos: 3 },
      { chainIdx: 37, pos: 3 },
      { chainIdx: 38, pos: 3 },
      { chainIdx: 39, pos: 3 },
      { chainIdx: 40, pos: 3 },
      { chainIdx: 41, pos: 3 },
      { chainIdx: 143, pos: 3 },
      { chainIdx: 144, pos: 3 },
      { chainIdx: 145, pos: 3 },
      { chainIdx: 146, pos: 3 },
      { chainIdx: 147, pos: 3 },
      { chainIdx: 148, pos: 3 },
    ],
  ],
  [
    270,
    [
      { chainIdx: 32, pos: 4 },
      { chainIdx: 33, pos: 4 },
      { chainIdx: 34, pos: 4 },
      { chainIdx: 35, pos: 4 },
      { chainIdx: 143, pos: 4 },
      { chainIdx: 144, pos: 4 },
      { chainIdx: 145, pos: 4 },
    ],
  ],
  [
    271,
    [
      { chainIdx: 32, pos: 5 },
      { chainIdx: 33, pos: 5 },
    ],
  ],
  [
    272,
    [
      { chainIdx: 32, pos: 6 },
      { chainIdx: 33, pos: 6 },
    ],
  ],
  [
    273,
    [
      { chainIdx: 32, pos: 7 },
      { chainIdx: 33, pos: 7 },
    ],
  ],
  [274, [{ chainIdx: 32, pos: 8 }]],
  [275, [{ chainIdx: 33, pos: 8 }]],
  [
    284,
    [
      { chainIdx: 34, pos: 5 },
      { chainIdx: 35, pos: 5 },
      { chainIdx: 145, pos: 5 },
    ],
  ],
  [
    285,
    [
      { chainIdx: 34, pos: 6 },
      { chainIdx: 35, pos: 6 },
      { chainIdx: 145, pos: 6 },
    ],
  ],
  [
    286,
    [
      { chainIdx: 34, pos: 7 },
      { chainIdx: 35, pos: 7 },
    ],
  ],
  [287, [{ chainIdx: 34, pos: 8 }]],
  [288, [{ chainIdx: 35, pos: 8 }]],
  [
    292,
    [
      { chainIdx: 36, pos: 4 },
      { chainIdx: 37, pos: 4 },
      { chainIdx: 38, pos: 4 },
      { chainIdx: 39, pos: 4 },
      { chainIdx: 40, pos: 4 },
      { chainIdx: 41, pos: 4 },
      { chainIdx: 146, pos: 4 },
      { chainIdx: 147, pos: 4 },
      { chainIdx: 148, pos: 4 },
    ],
  ],
  [
    304,
    [
      { chainIdx: 36, pos: 5 },
      { chainIdx: 37, pos: 5 },
      { chainIdx: 38, pos: 5 },
      { chainIdx: 39, pos: 5 },
    ],
  ],
  [
    305,
    [
      { chainIdx: 36, pos: 6 },
      { chainIdx: 37, pos: 6 },
      { chainIdx: 38, pos: 6 },
      { chainIdx: 39, pos: 6 },
    ],
  ],
  [
    306,
    [
      { chainIdx: 36, pos: 7 },
      { chainIdx: 37, pos: 7 },
    ],
  ],
  [307, [{ chainIdx: 36, pos: 8 }]],
  [308, [{ chainIdx: 37, pos: 8 }]],
  [
    311,
    [
      { chainIdx: 38, pos: 7 },
      { chainIdx: 39, pos: 7 },
    ],
  ],
  [312, [{ chainIdx: 38, pos: 8 }]],
  [313, [{ chainIdx: 39, pos: 8 }]],
  [
    314,
    [
      { chainIdx: 40, pos: 5 },
      { chainIdx: 41, pos: 5 },
      { chainIdx: 147, pos: 5 },
      { chainIdx: 148, pos: 5 },
    ],
  ],
  [
    315,
    [
      { chainIdx: 40, pos: 6 },
      { chainIdx: 41, pos: 6 },
      { chainIdx: 147, pos: 6 },
      { chainIdx: 148, pos: 6 },
    ],
  ],
  [
    318,
    [
      { chainIdx: 40, pos: 7 },
      { chainIdx: 41, pos: 7 },
    ],
  ],
  [319, [{ chainIdx: 40, pos: 8 }]],
  [320, [{ chainIdx: 41, pos: 8 }]],
  [
    323,
    [
      { chainIdx: 42, pos: 3 },
      { chainIdx: 43, pos: 3 },
      { chainIdx: 149, pos: 3 },
      { chainIdx: 150, pos: 3 },
    ],
  ],
  [
    325,
    [
      { chainIdx: 42, pos: 4 },
      { chainIdx: 43, pos: 4 },
      { chainIdx: 149, pos: 4 },
      { chainIdx: 150, pos: 4 },
    ],
  ],
  [
    326,
    [
      { chainIdx: 42, pos: 5 },
      { chainIdx: 43, pos: 5 },
      { chainIdx: 149, pos: 5 },
      { chainIdx: 150, pos: 5 },
    ],
  ],
  [
    327,
    [
      { chainIdx: 42, pos: 6 },
      { chainIdx: 43, pos: 6 },
      { chainIdx: 149, pos: 6 },
    ],
  ],
  [
    333,
    [
      { chainIdx: 42, pos: 7 },
      { chainIdx: 43, pos: 7 },
    ],
  ],
  [334, [{ chainIdx: 42, pos: 8 }]],
  [335, [{ chainIdx: 43, pos: 8 }]],
  [
    358,
    [
      { chainIdx: 44, pos: 1 },
      { chainIdx: 45, pos: 1 },
      { chainIdx: 46, pos: 1 },
      { chainIdx: 47, pos: 1 },
      { chainIdx: 48, pos: 1 },
      { chainIdx: 49, pos: 1 },
      { chainIdx: 50, pos: 1 },
      { chainIdx: 51, pos: 1 },
      { chainIdx: 52, pos: 1 },
      { chainIdx: 53, pos: 1 },
      { chainIdx: 54, pos: 1 },
      { chainIdx: 55, pos: 1 },
      { chainIdx: 56, pos: 1 },
      { chainIdx: 57, pos: 1 },
      { chainIdx: 58, pos: 1 },
      { chainIdx: 59, pos: 1 },
      { chainIdx: 60, pos: 1 },
      { chainIdx: 61, pos: 1 },
      { chainIdx: 62, pos: 1 },
      { chainIdx: 152, pos: 1 },
      { chainIdx: 153, pos: 1 },
      { chainIdx: 154, pos: 1 },
      { chainIdx: 155, pos: 1 },
      { chainIdx: 156, pos: 1 },
      { chainIdx: 157, pos: 1 },
      { chainIdx: 158, pos: 1 },
      { chainIdx: 159, pos: 1 },
      { chainIdx: 160, pos: 1 },
      { chainIdx: 161, pos: 1 },
      { chainIdx: 162, pos: 1 },
      { chainIdx: 163, pos: 1 },
      { chainIdx: 164, pos: 1 },
    ],
  ],
  [
    378,
    [
      { chainIdx: 44, pos: 2 },
      { chainIdx: 45, pos: 2 },
      { chainIdx: 46, pos: 2 },
      { chainIdx: 47, pos: 2 },
      { chainIdx: 48, pos: 2 },
      { chainIdx: 49, pos: 2 },
      { chainIdx: 152, pos: 2 },
      { chainIdx: 153, pos: 2 },
      { chainIdx: 154, pos: 2 },
    ],
  ],
  [
    379,
    [
      { chainIdx: 44, pos: 3 },
      { chainIdx: 45, pos: 3 },
      { chainIdx: 46, pos: 3 },
      { chainIdx: 47, pos: 3 },
      { chainIdx: 48, pos: 3 },
      { chainIdx: 49, pos: 3 },
      { chainIdx: 152, pos: 3 },
      { chainIdx: 153, pos: 3 },
      { chainIdx: 154, pos: 3 },
    ],
  ],
  [
    380,
    [
      { chainIdx: 44, pos: 4 },
      { chainIdx: 45, pos: 4 },
      { chainIdx: 46, pos: 4 },
      { chainIdx: 47, pos: 4 },
      { chainIdx: 152, pos: 4 },
    ],
  ],
  [
    381,
    [
      { chainIdx: 44, pos: 5 },
      { chainIdx: 45, pos: 5 },
      { chainIdx: 46, pos: 5 },
      { chainIdx: 47, pos: 5 },
      { chainIdx: 152, pos: 5 },
    ],
  ],
  [
    382,
    [
      { chainIdx: 44, pos: 6 },
      { chainIdx: 45, pos: 6 },
      { chainIdx: 46, pos: 6 },
      { chainIdx: 47, pos: 6 },
      { chainIdx: 152, pos: 6 },
    ],
  ],
  [
    384,
    [
      { chainIdx: 44, pos: 7 },
      { chainIdx: 45, pos: 7 },
    ],
  ],
  [385, [{ chainIdx: 44, pos: 8 }]],
  [386, [{ chainIdx: 45, pos: 8 }]],
  [
    387,
    [
      { chainIdx: 46, pos: 7 },
      { chainIdx: 47, pos: 7 },
    ],
  ],
  [388, [{ chainIdx: 46, pos: 8 }]],
  [389, [{ chainIdx: 47, pos: 8 }]],
  [
    390,
    [
      { chainIdx: 48, pos: 4 },
      { chainIdx: 49, pos: 4 },
      { chainIdx: 153, pos: 4 },
      { chainIdx: 154, pos: 4 },
    ],
  ],
  [
    391,
    [
      { chainIdx: 48, pos: 5 },
      { chainIdx: 49, pos: 5 },
      { chainIdx: 153, pos: 5 },
    ],
  ],
  [
    394,
    [
      { chainIdx: 48, pos: 6 },
      { chainIdx: 49, pos: 6 },
      { chainIdx: 153, pos: 6 },
    ],
  ],
  [
    396,
    [
      { chainIdx: 48, pos: 7 },
      { chainIdx: 49, pos: 7 },
    ],
  ],
  [397, [{ chainIdx: 48, pos: 8 }]],
  [398, [{ chainIdx: 49, pos: 8 }]],
  [
    415,
    [
      { chainIdx: 50, pos: 2 },
      { chainIdx: 51, pos: 2 },
      { chainIdx: 52, pos: 2 },
      { chainIdx: 53, pos: 2 },
      { chainIdx: 54, pos: 2 },
      { chainIdx: 55, pos: 2 },
      { chainIdx: 56, pos: 2 },
      { chainIdx: 57, pos: 2 },
      { chainIdx: 58, pos: 2 },
      { chainIdx: 59, pos: 2 },
      { chainIdx: 60, pos: 2 },
      { chainIdx: 61, pos: 2 },
      { chainIdx: 62, pos: 2 },
      { chainIdx: 155, pos: 2 },
      { chainIdx: 156, pos: 2 },
      { chainIdx: 157, pos: 2 },
      { chainIdx: 158, pos: 2 },
      { chainIdx: 159, pos: 2 },
      { chainIdx: 160, pos: 2 },
      { chainIdx: 161, pos: 2 },
      { chainIdx: 162, pos: 2 },
      { chainIdx: 163, pos: 2 },
      { chainIdx: 164, pos: 2 },
    ],
  ],
  [
    431,
    [
      { chainIdx: 50, pos: 3 },
      { chainIdx: 51, pos: 3 },
      { chainIdx: 52, pos: 3 },
      { chainIdx: 53, pos: 3 },
      { chainIdx: 54, pos: 3 },
      { chainIdx: 55, pos: 3 },
      { chainIdx: 56, pos: 3 },
      { chainIdx: 57, pos: 3 },
      { chainIdx: 58, pos: 3 },
      { chainIdx: 59, pos: 3 },
      { chainIdx: 60, pos: 3 },
      { chainIdx: 61, pos: 3 },
      { chainIdx: 62, pos: 3 },
      { chainIdx: 155, pos: 3 },
      { chainIdx: 156, pos: 3 },
      { chainIdx: 157, pos: 3 },
      { chainIdx: 158, pos: 3 },
      { chainIdx: 159, pos: 3 },
      { chainIdx: 160, pos: 3 },
      { chainIdx: 161, pos: 3 },
      { chainIdx: 162, pos: 3 },
      { chainIdx: 163, pos: 3 },
      { chainIdx: 164, pos: 3 },
    ],
  ],
  [
    432,
    [
      { chainIdx: 50, pos: 4 },
      { chainIdx: 51, pos: 4 },
      { chainIdx: 52, pos: 4 },
      { chainIdx: 53, pos: 4 },
      { chainIdx: 54, pos: 4 },
      { chainIdx: 55, pos: 4 },
      { chainIdx: 56, pos: 4 },
      { chainIdx: 57, pos: 4 },
      { chainIdx: 58, pos: 4 },
      { chainIdx: 59, pos: 4 },
      { chainIdx: 60, pos: 4 },
      { chainIdx: 61, pos: 4 },
      { chainIdx: 62, pos: 4 },
      { chainIdx: 155, pos: 4 },
      { chainIdx: 156, pos: 4 },
      { chainIdx: 157, pos: 4 },
      { chainIdx: 158, pos: 4 },
      { chainIdx: 159, pos: 4 },
      { chainIdx: 160, pos: 4 },
      { chainIdx: 161, pos: 4 },
      { chainIdx: 162, pos: 4 },
      { chainIdx: 163, pos: 4 },
      { chainIdx: 164, pos: 4 },
    ],
  ],
  [
    445,
    [
      { chainIdx: 50, pos: 5 },
      { chainIdx: 51, pos: 5 },
      { chainIdx: 52, pos: 5 },
      { chainIdx: 53, pos: 5 },
      { chainIdx: 54, pos: 5 },
      { chainIdx: 55, pos: 5 },
      { chainIdx: 56, pos: 5 },
      { chainIdx: 57, pos: 5 },
      { chainIdx: 58, pos: 5 },
      { chainIdx: 159, pos: 5 },
      { chainIdx: 160, pos: 5 },
    ],
  ],
  [
    446,
    [
      { chainIdx: 50, pos: 6 },
      { chainIdx: 51, pos: 6 },
      { chainIdx: 159, pos: 6 },
      { chainIdx: 160, pos: 6 },
    ],
  ],
  [
    447,
    [
      { chainIdx: 50, pos: 7 },
      { chainIdx: 51, pos: 7 },
    ],
  ],
  [448, [{ chainIdx: 50, pos: 8 }]],
  [449, [{ chainIdx: 51, pos: 8 }]],
  [
    456,
    [
      { chainIdx: 52, pos: 6 },
      { chainIdx: 53, pos: 6 },
      { chainIdx: 54, pos: 6 },
      { chainIdx: 55, pos: 6 },
      { chainIdx: 56, pos: 6 },
      { chainIdx: 57, pos: 6 },
      { chainIdx: 58, pos: 6 },
    ],
  ],
  [
    457,
    [
      { chainIdx: 52, pos: 7 },
      { chainIdx: 53, pos: 7 },
    ],
  ],
  [458, [{ chainIdx: 52, pos: 8 }]],
  [459, [{ chainIdx: 53, pos: 8 }]],
  [
    460,
    [
      { chainIdx: 54, pos: 7 },
      { chainIdx: 55, pos: 7 },
    ],
  ],
  [461, [{ chainIdx: 54, pos: 8 }]],
  [462, [{ chainIdx: 55, pos: 8 }]],
  [
    465,
    [
      { chainIdx: 56, pos: 7 },
      { chainIdx: 57, pos: 7 },
      { chainIdx: 58, pos: 7 },
    ],
  ],
  [466, [{ chainIdx: 56, pos: 8 }]],
  [467, [{ chainIdx: 57, pos: 8 }]],
  [468, [{ chainIdx: 58, pos: 8 }]],
  [
    469,
    [
      { chainIdx: 59, pos: 5 },
      { chainIdx: 60, pos: 5 },
      { chainIdx: 61, pos: 5 },
      { chainIdx: 62, pos: 5 },
      { chainIdx: 161, pos: 5 },
      { chainIdx: 162, pos: 5 },
      { chainIdx: 163, pos: 5 },
      { chainIdx: 164, pos: 5 },
    ],
  ],
  [
    473,
    [
      { chainIdx: 59, pos: 6 },
      { chainIdx: 60, pos: 6 },
      { chainIdx: 61, pos: 6 },
      { chainIdx: 62, pos: 6 },
      { chainIdx: 163, pos: 6 },
      { chainIdx: 164, pos: 6 },
    ],
  ],
  [
    474,
    [
      { chainIdx: 59, pos: 7 },
      { chainIdx: 60, pos: 7 },
      { chainIdx: 61, pos: 7 },
      { chainIdx: 62, pos: 7 },
    ],
  ],
  [475, [{ chainIdx: 59, pos: 8 }]],
  [476, [{ chainIdx: 60, pos: 8 }]],
  [477, [{ chainIdx: 61, pos: 8 }]],
  [478, [{ chainIdx: 62, pos: 8 }]],
  [
    483,
    [
      { chainIdx: 63, pos: 1 },
      { chainIdx: 64, pos: 1 },
      { chainIdx: 65, pos: 1 },
      { chainIdx: 66, pos: 1 },
      { chainIdx: 67, pos: 1 },
      { chainIdx: 68, pos: 1 },
      { chainIdx: 69, pos: 1 },
      { chainIdx: 70, pos: 1 },
      { chainIdx: 71, pos: 1 },
      { chainIdx: 72, pos: 1 },
      { chainIdx: 73, pos: 1 },
      { chainIdx: 74, pos: 1 },
      { chainIdx: 75, pos: 1 },
      { chainIdx: 76, pos: 1 },
      { chainIdx: 77, pos: 1 },
      { chainIdx: 78, pos: 1 },
      { chainIdx: 79, pos: 1 },
      { chainIdx: 80, pos: 1 },
      { chainIdx: 81, pos: 1 },
      { chainIdx: 82, pos: 1 },
      { chainIdx: 83, pos: 1 },
      { chainIdx: 84, pos: 1 },
      { chainIdx: 85, pos: 1 },
      { chainIdx: 165, pos: 1 },
      { chainIdx: 166, pos: 1 },
      { chainIdx: 167, pos: 1 },
      { chainIdx: 168, pos: 1 },
      { chainIdx: 169, pos: 1 },
      { chainIdx: 170, pos: 1 },
      { chainIdx: 171, pos: 1 },
      { chainIdx: 172, pos: 1 },
      { chainIdx: 173, pos: 1 },
      { chainIdx: 174, pos: 1 },
    ],
  ],
  [
    484,
    [
      { chainIdx: 63, pos: 2 },
      { chainIdx: 64, pos: 2 },
      { chainIdx: 65, pos: 2 },
      { chainIdx: 66, pos: 2 },
    ],
  ],
  [
    486,
    [
      { chainIdx: 63, pos: 3 },
      { chainIdx: 64, pos: 3 },
      { chainIdx: 65, pos: 3 },
      { chainIdx: 66, pos: 3 },
    ],
  ],
  [
    487,
    [
      { chainIdx: 63, pos: 4 },
      { chainIdx: 64, pos: 4 },
    ],
  ],
  [
    489,
    [
      { chainIdx: 63, pos: 5 },
      { chainIdx: 64, pos: 5 },
    ],
  ],
  [
    490,
    [
      { chainIdx: 63, pos: 6 },
      { chainIdx: 64, pos: 6 },
    ],
  ],
  [
    493,
    [
      { chainIdx: 63, pos: 7 },
      { chainIdx: 64, pos: 7 },
    ],
  ],
  [494, [{ chainIdx: 63, pos: 8 }]],
  [495, [{ chainIdx: 64, pos: 8 }]],
  [
    497,
    [
      { chainIdx: 65, pos: 4 },
      { chainIdx: 66, pos: 4 },
    ],
  ],
  [
    498,
    [
      { chainIdx: 65, pos: 5 },
      { chainIdx: 66, pos: 5 },
    ],
  ],
  [
    499,
    [
      { chainIdx: 65, pos: 6 },
      { chainIdx: 66, pos: 6 },
    ],
  ],
  [
    504,
    [
      { chainIdx: 65, pos: 7 },
      { chainIdx: 66, pos: 7 },
    ],
  ],
  [505, [{ chainIdx: 65, pos: 8 }]],
  [506, [{ chainIdx: 66, pos: 8 }]],
  [
    512,
    [
      { chainIdx: 67, pos: 2 },
      { chainIdx: 68, pos: 2 },
      { chainIdx: 69, pos: 2 },
      { chainIdx: 70, pos: 2 },
      { chainIdx: 71, pos: 2 },
      { chainIdx: 72, pos: 2 },
      { chainIdx: 73, pos: 2 },
      { chainIdx: 74, pos: 2 },
      { chainIdx: 75, pos: 2 },
      { chainIdx: 76, pos: 2 },
      { chainIdx: 77, pos: 2 },
      { chainIdx: 78, pos: 2 },
      { chainIdx: 79, pos: 2 },
      { chainIdx: 80, pos: 2 },
      { chainIdx: 81, pos: 2 },
      { chainIdx: 82, pos: 2 },
      { chainIdx: 83, pos: 2 },
      { chainIdx: 84, pos: 2 },
      { chainIdx: 85, pos: 2 },
      { chainIdx: 165, pos: 2 },
      { chainIdx: 166, pos: 2 },
      { chainIdx: 167, pos: 2 },
      { chainIdx: 168, pos: 2 },
      { chainIdx: 169, pos: 2 },
      { chainIdx: 170, pos: 2 },
      { chainIdx: 171, pos: 2 },
      { chainIdx: 172, pos: 2 },
      { chainIdx: 173, pos: 2 },
      { chainIdx: 174, pos: 2 },
    ],
  ],
  [
    513,
    [
      { chainIdx: 67, pos: 3 },
      { chainIdx: 68, pos: 3 },
      { chainIdx: 69, pos: 3 },
      { chainIdx: 70, pos: 3 },
      { chainIdx: 71, pos: 3 },
      { chainIdx: 72, pos: 3 },
      { chainIdx: 73, pos: 3 },
      { chainIdx: 165, pos: 3 },
      { chainIdx: 166, pos: 3 },
      { chainIdx: 167, pos: 3 },
    ],
  ],
  [
    522,
    [
      { chainIdx: 67, pos: 4 },
      { chainIdx: 68, pos: 4 },
      { chainIdx: 69, pos: 4 },
      { chainIdx: 70, pos: 4 },
      { chainIdx: 71, pos: 4 },
      { chainIdx: 72, pos: 4 },
      { chainIdx: 73, pos: 4 },
      { chainIdx: 165, pos: 4 },
      { chainIdx: 166, pos: 4 },
    ],
  ],
  [
    524,
    [
      { chainIdx: 67, pos: 5 },
      { chainIdx: 68, pos: 5 },
      { chainIdx: 69, pos: 5 },
    ],
  ],
  [
    525,
    [
      { chainIdx: 67, pos: 6 },
      { chainIdx: 68, pos: 6 },
      { chainIdx: 69, pos: 6 },
    ],
  ],
  [
    526,
    [
      { chainIdx: 67, pos: 7 },
      { chainIdx: 68, pos: 7 },
      { chainIdx: 69, pos: 7 },
    ],
  ],
  [527, [{ chainIdx: 67, pos: 8 }]],
  [528, [{ chainIdx: 68, pos: 8 }]],
  [529, [{ chainIdx: 69, pos: 8 }]],
  [
    532,
    [
      { chainIdx: 70, pos: 5 },
      { chainIdx: 71, pos: 5 },
      { chainIdx: 72, pos: 5 },
      { chainIdx: 73, pos: 5 },
      { chainIdx: 165, pos: 5 },
      { chainIdx: 166, pos: 5 },
    ],
  ],
  [
    533,
    [
      { chainIdx: 70, pos: 6 },
      { chainIdx: 71, pos: 6 },
      { chainIdx: 72, pos: 6 },
      { chainIdx: 73, pos: 6 },
      { chainIdx: 165, pos: 6 },
      { chainIdx: 166, pos: 6 },
    ],
  ],
  [
    535,
    [
      { chainIdx: 70, pos: 7 },
      { chainIdx: 71, pos: 7 },
    ],
  ],
  [536, [{ chainIdx: 70, pos: 8 }]],
  [537, [{ chainIdx: 71, pos: 8 }]],
  [
    538,
    [
      { chainIdx: 72, pos: 7 },
      { chainIdx: 73, pos: 7 },
    ],
  ],
  [539, [{ chainIdx: 72, pos: 8 }]],
  [540, [{ chainIdx: 73, pos: 8 }]],
  [
    549,
    [
      { chainIdx: 74, pos: 3 },
      { chainIdx: 75, pos: 3 },
      { chainIdx: 76, pos: 3 },
      { chainIdx: 77, pos: 3 },
      { chainIdx: 168, pos: 3 },
      { chainIdx: 169, pos: 3 },
      { chainIdx: 170, pos: 3 },
    ],
  ],
  [
    550,
    [
      { chainIdx: 74, pos: 4 },
      { chainIdx: 75, pos: 4 },
      { chainIdx: 76, pos: 4 },
      { chainIdx: 77, pos: 4 },
      { chainIdx: 168, pos: 4 },
      { chainIdx: 169, pos: 4 },
      { chainIdx: 170, pos: 4 },
    ],
  ],
  [
    551,
    [
      { chainIdx: 74, pos: 5 },
      { chainIdx: 75, pos: 5 },
    ],
  ],
  [
    552,
    [
      { chainIdx: 74, pos: 6 },
      { chainIdx: 75, pos: 6 },
    ],
  ],
  [
    553,
    [
      { chainIdx: 74, pos: 7 },
      { chainIdx: 75, pos: 7 },
    ],
  ],
  [554, [{ chainIdx: 74, pos: 8 }]],
  [555, [{ chainIdx: 75, pos: 8 }]],
  [
    560,
    [
      { chainIdx: 76, pos: 5 },
      { chainIdx: 77, pos: 5 },
      { chainIdx: 168, pos: 5 },
      { chainIdx: 169, pos: 5 },
      { chainIdx: 170, pos: 5 },
    ],
  ],
  [
    561,
    [
      { chainIdx: 76, pos: 6 },
      { chainIdx: 77, pos: 6 },
      { chainIdx: 168, pos: 6 },
      { chainIdx: 169, pos: 6 },
      { chainIdx: 170, pos: 6 },
    ],
  ],
  [
    562,
    [
      { chainIdx: 76, pos: 7 },
      { chainIdx: 77, pos: 7 },
    ],
  ],
  [563, [{ chainIdx: 76, pos: 8 }]],
  [564, [{ chainIdx: 77, pos: 8 }]],
  [
    570,
    [
      { chainIdx: 78, pos: 3 },
      { chainIdx: 79, pos: 3 },
      { chainIdx: 80, pos: 3 },
      { chainIdx: 81, pos: 3 },
      { chainIdx: 82, pos: 3 },
      { chainIdx: 83, pos: 3 },
      { chainIdx: 84, pos: 3 },
      { chainIdx: 85, pos: 3 },
      { chainIdx: 171, pos: 3 },
      { chainIdx: 172, pos: 3 },
      { chainIdx: 173, pos: 3 },
      { chainIdx: 174, pos: 3 },
    ],
  ],
  [
    571,
    [
      { chainIdx: 78, pos: 4 },
      { chainIdx: 79, pos: 4 },
      { chainIdx: 80, pos: 4 },
      { chainIdx: 81, pos: 4 },
      { chainIdx: 82, pos: 4 },
      { chainIdx: 83, pos: 4 },
      { chainIdx: 84, pos: 4 },
      { chainIdx: 85, pos: 4 },
      { chainIdx: 171, pos: 4 },
      { chainIdx: 172, pos: 4 },
      { chainIdx: 173, pos: 4 },
      { chainIdx: 174, pos: 4 },
    ],
  ],
  [
    572,
    [
      { chainIdx: 78, pos: 5 },
      { chainIdx: 79, pos: 5 },
      { chainIdx: 80, pos: 5 },
      { chainIdx: 81, pos: 5 },
      { chainIdx: 82, pos: 5 },
      { chainIdx: 83, pos: 5 },
      { chainIdx: 84, pos: 5 },
      { chainIdx: 85, pos: 5 },
      { chainIdx: 171, pos: 5 },
      { chainIdx: 172, pos: 5 },
      { chainIdx: 173, pos: 5 },
      { chainIdx: 174, pos: 5 },
    ],
  ],
  [
    573,
    [
      { chainIdx: 78, pos: 6 },
      { chainIdx: 79, pos: 6 },
      { chainIdx: 80, pos: 6 },
      { chainIdx: 81, pos: 6 },
      { chainIdx: 171, pos: 6 },
      { chainIdx: 172, pos: 6 },
    ],
  ],
  [
    574,
    [
      { chainIdx: 78, pos: 7 },
      { chainIdx: 79, pos: 7 },
      { chainIdx: 80, pos: 7 },
      { chainIdx: 81, pos: 7 },
    ],
  ],
  [575, [{ chainIdx: 78, pos: 8 }]],
  [576, [{ chainIdx: 79, pos: 8 }]],
  [577, [{ chainIdx: 80, pos: 8 }]],
  [578, [{ chainIdx: 81, pos: 8 }]],
  [
    581,
    [
      { chainIdx: 82, pos: 6 },
      { chainIdx: 83, pos: 6 },
      { chainIdx: 173, pos: 6 },
    ],
  ],
  [
    582,
    [
      { chainIdx: 82, pos: 7 },
      { chainIdx: 83, pos: 7 },
    ],
  ],
  [583, [{ chainIdx: 82, pos: 8 }]],
  [584, [{ chainIdx: 83, pos: 8 }]],
  [
    586,
    [
      { chainIdx: 84, pos: 6 },
      { chainIdx: 85, pos: 6 },
      { chainIdx: 174, pos: 6 },
    ],
  ],
  [
    589,
    [
      { chainIdx: 84, pos: 7 },
      { chainIdx: 85, pos: 7 },
    ],
  ],
  [590, [{ chainIdx: 84, pos: 8 }]],
  [591, [{ chainIdx: 85, pos: 8 }]],
  [
    595,
    [
      { chainIdx: 86, pos: 1 },
      { chainIdx: 87, pos: 1 },
      { chainIdx: 88, pos: 1 },
      { chainIdx: 89, pos: 1 },
      { chainIdx: 90, pos: 1 },
      { chainIdx: 91, pos: 1 },
      { chainIdx: 92, pos: 1 },
      { chainIdx: 93, pos: 1 },
      { chainIdx: 94, pos: 1 },
      { chainIdx: 95, pos: 1 },
      { chainIdx: 96, pos: 1 },
      { chainIdx: 97, pos: 1 },
      { chainIdx: 98, pos: 1 },
      { chainIdx: 99, pos: 1 },
      { chainIdx: 100, pos: 1 },
      { chainIdx: 101, pos: 1 },
      { chainIdx: 175, pos: 1 },
      { chainIdx: 176, pos: 1 },
      { chainIdx: 177, pos: 1 },
      { chainIdx: 178, pos: 1 },
      { chainIdx: 179, pos: 1 },
      { chainIdx: 180, pos: 1 },
      { chainIdx: 181, pos: 1 },
      { chainIdx: 182, pos: 1 },
      { chainIdx: 183, pos: 1 },
      { chainIdx: 184, pos: 1 },
      { chainIdx: 185, pos: 1 },
      { chainIdx: 186, pos: 1 },
      { chainIdx: 187, pos: 1 },
      { chainIdx: 188, pos: 1 },
      { chainIdx: 189, pos: 1 },
      { chainIdx: 190, pos: 1 },
      { chainIdx: 191, pos: 1 },
      { chainIdx: 192, pos: 1 },
    ],
  ],
  [
    596,
    [
      { chainIdx: 86, pos: 2 },
      { chainIdx: 87, pos: 2 },
      { chainIdx: 175, pos: 2 },
      { chainIdx: 176, pos: 2 },
      { chainIdx: 177, pos: 2 },
      { chainIdx: 178, pos: 2 },
      { chainIdx: 179, pos: 2 },
      { chainIdx: 180, pos: 2 },
      { chainIdx: 181, pos: 2 },
      { chainIdx: 182, pos: 2 },
    ],
  ],
  [
    598,
    [
      { chainIdx: 86, pos: 3 },
      { chainIdx: 87, pos: 3 },
      { chainIdx: 175, pos: 3 },
      { chainIdx: 176, pos: 3 },
      { chainIdx: 177, pos: 3 },
      { chainIdx: 178, pos: 3 },
      { chainIdx: 179, pos: 3 },
    ],
  ],
  [
    599,
    [
      { chainIdx: 86, pos: 4 },
      { chainIdx: 87, pos: 4 },
      { chainIdx: 175, pos: 4 },
      { chainIdx: 176, pos: 4 },
      { chainIdx: 177, pos: 4 },
      { chainIdx: 178, pos: 4 },
      { chainIdx: 179, pos: 4 },
    ],
  ],
  [
    600,
    [
      { chainIdx: 86, pos: 5 },
      { chainIdx: 87, pos: 5 },
      { chainIdx: 175, pos: 5 },
      { chainIdx: 176, pos: 5 },
      { chainIdx: 177, pos: 5 },
      { chainIdx: 178, pos: 5 },
      { chainIdx: 179, pos: 5 },
    ],
  ],
  [
    601,
    [
      { chainIdx: 86, pos: 6 },
      { chainIdx: 87, pos: 6 },
      { chainIdx: 175, pos: 6 },
    ],
  ],
  [
    603,
    [
      { chainIdx: 86, pos: 7 },
      { chainIdx: 87, pos: 7 },
    ],
  ],
  [604, [{ chainIdx: 86, pos: 8 }]],
  [605, [{ chainIdx: 87, pos: 8 }]],
  [
    626,
    [
      { chainIdx: 88, pos: 2 },
      { chainIdx: 89, pos: 2 },
      { chainIdx: 90, pos: 2 },
      { chainIdx: 91, pos: 2 },
      { chainIdx: 92, pos: 2 },
      { chainIdx: 93, pos: 2 },
      { chainIdx: 94, pos: 2 },
      { chainIdx: 95, pos: 2 },
      { chainIdx: 96, pos: 2 },
      { chainIdx: 97, pos: 2 },
      { chainIdx: 98, pos: 2 },
      { chainIdx: 99, pos: 2 },
      { chainIdx: 100, pos: 2 },
      { chainIdx: 101, pos: 2 },
      { chainIdx: 183, pos: 2 },
      { chainIdx: 184, pos: 2 },
      { chainIdx: 185, pos: 2 },
      { chainIdx: 186, pos: 2 },
      { chainIdx: 187, pos: 2 },
      { chainIdx: 188, pos: 2 },
      { chainIdx: 189, pos: 2 },
      { chainIdx: 190, pos: 2 },
      { chainIdx: 191, pos: 2 },
      { chainIdx: 192, pos: 2 },
    ],
  ],
  [
    627,
    [
      { chainIdx: 88, pos: 3 },
      { chainIdx: 89, pos: 3 },
      { chainIdx: 90, pos: 3 },
      { chainIdx: 91, pos: 3 },
      { chainIdx: 92, pos: 3 },
      { chainIdx: 93, pos: 3 },
      { chainIdx: 94, pos: 3 },
      { chainIdx: 95, pos: 3 },
      { chainIdx: 96, pos: 3 },
      { chainIdx: 97, pos: 3 },
      { chainIdx: 98, pos: 3 },
      { chainIdx: 99, pos: 3 },
      { chainIdx: 100, pos: 3 },
      { chainIdx: 101, pos: 3 },
      { chainIdx: 183, pos: 3 },
      { chainIdx: 184, pos: 3 },
      { chainIdx: 185, pos: 3 },
      { chainIdx: 186, pos: 3 },
      { chainIdx: 187, pos: 3 },
      { chainIdx: 188, pos: 3 },
      { chainIdx: 189, pos: 3 },
    ],
  ],
  [
    628,
    [
      { chainIdx: 88, pos: 4 },
      { chainIdx: 89, pos: 4 },
      { chainIdx: 90, pos: 4 },
      { chainIdx: 91, pos: 4 },
      { chainIdx: 92, pos: 4 },
      { chainIdx: 93, pos: 4 },
      { chainIdx: 183, pos: 4 },
      { chainIdx: 184, pos: 4 },
    ],
  ],
  [
    629,
    [
      { chainIdx: 88, pos: 5 },
      { chainIdx: 89, pos: 5 },
      { chainIdx: 90, pos: 5 },
      { chainIdx: 91, pos: 5 },
      { chainIdx: 92, pos: 5 },
      { chainIdx: 93, pos: 5 },
      { chainIdx: 183, pos: 5 },
      { chainIdx: 184, pos: 5 },
    ],
  ],
  [
    630,
    [
      { chainIdx: 88, pos: 6 },
      { chainIdx: 89, pos: 6 },
      { chainIdx: 90, pos: 6 },
      { chainIdx: 91, pos: 6 },
      { chainIdx: 92, pos: 6 },
      { chainIdx: 93, pos: 6 },
      { chainIdx: 183, pos: 6 },
      { chainIdx: 184, pos: 6 },
    ],
  ],
  [
    631,
    [
      { chainIdx: 88, pos: 7 },
      { chainIdx: 89, pos: 7 },
      { chainIdx: 90, pos: 7 },
    ],
  ],
  [632, [{ chainIdx: 88, pos: 8 }]],
  [633, [{ chainIdx: 89, pos: 8 }]],
  [634, [{ chainIdx: 90, pos: 8 }]],
  [
    636,
    [
      { chainIdx: 91, pos: 7 },
      { chainIdx: 92, pos: 7 },
      { chainIdx: 93, pos: 7 },
    ],
  ],
  [637, [{ chainIdx: 91, pos: 8 }]],
  [638, [{ chainIdx: 92, pos: 8 }]],
  [639, [{ chainIdx: 93, pos: 8 }]],
  [
    642,
    [
      { chainIdx: 94, pos: 4 },
      { chainIdx: 95, pos: 4 },
      { chainIdx: 96, pos: 4 },
      { chainIdx: 97, pos: 4 },
      { chainIdx: 98, pos: 4 },
      { chainIdx: 99, pos: 4 },
      { chainIdx: 100, pos: 4 },
      { chainIdx: 101, pos: 4 },
      { chainIdx: 185, pos: 4 },
      { chainIdx: 186, pos: 4 },
      { chainIdx: 187, pos: 4 },
      { chainIdx: 188, pos: 4 },
      { chainIdx: 189, pos: 4 },
    ],
  ],
  [
    643,
    [
      { chainIdx: 94, pos: 5 },
      { chainIdx: 95, pos: 5 },
      { chainIdx: 185, pos: 5 },
    ],
  ],
  [
    644,
    [
      { chainIdx: 94, pos: 6 },
      { chainIdx: 95, pos: 6 },
      { chainIdx: 185, pos: 6 },
    ],
  ],
  [
    646,
    [
      { chainIdx: 94, pos: 7 },
      { chainIdx: 95, pos: 7 },
    ],
  ],
  [647, [{ chainIdx: 94, pos: 8 }]],
  [648, [{ chainIdx: 95, pos: 8 }]],
  [
    649,
    [
      { chainIdx: 96, pos: 5 },
      { chainIdx: 97, pos: 5 },
      { chainIdx: 98, pos: 5 },
      { chainIdx: 99, pos: 5 },
      { chainIdx: 100, pos: 5 },
      { chainIdx: 101, pos: 5 },
      { chainIdx: 186, pos: 5 },
      { chainIdx: 187, pos: 5 },
      { chainIdx: 188, pos: 5 },
      { chainIdx: 189, pos: 5 },
    ],
  ],
  [
    655,
    [
      { chainIdx: 96, pos: 6 },
      { chainIdx: 97, pos: 6 },
      { chainIdx: 98, pos: 6 },
    ],
  ],
  [
    656,
    [
      { chainIdx: 96, pos: 7 },
      { chainIdx: 97, pos: 7 },
      { chainIdx: 98, pos: 7 },
    ],
  ],
  [657, [{ chainIdx: 96, pos: 8 }]],
  [658, [{ chainIdx: 97, pos: 8 }]],
  [659, [{ chainIdx: 98, pos: 8 }]],
  [
    660,
    [
      { chainIdx: 99, pos: 6 },
      { chainIdx: 100, pos: 6 },
      { chainIdx: 101, pos: 6 },
      { chainIdx: 188, pos: 6 },
      { chainIdx: 189, pos: 6 },
    ],
  ],
  [
    663,
    [
      { chainIdx: 99, pos: 7 },
      { chainIdx: 100, pos: 7 },
      { chainIdx: 101, pos: 7 },
    ],
  ],
  [664, [{ chainIdx: 99, pos: 8 }]],
  [665, [{ chainIdx: 100, pos: 8 }]],
  [666, [{ chainIdx: 101, pos: 8 }]],
  [
    6,
    [
      { chainIdx: 102, pos: 5 },
      { chainIdx: 103, pos: 5 },
    ],
  ],
  [
    7,
    [
      { chainIdx: 102, pos: 6 },
      { chainIdx: 103, pos: 6 },
    ],
  ],
  [8, [{ chainIdx: 102, pos: 7 }]],
  [9, [{ chainIdx: 103, pos: 7 }]],
  [
    22,
    [
      { chainIdx: 104, pos: 5 },
      { chainIdx: 105, pos: 5 },
    ],
  ],
  [
    23,
    [
      { chainIdx: 104, pos: 6 },
      { chainIdx: 105, pos: 6 },
    ],
  ],
  [26, [{ chainIdx: 104, pos: 7 }]],
  [27, [{ chainIdx: 105, pos: 7 }]],
  [
    36,
    [
      { chainIdx: 106, pos: 4 },
      { chainIdx: 107, pos: 4 },
      { chainIdx: 108, pos: 4 },
      { chainIdx: 109, pos: 4 },
      { chainIdx: 194, pos: 4 },
    ],
  ],
  [
    42,
    [
      { chainIdx: 106, pos: 5 },
      { chainIdx: 107, pos: 5 },
      { chainIdx: 108, pos: 5 },
      { chainIdx: 109, pos: 5 },
    ],
  ],
  [
    43,
    [
      { chainIdx: 106, pos: 6 },
      { chainIdx: 107, pos: 6 },
      { chainIdx: 108, pos: 6 },
      { chainIdx: 109, pos: 6 },
    ],
  ],
  [44, [{ chainIdx: 106, pos: 7 }]],
  [45, [{ chainIdx: 107, pos: 7 }]],
  [46, [{ chainIdx: 108, pos: 7 }]],
  [47, [{ chainIdx: 109, pos: 7 }]],
  [55, [{ chainIdx: 110, pos: 7 }]],
  [70, [{ chainIdx: 111, pos: 7 }]],
  [73, [{ chainIdx: 112, pos: 7 }]],
  [78, [{ chainIdx: 113, pos: 7 }]],
  [
    83,
    [
      { chainIdx: 114, pos: 6 },
      { chainIdx: 115, pos: 6 },
      { chainIdx: 116, pos: 6 },
    ],
  ],
  [84, [{ chainIdx: 114, pos: 7 }]],
  [85, [{ chainIdx: 115, pos: 7 }]],
  [88, [{ chainIdx: 116, pos: 7 }]],
  [100, [{ chainIdx: 117, pos: 7 }]],
  [101, [{ chainIdx: 118, pos: 7 }]],
  [102, [{ chainIdx: 119, pos: 7 }]],
  [
    107,
    [
      { chainIdx: 120, pos: 5 },
      { chainIdx: 121, pos: 5 },
    ],
  ],
  [
    108,
    [
      { chainIdx: 120, pos: 6 },
      { chainIdx: 121, pos: 6 },
    ],
  ],
  [111, [{ chainIdx: 120, pos: 7 }]],
  [112, [{ chainIdx: 121, pos: 7 }]],
  [121, [{ chainIdx: 122, pos: 7 }]],
  [131, [{ chainIdx: 123, pos: 7 }]],
  [137, [{ chainIdx: 124, pos: 7 }]],
  [138, [{ chainIdx: 125, pos: 7 }]],
  [143, [{ chainIdx: 126, pos: 7 }]],
  [
    151,
    [
      { chainIdx: 127, pos: 4 },
      { chainIdx: 128, pos: 4 },
    ],
  ],
  [
    152,
    [
      { chainIdx: 127, pos: 5 },
      { chainIdx: 128, pos: 5 },
    ],
  ],
  [
    153,
    [
      { chainIdx: 127, pos: 6 },
      { chainIdx: 128, pos: 6 },
    ],
  ],
  [154, [{ chainIdx: 127, pos: 7 }]],
  [155, [{ chainIdx: 128, pos: 7 }]],
  [
    162,
    [
      { chainIdx: 129, pos: 6 },
      { chainIdx: 130, pos: 6 },
    ],
  ],
  [163, [{ chainIdx: 129, pos: 7 }]],
  [168, [{ chainIdx: 130, pos: 7 }]],
  [
    169,
    [
      { chainIdx: 131, pos: 6 },
      { chainIdx: 132, pos: 6 },
    ],
  ],
  [170, [{ chainIdx: 131, pos: 7 }]],
  [171, [{ chainIdx: 132, pos: 7 }]],
  [176, [{ chainIdx: 133, pos: 7 }]],
  [180, [{ chainIdx: 134, pos: 7 }]],
  [186, [{ chainIdx: 135, pos: 5 }]],
  [187, [{ chainIdx: 135, pos: 6 }]],
  [188, [{ chainIdx: 135, pos: 7 }]],
  [
    192,
    [
      { chainIdx: 136, pos: 6 },
      { chainIdx: 137, pos: 6 },
    ],
  ],
  [193, [{ chainIdx: 136, pos: 7 }]],
  [196, [{ chainIdx: 137, pos: 7 }]],
  [212, [{ chainIdx: 138, pos: 7 }]],
  [216, [{ chainIdx: 139, pos: 6 }]],
  [219, [{ chainIdx: 139, pos: 7 }]],
  [220, [{ chainIdx: 140, pos: 2 }]],
  [225, [{ chainIdx: 140, pos: 3 }]],
  [226, [{ chainIdx: 140, pos: 4 }]],
  [227, [{ chainIdx: 140, pos: 5 }]],
  [228, [{ chainIdx: 140, pos: 6 }]],
  [231, [{ chainIdx: 140, pos: 7 }]],
  [235, [{ chainIdx: 141, pos: 2 }]],
  [238, [{ chainIdx: 141, pos: 3 }]],
  [239, [{ chainIdx: 141, pos: 4 }]],
  [241, [{ chainIdx: 141, pos: 5 }]],
  [242, [{ chainIdx: 141, pos: 6 }]],
  [245, [{ chainIdx: 141, pos: 7 }]],
  [262, [{ chainIdx: 142, pos: 7 }]],
  [
    278,
    [
      { chainIdx: 143, pos: 5 },
      { chainIdx: 144, pos: 5 },
    ],
  ],
  [
    281,
    [
      { chainIdx: 143, pos: 6 },
      { chainIdx: 144, pos: 6 },
    ],
  ],
  [282, [{ chainIdx: 143, pos: 7 }]],
  [283, [{ chainIdx: 144, pos: 7 }]],
  [289, [{ chainIdx: 145, pos: 7 }]],
  [297, [{ chainIdx: 146, pos: 5 }]],
  [298, [{ chainIdx: 146, pos: 6 }]],
  [303, [{ chainIdx: 146, pos: 7 }]],
  [321, [{ chainIdx: 147, pos: 7 }]],
  [322, [{ chainIdx: 148, pos: 7 }]],
  [332, [{ chainIdx: 149, pos: 7 }]],
  [336, [{ chainIdx: 150, pos: 6 }]],
  [339, [{ chainIdx: 150, pos: 7 }]],
  [345, [{ chainIdx: 151, pos: 2 }]],
  [348, [{ chainIdx: 151, pos: 3 }]],
  [349, [{ chainIdx: 151, pos: 4 }]],
  [350, [{ chainIdx: 151, pos: 5 }]],
  [351, [{ chainIdx: 151, pos: 6 }]],
  [352, [{ chainIdx: 151, pos: 7 }]],
  [383, [{ chainIdx: 152, pos: 7 }]],
  [395, [{ chainIdx: 153, pos: 7 }]],
  [399, [{ chainIdx: 154, pos: 5 }]],
  [400, [{ chainIdx: 154, pos: 6 }]],
  [401, [{ chainIdx: 154, pos: 7 }]],
  [433, [{ chainIdx: 155, pos: 5 }]],
  [434, [{ chainIdx: 155, pos: 6 }]],
  [437, [{ chainIdx: 155, pos: 7 }]],
  [
    438,
    [
      { chainIdx: 156, pos: 5 },
      { chainIdx: 157, pos: 5 },
      { chainIdx: 158, pos: 5 },
    ],
  ],
  [
    439,
    [
      { chainIdx: 156, pos: 6 },
      { chainIdx: 157, pos: 6 },
      { chainIdx: 158, pos: 6 },
    ],
  ],
  [440, [{ chainIdx: 156, pos: 7 }]],
  [441, [{ chainIdx: 157, pos: 7 }]],
  [444, [{ chainIdx: 158, pos: 7 }]],
  [452, [{ chainIdx: 159, pos: 7 }]],
  [453, [{ chainIdx: 160, pos: 7 }]],
  [
    470,
    [
      { chainIdx: 161, pos: 6 },
      { chainIdx: 162, pos: 6 },
    ],
  ],
  [471, [{ chainIdx: 161, pos: 7 }]],
  [472, [{ chainIdx: 162, pos: 7 }]],
  [479, [{ chainIdx: 163, pos: 7 }]],
  [480, [{ chainIdx: 164, pos: 7 }]],
  [534, [{ chainIdx: 165, pos: 7 }]],
  [541, [{ chainIdx: 166, pos: 7 }]],
  [542, [{ chainIdx: 167, pos: 4 }]],
  [544, [{ chainIdx: 167, pos: 5 }]],
  [545, [{ chainIdx: 167, pos: 6 }]],
  [548, [{ chainIdx: 167, pos: 7 }]],
  [567, [{ chainIdx: 168, pos: 7 }]],
  [568, [{ chainIdx: 169, pos: 7 }]],
  [569, [{ chainIdx: 170, pos: 7 }]],
  [579, [{ chainIdx: 171, pos: 7 }]],
  [580, [{ chainIdx: 172, pos: 7 }]],
  [585, [{ chainIdx: 173, pos: 7 }]],
  [592, [{ chainIdx: 174, pos: 7 }]],
  [602, [{ chainIdx: 175, pos: 7 }]],
  [
    606,
    [
      { chainIdx: 176, pos: 6 },
      { chainIdx: 177, pos: 6 },
      { chainIdx: 178, pos: 6 },
    ],
  ],
  [609, [{ chainIdx: 176, pos: 7 }]],
  [610, [{ chainIdx: 177, pos: 7 }]],
  [611, [{ chainIdx: 178, pos: 7 }]],
  [612, [{ chainIdx: 179, pos: 6 }]],
  [615, [{ chainIdx: 179, pos: 7 }]],
  [
    616,
    [
      { chainIdx: 180, pos: 3 },
      { chainIdx: 181, pos: 3 },
      { chainIdx: 182, pos: 3 },
    ],
  ],
  [
    617,
    [
      { chainIdx: 180, pos: 4 },
      { chainIdx: 181, pos: 4 },
      { chainIdx: 182, pos: 4 },
    ],
  ],
  [
    618,
    [
      { chainIdx: 180, pos: 5 },
      { chainIdx: 181, pos: 5 },
      { chainIdx: 182, pos: 5 },
    ],
  ],
  [
    619,
    [
      { chainIdx: 180, pos: 6 },
      { chainIdx: 181, pos: 6 },
      { chainIdx: 182, pos: 6 },
    ],
  ],
  [620, [{ chainIdx: 180, pos: 7 }]],
  [621, [{ chainIdx: 181, pos: 7 }]],
  [622, [{ chainIdx: 182, pos: 7 }]],
  [635, [{ chainIdx: 183, pos: 7 }]],
  [640, [{ chainIdx: 184, pos: 7 }]],
  [645, [{ chainIdx: 185, pos: 7 }]],
  [
    650,
    [
      { chainIdx: 186, pos: 6 },
      { chainIdx: 187, pos: 6 },
    ],
  ],
  [653, [{ chainIdx: 186, pos: 7 }]],
  [654, [{ chainIdx: 187, pos: 7 }]],
  [661, [{ chainIdx: 188, pos: 7 }]],
  [662, [{ chainIdx: 189, pos: 7 }]],
  [
    667,
    [
      { chainIdx: 190, pos: 3 },
      { chainIdx: 191, pos: 3 },
      { chainIdx: 192, pos: 3 },
    ],
  ],
  [
    668,
    [
      { chainIdx: 190, pos: 4 },
      { chainIdx: 191, pos: 4 },
      { chainIdx: 192, pos: 4 },
    ],
  ],
  [
    670,
    [
      { chainIdx: 190, pos: 5 },
      { chainIdx: 191, pos: 5 },
      { chainIdx: 192, pos: 5 },
    ],
  ],
  [
    671,
    [
      { chainIdx: 190, pos: 6 },
      { chainIdx: 191, pos: 6 },
      { chainIdx: 192, pos: 6 },
    ],
  ],
  [672, [{ chainIdx: 190, pos: 7 }]],
  [673, [{ chainIdx: 191, pos: 7 }]],
  [674, [{ chainIdx: 192, pos: 7 }]],
  [35, [{ chainIdx: 193, pos: 5 }]],
  [41, [{ chainIdx: 194, pos: 5 }]],
  [79, [{ chainIdx: 195, pos: 5 }]],
  [80, [{ chainIdx: 196, pos: 5 }]],
  [106, [{ chainIdx: 197, pos: 5 }]],
  [118, [{ chainIdx: 198, pos: 5 }]],
  [134, [{ chainIdx: 199, pos: 5 }]],
]

/** Positive/negative verification state + target fill opacity per node. */
export const STATIC_NODE_STATES: Array<
  [number, { state: VerifyState; targetOpacity: number }]
> = [
  [33, { state: 'positive', targetOpacity: 0.7 }],
  [34, { state: 'positive', targetOpacity: 0.7 }],
  [57, { state: 'positive', targetOpacity: 0.7 }],
  [58, { state: 'positive', targetOpacity: 0.7 }],
  [65, { state: 'negative', targetOpacity: 0.7 }],
  [66, { state: 'positive', targetOpacity: 0.7 }],
  [68, { state: 'positive', targetOpacity: 0.7 }],
  [69, { state: 'positive', targetOpacity: 0.7 }],
  [75, { state: 'positive', targetOpacity: 0.7 }],
  [76, { state: 'positive', targetOpacity: 0.7 }],
  [77, { state: 'positive', targetOpacity: 0.7 }],
  [95, { state: 'positive', targetOpacity: 0.7 }],
  [96, { state: 'positive', targetOpacity: 0.7 }],
  [104, { state: 'positive', targetOpacity: 0.7 }],
  [105, { state: 'positive', targetOpacity: 0.7 }],
  [123, { state: 'positive', targetOpacity: 0.7 }],
  [124, { state: 'positive', targetOpacity: 0.7 }],
  [127, { state: 'positive', targetOpacity: 0.7 }],
  [128, { state: 'positive', targetOpacity: 0.7 }],
  [140, { state: 'positive', targetOpacity: 0.7 }],
  [141, { state: 'positive', targetOpacity: 0.7 }],
  [142, { state: 'positive', targetOpacity: 0.7 }],
  [174, { state: 'positive', targetOpacity: 0.7 }],
  [175, { state: 'positive', targetOpacity: 0.7 }],
  [182, { state: 'positive', targetOpacity: 0.7 }],
  [183, { state: 'positive', targetOpacity: 0.7 }],
  [199, { state: 'positive', targetOpacity: 0.7 }],
  [200, { state: 'positive', targetOpacity: 0.7 }],
  [214, { state: 'positive', targetOpacity: 0.7 }],
  [215, { state: 'positive', targetOpacity: 0.7 }],
  [260, { state: 'positive', targetOpacity: 0.7 }],
  [261, { state: 'positive', targetOpacity: 0.7 }],
  [274, { state: 'positive', targetOpacity: 0.7 }],
  [275, { state: 'positive', targetOpacity: 0.7 }],
  [287, { state: 'positive', targetOpacity: 0.7 }],
  [288, { state: 'positive', targetOpacity: 0.7 }],
  [307, { state: 'positive', targetOpacity: 0.7 }],
  [308, { state: 'positive', targetOpacity: 0.7 }],
  [312, { state: 'negative', targetOpacity: 0.7 }],
  [313, { state: 'positive', targetOpacity: 0.7 }],
  [319, { state: 'positive', targetOpacity: 0.7 }],
  [320, { state: 'positive', targetOpacity: 0.7 }],
  [334, { state: 'positive', targetOpacity: 0.7 }],
  [335, { state: 'positive', targetOpacity: 0.7 }],
  [385, { state: 'positive', targetOpacity: 0.7 }],
  [386, { state: 'positive', targetOpacity: 0.7 }],
  [388, { state: 'positive', targetOpacity: 0.7 }],
  [389, { state: 'positive', targetOpacity: 0.7 }],
  [397, { state: 'positive', targetOpacity: 0.7 }],
  [398, { state: 'positive', targetOpacity: 0.7 }],
  [448, { state: 'positive', targetOpacity: 0.7 }],
  [449, { state: 'positive', targetOpacity: 0.7 }],
  [458, { state: 'positive', targetOpacity: 0.7 }],
  [459, { state: 'positive', targetOpacity: 0.7 }],
  [461, { state: 'positive', targetOpacity: 0.7 }],
  [462, { state: 'positive', targetOpacity: 0.7 }],
  [466, { state: 'positive', targetOpacity: 0.7 }],
  [467, { state: 'positive', targetOpacity: 0.7 }],
  [468, { state: 'positive', targetOpacity: 0.7 }],
  [475, { state: 'positive', targetOpacity: 0.7 }],
  [476, { state: 'negative', targetOpacity: 0.7 }],
  [477, { state: 'positive', targetOpacity: 0.7 }],
  [478, { state: 'positive', targetOpacity: 0.7 }],
  [494, { state: 'negative', targetOpacity: 0.7 }],
  [495, { state: 'positive', targetOpacity: 0.7 }],
  [505, { state: 'positive', targetOpacity: 0.7 }],
  [506, { state: 'positive', targetOpacity: 0.7 }],
  [527, { state: 'positive', targetOpacity: 0.7 }],
  [528, { state: 'positive', targetOpacity: 0.7 }],
  [529, { state: 'positive', targetOpacity: 0.7 }],
  [536, { state: 'positive', targetOpacity: 0.7 }],
  [537, { state: 'positive', targetOpacity: 0.7 }],
  [539, { state: 'positive', targetOpacity: 0.7 }],
  [540, { state: 'positive', targetOpacity: 0.7 }],
  [554, { state: 'positive', targetOpacity: 0.7 }],
  [555, { state: 'negative', targetOpacity: 0.7 }],
  [563, { state: 'positive', targetOpacity: 0.7 }],
  [564, { state: 'positive', targetOpacity: 0.7 }],
  [575, { state: 'positive', targetOpacity: 0.7 }],
  [576, { state: 'positive', targetOpacity: 0.7 }],
  [577, { state: 'positive', targetOpacity: 0.7 }],
  [578, { state: 'positive', targetOpacity: 0.7 }],
  [583, { state: 'positive', targetOpacity: 0.7 }],
  [584, { state: 'positive', targetOpacity: 0.7 }],
  [590, { state: 'positive', targetOpacity: 0.7 }],
  [591, { state: 'positive', targetOpacity: 0.7 }],
  [604, { state: 'positive', targetOpacity: 0.7 }],
  [605, { state: 'positive', targetOpacity: 0.7 }],
  [632, { state: 'positive', targetOpacity: 0.7 }],
  [633, { state: 'positive', targetOpacity: 0.7 }],
  [634, { state: 'positive', targetOpacity: 0.7 }],
  [637, { state: 'positive', targetOpacity: 0.7 }],
  [638, { state: 'positive', targetOpacity: 0.7 }],
  [639, { state: 'positive', targetOpacity: 0.7 }],
  [647, { state: 'positive', targetOpacity: 0.7 }],
  [648, { state: 'positive', targetOpacity: 0.7 }],
  [657, { state: 'positive', targetOpacity: 0.7 }],
  [658, { state: 'positive', targetOpacity: 0.7 }],
  [659, { state: 'positive', targetOpacity: 0.7 }],
  [664, { state: 'positive', targetOpacity: 0.7 }],
  [665, { state: 'positive', targetOpacity: 0.7 }],
  [666, { state: 'positive', targetOpacity: 0.7 }],
  [8, { state: 'positive', targetOpacity: 0.7 }],
  [9, { state: 'positive', targetOpacity: 0.7 }],
  [26, { state: 'positive', targetOpacity: 0.7 }],
  [27, { state: 'positive', targetOpacity: 0.7 }],
  [44, { state: 'positive', targetOpacity: 0.7 }],
  [45, { state: 'positive', targetOpacity: 0.7 }],
  [46, { state: 'positive', targetOpacity: 0.7 }],
  [47, { state: 'positive', targetOpacity: 0.7 }],
  [55, { state: 'positive', targetOpacity: 0.7 }],
  [70, { state: 'positive', targetOpacity: 0.7 }],
  [73, { state: 'positive', targetOpacity: 0.7 }],
  [78, { state: 'positive', targetOpacity: 0.7 }],
  [84, { state: 'positive', targetOpacity: 0.7 }],
  [85, { state: 'positive', targetOpacity: 0.7 }],
  [88, { state: 'positive', targetOpacity: 0.7 }],
  [100, { state: 'positive', targetOpacity: 0.7 }],
  [101, { state: 'positive', targetOpacity: 0.7 }],
  [102, { state: 'positive', targetOpacity: 0.7 }],
  [111, { state: 'positive', targetOpacity: 0.7 }],
  [112, { state: 'positive', targetOpacity: 0.7 }],
  [121, { state: 'positive', targetOpacity: 0.7 }],
  [131, { state: 'positive', targetOpacity: 0.7 }],
  [137, { state: 'positive', targetOpacity: 0.7 }],
  [138, { state: 'positive', targetOpacity: 0.7 }],
  [143, { state: 'positive', targetOpacity: 0.7 }],
  [154, { state: 'positive', targetOpacity: 0.7 }],
  [155, { state: 'positive', targetOpacity: 0.7 }],
  [163, { state: 'positive', targetOpacity: 0.7 }],
  [168, { state: 'positive', targetOpacity: 0.7 }],
  [170, { state: 'positive', targetOpacity: 0.7 }],
  [171, { state: 'positive', targetOpacity: 0.7 }],
  [176, { state: 'positive', targetOpacity: 0.7 }],
  [180, { state: 'positive', targetOpacity: 0.7 }],
  [188, { state: 'positive', targetOpacity: 0.7 }],
  [193, { state: 'positive', targetOpacity: 0.7 }],
  [196, { state: 'positive', targetOpacity: 0.7 }],
  [212, { state: 'positive', targetOpacity: 0.7 }],
  [219, { state: 'positive', targetOpacity: 0.7 }],
  [231, { state: 'positive', targetOpacity: 0.7 }],
  [245, { state: 'positive', targetOpacity: 0.7 }],
  [262, { state: 'positive', targetOpacity: 0.7 }],
  [282, { state: 'positive', targetOpacity: 0.7 }],
  [283, { state: 'positive', targetOpacity: 0.7 }],
  [289, { state: 'positive', targetOpacity: 0.7 }],
  [303, { state: 'positive', targetOpacity: 0.7 }],
  [321, { state: 'positive', targetOpacity: 0.7 }],
  [322, { state: 'positive', targetOpacity: 0.7 }],
  [332, { state: 'positive', targetOpacity: 0.7 }],
  [339, { state: 'positive', targetOpacity: 0.7 }],
  [352, { state: 'positive', targetOpacity: 0.7 }],
  [383, { state: 'positive', targetOpacity: 0.7 }],
  [395, { state: 'positive', targetOpacity: 0.7 }],
  [401, { state: 'positive', targetOpacity: 0.7 }],
  [437, { state: 'positive', targetOpacity: 0.7 }],
  [440, { state: 'positive', targetOpacity: 0.7 }],
  [441, { state: 'positive', targetOpacity: 0.7 }],
  [444, { state: 'positive', targetOpacity: 0.7 }],
  [452, { state: 'positive', targetOpacity: 0.7 }],
  [453, { state: 'positive', targetOpacity: 0.7 }],
  [471, { state: 'positive', targetOpacity: 0.7 }],
  [472, { state: 'positive', targetOpacity: 0.7 }],
  [479, { state: 'positive', targetOpacity: 0.7 }],
  [480, { state: 'positive', targetOpacity: 0.7 }],
  [534, { state: 'positive', targetOpacity: 0.7 }],
  [541, { state: 'positive', targetOpacity: 0.7 }],
  [548, { state: 'positive', targetOpacity: 0.7 }],
  [567, { state: 'positive', targetOpacity: 0.7 }],
  [568, { state: 'positive', targetOpacity: 0.7 }],
  [569, { state: 'positive', targetOpacity: 0.7 }],
  [579, { state: 'positive', targetOpacity: 0.7 }],
  [580, { state: 'positive', targetOpacity: 0.7 }],
  [585, { state: 'positive', targetOpacity: 0.7 }],
  [592, { state: 'positive', targetOpacity: 0.7 }],
  [602, { state: 'positive', targetOpacity: 0.7 }],
  [609, { state: 'positive', targetOpacity: 0.7 }],
  [610, { state: 'positive', targetOpacity: 0.7 }],
  [611, { state: 'positive', targetOpacity: 0.7 }],
  [615, { state: 'positive', targetOpacity: 0.7 }],
  [620, { state: 'positive', targetOpacity: 0.7 }],
  [621, { state: 'positive', targetOpacity: 0.7 }],
  [622, { state: 'positive', targetOpacity: 0.7 }],
  [635, { state: 'positive', targetOpacity: 0.7 }],
  [640, { state: 'positive', targetOpacity: 0.7 }],
  [645, { state: 'positive', targetOpacity: 0.7 }],
  [653, { state: 'positive', targetOpacity: 0.7 }],
  [654, { state: 'positive', targetOpacity: 0.7 }],
  [661, { state: 'positive', targetOpacity: 0.7 }],
  [662, { state: 'positive', targetOpacity: 0.7 }],
  [672, { state: 'positive', targetOpacity: 0.7 }],
  [673, { state: 'positive', targetOpacity: 0.7 }],
  [674, { state: 'positive', targetOpacity: 0.7 }],
  [35, { state: 'positive', targetOpacity: 0.6 }],
  [41, { state: 'positive', targetOpacity: 0.6 }],
  [79, { state: 'positive', targetOpacity: 0.6 }],
  [80, { state: 'positive', targetOpacity: 0.6 }],
  [106, { state: 'positive', targetOpacity: 0.6 }],
  [118, { state: 'positive', targetOpacity: 0.6 }],
  [134, { state: 'positive', targetOpacity: 0.6 }],
  [32, { state: 'positive', targetOpacity: 0.7 }],
  [31, { state: 'positive', targetOpacity: 0.7 }],
  [30, { state: 'positive', targetOpacity: 0.6 }],
  [56, { state: 'positive', targetOpacity: 0.7 }],
  [64, { state: 'negative', targetOpacity: 0.7 }],
  [67, { state: 'positive', targetOpacity: 0.7 }],
  [74, { state: 'positive', targetOpacity: 0.7 }],
  [72, { state: 'positive', targetOpacity: 0.7 }],
  [71, { state: 'positive', targetOpacity: 0.6 }],
  [94, { state: 'positive', targetOpacity: 0.7 }],
  [103, { state: 'positive', targetOpacity: 0.7 }],
  [99, { state: 'positive', targetOpacity: 0.7 }],
  [98, { state: 'positive', targetOpacity: 0.6 }],
  [122, { state: 'positive', targetOpacity: 0.7 }],
  [120, { state: 'positive', targetOpacity: 0.7 }],
  [126, { state: 'positive', targetOpacity: 0.7 }],
  [139, { state: 'positive', targetOpacity: 0.7 }],
  [136, { state: 'positive', targetOpacity: 0.7 }],
  [135, { state: 'positive', targetOpacity: 0.6 }],
  [133, { state: 'positive', targetOpacity: 0.4 }],
  [173, { state: 'positive', targetOpacity: 0.7 }],
  [172, { state: 'positive', targetOpacity: 0.7 }],
  [181, { state: 'positive', targetOpacity: 0.7 }],
  [198, { state: 'positive', targetOpacity: 0.7 }],
  [213, { state: 'positive', targetOpacity: 0.7 }],
  [211, { state: 'positive', targetOpacity: 0.7 }],
  [259, { state: 'positive', targetOpacity: 0.7 }],
  [258, { state: 'positive', targetOpacity: 0.7 }],
  [257, { state: 'positive', targetOpacity: 0.6 }],
  [256, { state: 'positive', targetOpacity: 0.4 }],
  [273, { state: 'positive', targetOpacity: 0.7 }],
  [286, { state: 'positive', targetOpacity: 0.7 }],
  [306, { state: 'positive', targetOpacity: 0.7 }],
  [311, { state: 'negative', targetOpacity: 0.7 }],
  [318, { state: 'positive', targetOpacity: 0.7 }],
  [333, { state: 'positive', targetOpacity: 0.7 }],
  [384, { state: 'positive', targetOpacity: 0.7 }],
  [387, { state: 'positive', targetOpacity: 0.7 }],
  [382, { state: 'positive', targetOpacity: 0.7 }],
  [381, { state: 'positive', targetOpacity: 0.6 }],
  [380, { state: 'positive', targetOpacity: 0.4 }],
  [396, { state: 'positive', targetOpacity: 0.7 }],
  [394, { state: 'positive', targetOpacity: 0.7 }],
  [447, { state: 'positive', targetOpacity: 0.7 }],
  [457, { state: 'positive', targetOpacity: 0.7 }],
  [460, { state: 'positive', targetOpacity: 0.7 }],
  [465, { state: 'positive', targetOpacity: 0.7 }],
  [474, { state: 'negative', targetOpacity: 0.7 }],
  [473, { state: 'negative', targetOpacity: 0.7 }],
  [493, { state: 'negative', targetOpacity: 0.7 }],
  [504, { state: 'positive', targetOpacity: 0.7 }],
  [526, { state: 'positive', targetOpacity: 0.7 }],
  [535, { state: 'positive', targetOpacity: 0.7 }],
  [538, { state: 'positive', targetOpacity: 0.7 }],
  [533, { state: 'positive', targetOpacity: 0.7 }],
  [532, { state: 'positive', targetOpacity: 0.6 }],
  [553, { state: 'negative', targetOpacity: 0.7 }],
  [562, { state: 'positive', targetOpacity: 0.7 }],
  [574, { state: 'positive', targetOpacity: 0.7 }],
  [573, { state: 'positive', targetOpacity: 0.7 }],
  [582, { state: 'positive', targetOpacity: 0.7 }],
  [581, { state: 'positive', targetOpacity: 0.7 }],
  [589, { state: 'positive', targetOpacity: 0.7 }],
  [603, { state: 'positive', targetOpacity: 0.7 }],
  [601, { state: 'positive', targetOpacity: 0.7 }],
  [631, { state: 'positive', targetOpacity: 0.7 }],
  [636, { state: 'positive', targetOpacity: 0.7 }],
  [630, { state: 'positive', targetOpacity: 0.7 }],
  [629, { state: 'positive', targetOpacity: 0.6 }],
  [646, { state: 'positive', targetOpacity: 0.7 }],
  [644, { state: 'positive', targetOpacity: 0.7 }],
  [643, { state: 'positive', targetOpacity: 0.6 }],
  [656, { state: 'positive', targetOpacity: 0.7 }],
  [655, { state: 'positive', targetOpacity: 0.7 }],
  [663, { state: 'positive', targetOpacity: 0.7 }],
  [660, { state: 'positive', targetOpacity: 0.7 }],
  [7, { state: 'positive', targetOpacity: 0.7 }],
  [6, { state: 'positive', targetOpacity: 0.6 }],
  [43, { state: 'positive', targetOpacity: 0.7 }],
  [42, { state: 'positive', targetOpacity: 0.6 }],
  [169, { state: 'positive', targetOpacity: 0.7 }],
  [281, { state: 'positive', targetOpacity: 0.7 }],
  [470, { state: 'positive', targetOpacity: 0.7 }],
  [469, { state: 'negative', targetOpacity: 0.6 }],
  [619, { state: 'positive', targetOpacity: 0.7 }],
  [618, { state: 'positive', targetOpacity: 0.6 }],
  [671, { state: 'positive', targetOpacity: 0.7 }],
  [670, { state: 'positive', targetOpacity: 0.6 }],
  [0, { state: 'positive', targetOpacity: 0.05 }],
  [1, { state: 'positive', targetOpacity: 0.1 }],
  [2, { state: 'positive', targetOpacity: 0.15 }],
  [3, { state: 'positive', targetOpacity: 0.3 }],
  [4, { state: 'positive', targetOpacity: 0.3 }],
  [5, { state: 'positive', targetOpacity: 0.4 }],
  [10, { state: 'positive', targetOpacity: 0.6 }],
  [11, { state: 'positive', targetOpacity: 0.7 }],
  [12, { state: 'positive', targetOpacity: 0.7 }],
  [13, { state: 'positive', targetOpacity: 0.7 }],
  [14, { state: 'positive', targetOpacity: 0.7 }],
  [15, { state: 'positive', targetOpacity: 0.7 }],
  [16, { state: 'positive', targetOpacity: 0.6 }],
  [17, { state: 'positive', targetOpacity: 0.7 }],
  [18, { state: 'positive', targetOpacity: 0.7 }],
  [19, { state: 'positive', targetOpacity: 0.7 }],
  [20, { state: 'positive', targetOpacity: 0.7 }],
  [21, { state: 'positive', targetOpacity: 0.7 }],
  [22, { state: 'positive', targetOpacity: 0.6 }],
  [23, { state: 'positive', targetOpacity: 0.7 }],
  [24, { state: 'positive', targetOpacity: 0.7 }],
  [25, { state: 'positive', targetOpacity: 0.7 }],
  [28, { state: 'positive', targetOpacity: 0.7 }],
  [29, { state: 'positive', targetOpacity: 0.7 }],
  [36, { state: 'positive', targetOpacity: 0.4 }],
  [37, { state: 'positive', targetOpacity: 0.6 }],
  [38, { state: 'positive', targetOpacity: 0.7 }],
  [39, { state: 'positive', targetOpacity: 0.7 }],
  [40, { state: 'positive', targetOpacity: 0.7 }],
  [48, { state: 'positive', targetOpacity: 0.4 }],
  [49, { state: 'positive', targetOpacity: 0.6 }],
  [50, { state: 'positive', targetOpacity: 0.15 }],
  [51, { state: 'positive', targetOpacity: 0.3 }],
  [52, { state: 'positive', targetOpacity: 0.4 }],
  [53, { state: 'positive', targetOpacity: 0.6 }],
  [54, { state: 'positive', targetOpacity: 0.7 }],
  [59, { state: 'positive', targetOpacity: 0.7 }],
  [60, { state: 'positive', targetOpacity: 0.7 }],
  [61, { state: 'positive', targetOpacity: 0.7 }],
  [62, { state: 'positive', targetOpacity: 0.7 }],
  [63, { state: 'positive', targetOpacity: 0.7 }],
  [81, { state: 'positive', targetOpacity: 0.4 }],
  [82, { state: 'positive', targetOpacity: 0.6 }],
  [83, { state: 'positive', targetOpacity: 0.7 }],
  [86, { state: 'positive', targetOpacity: 0.7 }],
  [87, { state: 'positive', targetOpacity: 0.7 }],
  [89, { state: 'positive', targetOpacity: 0.7 }],
  [90, { state: 'positive', targetOpacity: 0.7 }],
  [91, { state: 'positive', targetOpacity: 0.7 }],
  [92, { state: 'positive', targetOpacity: 0.7 }],
  [93, { state: 'positive', targetOpacity: 0.7 }],
  [97, { state: 'positive', targetOpacity: 0.4 }],
  [107, { state: 'positive', targetOpacity: 0.6 }],
  [108, { state: 'positive', targetOpacity: 0.7 }],
  [109, { state: 'positive', targetOpacity: 0.7 }],
  [110, { state: 'positive', targetOpacity: 0.7 }],
  [113, { state: 'positive', targetOpacity: 0.7 }],
  [114, { state: 'positive', targetOpacity: 0.7 }],
  [115, { state: 'positive', targetOpacity: 0.7 }],
  [116, { state: 'positive', targetOpacity: 0.7 }],
  [117, { state: 'positive', targetOpacity: 0.7 }],
  [119, { state: 'positive', targetOpacity: 0.6 }],
  [125, { state: 'positive', targetOpacity: 0.7 }],
  [129, { state: 'positive', targetOpacity: 0.7 }],
  [130, { state: 'positive', targetOpacity: 0.7 }],
  [132, { state: 'positive', targetOpacity: 0.3 }],
  [144, { state: 'positive', targetOpacity: 0.4 }],
  [145, { state: 'positive', targetOpacity: 0.6 }],
  [146, { state: 'positive', targetOpacity: 0.7 }],
  [147, { state: 'positive', targetOpacity: 0.7 }],
  [148, { state: 'positive', targetOpacity: 0.7 }],
  [149, { state: 'positive', targetOpacity: 0.7 }],
  [150, { state: 'positive', targetOpacity: 0.7 }],
  [151, { state: 'positive', targetOpacity: 0.4 }],
  [152, { state: 'positive', targetOpacity: 0.6 }],
  [153, { state: 'positive', targetOpacity: 0.7 }],
  [156, { state: 'positive', targetOpacity: 0.7 }],
  [157, { state: 'positive', targetOpacity: 0.7 }],
  [158, { state: 'positive', targetOpacity: 0.3 }],
  [159, { state: 'positive', targetOpacity: 0.4 }],
  [160, { state: 'positive', targetOpacity: 0.6 }],
  [161, { state: 'positive', targetOpacity: 0.6 }],
  [162, { state: 'positive', targetOpacity: 0.7 }],
  [164, { state: 'positive', targetOpacity: 0.7 }],
  [165, { state: 'positive', targetOpacity: 0.7 }],
  [166, { state: 'positive', targetOpacity: 0.7 }],
  [167, { state: 'positive', targetOpacity: 0.7 }],
  [177, { state: 'positive', targetOpacity: 0.7 }],
  [178, { state: 'positive', targetOpacity: 0.7 }],
  [179, { state: 'positive', targetOpacity: 0.7 }],
  [184, { state: 'positive', targetOpacity: 0.6 }],
  [185, { state: 'positive', targetOpacity: 0.4 }],
  [186, { state: 'positive', targetOpacity: 0.6 }],
  [187, { state: 'positive', targetOpacity: 0.7 }],
  [189, { state: 'positive', targetOpacity: 0.7 }],
  [190, { state: 'positive', targetOpacity: 0.7 }],
  [191, { state: 'positive', targetOpacity: 0.6 }],
  [192, { state: 'positive', targetOpacity: 0.7 }],
  [194, { state: 'positive', targetOpacity: 0.7 }],
  [195, { state: 'positive', targetOpacity: 0.7 }],
  [197, { state: 'positive', targetOpacity: 0.7 }],
  [201, { state: 'positive', targetOpacity: 0.7 }],
  [202, { state: 'positive', targetOpacity: 0.7 }],
  [203, { state: 'positive', targetOpacity: 0.7 }],
  [204, { state: 'positive', targetOpacity: 0.7 }],
  [205, { state: 'positive', targetOpacity: 0.7 }],
  [206, { state: 'positive', targetOpacity: 0.7 }],
  [207, { state: 'positive', targetOpacity: 0.7 }],
  [208, { state: 'positive', targetOpacity: 0.7 }],
  [209, { state: 'positive', targetOpacity: 0.7 }],
  [210, { state: 'positive', targetOpacity: 0.6 }],
  [216, { state: 'positive', targetOpacity: 0.7 }],
  [217, { state: 'positive', targetOpacity: 0.7 }],
  [218, { state: 'positive', targetOpacity: 0.7 }],
  [220, { state: 'positive', targetOpacity: 0.15 }],
  [221, { state: 'positive', targetOpacity: 0.3 }],
  [222, { state: 'positive', targetOpacity: 0.4 }],
  [223, { state: 'positive', targetOpacity: 0.6 }],
  [224, { state: 'positive', targetOpacity: 0.4 }],
  [225, { state: 'positive', targetOpacity: 0.3 }],
  [226, { state: 'positive', targetOpacity: 0.4 }],
  [227, { state: 'positive', targetOpacity: 0.6 }],
  [228, { state: 'positive', targetOpacity: 0.7 }],
  [229, { state: 'positive', targetOpacity: 0.7 }],
  [230, { state: 'positive', targetOpacity: 0.7 }],
  [232, { state: 'positive', targetOpacity: 0.4 }],
  [233, { state: 'positive', targetOpacity: 0.3 }],
  [234, { state: 'positive', targetOpacity: 0.4 }],
  [235, { state: 'positive', targetOpacity: 0.15 }],
  [236, { state: 'positive', targetOpacity: 0.3 }],
  [237, { state: 'positive', targetOpacity: 0.4 }],
  [238, { state: 'positive', targetOpacity: 0.3 }],
  [239, { state: 'positive', targetOpacity: 0.4 }],
  [240, { state: 'positive', targetOpacity: 0.6 }],
  [241, { state: 'positive', targetOpacity: 0.6 }],
  [242, { state: 'positive', targetOpacity: 0.7 }],
  [243, { state: 'positive', targetOpacity: 0.7 }],
  [244, { state: 'positive', targetOpacity: 0.7 }],
  [246, { state: 'positive', targetOpacity: 0.6 }],
  [247, { state: 'positive', targetOpacity: 0.6 }],
  [248, { state: 'positive', targetOpacity: 0.1 }],
  [249, { state: 'positive', targetOpacity: 0.1 }],
  [250, { state: 'positive', targetOpacity: 0.15 }],
  [251, { state: 'positive', targetOpacity: 0.3 }],
  [252, { state: 'positive', targetOpacity: 0.4 }],
  [253, { state: 'positive', targetOpacity: 0.6 }],
  [254, { state: 'positive', targetOpacity: 0.7 }],
  [255, { state: 'positive', targetOpacity: 0.6 }],
  [263, { state: 'positive', targetOpacity: 0.3 }],
  [264, { state: 'positive', targetOpacity: 0.3 }],
  [265, { state: 'positive', targetOpacity: 0.4 }],
  [266, { state: 'positive', targetOpacity: 0.4 }],
  [267, { state: 'positive', targetOpacity: 0.15 }],
  [268, { state: 'positive', targetOpacity: 0.15 }],
  [269, { state: 'positive', targetOpacity: 0.3 }],
  [270, { state: 'positive', targetOpacity: 0.4 }],
  [271, { state: 'positive', targetOpacity: 0.6 }],
  [272, { state: 'positive', targetOpacity: 0.7 }],
  [276, { state: 'positive', targetOpacity: 0.7 }],
  [277, { state: 'positive', targetOpacity: 0.7 }],
  [278, { state: 'positive', targetOpacity: 0.6 }],
  [279, { state: 'positive', targetOpacity: 0.7 }],
  [280, { state: 'positive', targetOpacity: 0.7 }],
  [284, { state: 'positive', targetOpacity: 0.6 }],
  [285, { state: 'positive', targetOpacity: 0.7 }],
  [290, { state: 'positive', targetOpacity: 0.7 }],
  [291, { state: 'positive', targetOpacity: 0.7 }],
  [292, { state: 'positive', targetOpacity: 0.4 }],
  [293, { state: 'positive', targetOpacity: 0.6 }],
  [294, { state: 'positive', targetOpacity: 0.7 }],
  [295, { state: 'positive', targetOpacity: 0.7 }],
  [296, { state: 'positive', targetOpacity: 0.7 }],
  [297, { state: 'positive', targetOpacity: 0.6 }],
  [298, { state: 'positive', targetOpacity: 0.7 }],
  [299, { state: 'positive', targetOpacity: 0.7 }],
  [300, { state: 'positive', targetOpacity: 0.7 }],
  [301, { state: 'positive', targetOpacity: 0.7 }],
  [302, { state: 'positive', targetOpacity: 0.7 }],
  [304, { state: 'positive', targetOpacity: 0.6 }],
  [305, { state: 'positive', targetOpacity: 0.7 }],
  [309, { state: 'positive', targetOpacity: 0.7 }],
  [310, { state: 'positive', targetOpacity: 0.7 }],
  [314, { state: 'positive', targetOpacity: 0.6 }],
  [315, { state: 'positive', targetOpacity: 0.7 }],
  [316, { state: 'positive', targetOpacity: 0.7 }],
  [317, { state: 'positive', targetOpacity: 0.7 }],
  [323, { state: 'positive', targetOpacity: 0.3 }],
  [324, { state: 'positive', targetOpacity: 0.4 }],
  [325, { state: 'positive', targetOpacity: 0.4 }],
  [326, { state: 'positive', targetOpacity: 0.6 }],
  [327, { state: 'positive', targetOpacity: 0.7 }],
  [328, { state: 'positive', targetOpacity: 0.7 }],
  [329, { state: 'positive', targetOpacity: 0.7 }],
  [330, { state: 'positive', targetOpacity: 0.7 }],
  [331, { state: 'positive', targetOpacity: 0.7 }],
  [336, { state: 'positive', targetOpacity: 0.7 }],
  [337, { state: 'positive', targetOpacity: 0.7 }],
  [338, { state: 'positive', targetOpacity: 0.7 }],
  [340, { state: 'positive', targetOpacity: 0.6 }],
  [341, { state: 'positive', targetOpacity: 0.4 }],
  [342, { state: 'positive', targetOpacity: 0.6 }],
  [343, { state: 'positive', targetOpacity: 0.4 }],
  [344, { state: 'positive', targetOpacity: 0.6 }],
  [345, { state: 'positive', targetOpacity: 0.15 }],
  [346, { state: 'positive', targetOpacity: 0.3 }],
  [347, { state: 'positive', targetOpacity: 0.4 }],
  [348, { state: 'positive', targetOpacity: 0.3 }],
  [349, { state: 'positive', targetOpacity: 0.4 }],
  [350, { state: 'positive', targetOpacity: 0.6 }],
  [351, { state: 'positive', targetOpacity: 0.7 }],
  [353, { state: 'positive', targetOpacity: 0.7 }],
  [354, { state: 'positive', targetOpacity: 0.7 }],
  [355, { state: 'positive', targetOpacity: 0.4 }],
  [356, { state: 'positive', targetOpacity: 0.6 }],
  [357, { state: 'positive', targetOpacity: 0.6 }],
  [358, { state: 'positive', targetOpacity: 0.1 }],
  [359, { state: 'positive', targetOpacity: 0.15 }],
  [360, { state: 'positive', targetOpacity: 0.3 }],
  [361, { state: 'positive', targetOpacity: 0.4 }],
  [362, { state: 'positive', targetOpacity: 0.4 }],
  [363, { state: 'positive', targetOpacity: 0.6 }],
  [364, { state: 'positive', targetOpacity: 0.6 }],
  [365, { state: 'positive', targetOpacity: 0.7 }],
  [366, { state: 'positive', targetOpacity: 0.7 }],
  [367, { state: 'positive', targetOpacity: 0.7 }],
  [368, { state: 'positive', targetOpacity: 0.7 }],
  [369, { state: 'positive', targetOpacity: 0.7 }],
  [370, { state: 'positive', targetOpacity: 0.7 }],
  [371, { state: 'positive', targetOpacity: 0.7 }],
  [372, { state: 'positive', targetOpacity: 0.7 }],
  [373, { state: 'positive', targetOpacity: 0.7 }],
  [374, { state: 'positive', targetOpacity: 0.4 }],
  [375, { state: 'positive', targetOpacity: 0.6 }],
  [376, { state: 'positive', targetOpacity: 0.6 }],
  [377, { state: 'positive', targetOpacity: 0.3 }],
  [378, { state: 'positive', targetOpacity: 0.15 }],
  [379, { state: 'positive', targetOpacity: 0.3 }],
  [390, { state: 'positive', targetOpacity: 0.4 }],
  [391, { state: 'positive', targetOpacity: 0.6 }],
  [392, { state: 'positive', targetOpacity: 0.7 }],
  [393, { state: 'positive', targetOpacity: 0.7 }],
  [399, { state: 'positive', targetOpacity: 0.6 }],
  [400, { state: 'positive', targetOpacity: 0.7 }],
  [402, { state: 'positive', targetOpacity: 0.7 }],
  [403, { state: 'positive', targetOpacity: 0.7 }],
  [404, { state: 'positive', targetOpacity: 0.3 }],
  [405, { state: 'positive', targetOpacity: 0.4 }],
  [406, { state: 'positive', targetOpacity: 0.6 }],
  [407, { state: 'positive', targetOpacity: 0.4 }],
  [408, { state: 'positive', targetOpacity: 0.4 }],
  [409, { state: 'positive', targetOpacity: 0.15 }],
  [410, { state: 'positive', targetOpacity: 0.3 }],
  [411, { state: 'positive', targetOpacity: 0.4 }],
  [412, { state: 'positive', targetOpacity: 0.6 }],
  [413, { state: 'positive', targetOpacity: 0.6 }],
  [414, { state: 'positive', targetOpacity: 0.4 }],
  [415, { state: 'positive', targetOpacity: 0.15 }],
  [416, { state: 'positive', targetOpacity: 0.3 }],
  [417, { state: 'positive', targetOpacity: 0.4 }],
  [418, { state: 'positive', targetOpacity: 0.6 }],
  [419, { state: 'positive', targetOpacity: 0.6 }],
  [420, { state: 'positive', targetOpacity: 0.6 }],
  [421, { state: 'positive', targetOpacity: 0.4 }],
  [422, { state: 'positive', targetOpacity: 0.6 }],
  [423, { state: 'positive', targetOpacity: 0.6 }],
  [424, { state: 'positive', targetOpacity: 0.6 }],
  [425, { state: 'positive', targetOpacity: 0.7 }],
  [426, { state: 'positive', targetOpacity: 0.7 }],
  [427, { state: 'positive', targetOpacity: 0.7 }],
  [428, { state: 'positive', targetOpacity: 0.7 }],
  [429, { state: 'positive', targetOpacity: 0.7 }],
  [430, { state: 'positive', targetOpacity: 0.4 }],
  [431, { state: 'positive', targetOpacity: 0.3 }],
  [432, { state: 'positive', targetOpacity: 0.4 }],
  [433, { state: 'positive', targetOpacity: 0.6 }],
  [434, { state: 'positive', targetOpacity: 0.7 }],
  [435, { state: 'positive', targetOpacity: 0.7 }],
  [436, { state: 'positive', targetOpacity: 0.7 }],
  [438, { state: 'positive', targetOpacity: 0.6 }],
  [439, { state: 'positive', targetOpacity: 0.7 }],
  [442, { state: 'positive', targetOpacity: 0.7 }],
  [443, { state: 'positive', targetOpacity: 0.7 }],
  [445, { state: 'positive', targetOpacity: 0.6 }],
  [446, { state: 'positive', targetOpacity: 0.7 }],
  [450, { state: 'positive', targetOpacity: 0.7 }],
  [451, { state: 'positive', targetOpacity: 0.7 }],
  [454, { state: 'positive', targetOpacity: 0.7 }],
  [455, { state: 'positive', targetOpacity: 0.7 }],
  [456, { state: 'positive', targetOpacity: 0.7 }],
  [463, { state: 'positive', targetOpacity: 0.7 }],
  [464, { state: 'positive', targetOpacity: 0.7 }],
  [481, { state: 'positive', targetOpacity: 0.6 }],
  [482, { state: 'positive', targetOpacity: 0.1 }],
  [483, { state: 'positive', targetOpacity: 0.1 }],
  [484, { state: 'positive', targetOpacity: 0.15 }],
  [485, { state: 'positive', targetOpacity: 0.3 }],
  [486, { state: 'positive', targetOpacity: 0.3 }],
  [487, { state: 'positive', targetOpacity: 0.4 }],
  [488, { state: 'positive', targetOpacity: 0.6 }],
  [489, { state: 'positive', targetOpacity: 0.6 }],
  [490, { state: 'positive', targetOpacity: 0.7 }],
  [491, { state: 'positive', targetOpacity: 0.7 }],
  [492, { state: 'positive', targetOpacity: 0.7 }],
  [496, { state: 'positive', targetOpacity: 0.6 }],
  [497, { state: 'positive', targetOpacity: 0.4 }],
  [498, { state: 'positive', targetOpacity: 0.6 }],
  [499, { state: 'positive', targetOpacity: 0.7 }],
  [500, { state: 'positive', targetOpacity: 0.7 }],
  [501, { state: 'positive', targetOpacity: 0.7 }],
  [502, { state: 'positive', targetOpacity: 0.7 }],
  [503, { state: 'positive', targetOpacity: 0.7 }],
  [507, { state: 'positive', targetOpacity: 0.7 }],
  [508, { state: 'positive', targetOpacity: 0.7 }],
  [509, { state: 'positive', targetOpacity: 0.7 }],
  [510, { state: 'positive', targetOpacity: 0.7 }],
  [511, { state: 'positive', targetOpacity: 0.6 }],
  [512, { state: 'positive', targetOpacity: 0.15 }],
  [513, { state: 'positive', targetOpacity: 0.3 }],
  [514, { state: 'positive', targetOpacity: 0.4 }],
  [515, { state: 'positive', targetOpacity: 0.6 }],
  [516, { state: 'positive', targetOpacity: 0.7 }],
  [517, { state: 'positive', targetOpacity: 0.7 }],
  [518, { state: 'positive', targetOpacity: 0.7 }],
  [519, { state: 'positive', targetOpacity: 0.6 }],
  [520, { state: 'positive', targetOpacity: 0.7 }],
  [521, { state: 'positive', targetOpacity: 0.7 }],
  [522, { state: 'positive', targetOpacity: 0.4 }],
  [523, { state: 'positive', targetOpacity: 0.6 }],
  [524, { state: 'positive', targetOpacity: 0.6 }],
  [525, { state: 'positive', targetOpacity: 0.7 }],
  [530, { state: 'positive', targetOpacity: 0.7 }],
  [531, { state: 'positive', targetOpacity: 0.7 }],
  [542, { state: 'positive', targetOpacity: 0.4 }],
  [543, { state: 'positive', targetOpacity: 0.6 }],
  [544, { state: 'positive', targetOpacity: 0.6 }],
  [545, { state: 'positive', targetOpacity: 0.7 }],
  [546, { state: 'positive', targetOpacity: 0.7 }],
  [547, { state: 'positive', targetOpacity: 0.7 }],
  [549, { state: 'positive', targetOpacity: 0.3 }],
  [550, { state: 'positive', targetOpacity: 0.4 }],
  [551, { state: 'positive', targetOpacity: 0.6 }],
  [552, { state: 'positive', targetOpacity: 0.7 }],
  [556, { state: 'positive', targetOpacity: 0.7 }],
  [557, { state: 'positive', targetOpacity: 0.7 }],
  [558, { state: 'positive', targetOpacity: 0.7 }],
  [559, { state: 'positive', targetOpacity: 0.7 }],
  [560, { state: 'positive', targetOpacity: 0.6 }],
  [561, { state: 'positive', targetOpacity: 0.7 }],
  [565, { state: 'positive', targetOpacity: 0.7 }],
  [566, { state: 'positive', targetOpacity: 0.7 }],
  [570, { state: 'positive', targetOpacity: 0.3 }],
  [571, { state: 'positive', targetOpacity: 0.4 }],
  [572, { state: 'positive', targetOpacity: 0.6 }],
  [586, { state: 'positive', targetOpacity: 0.7 }],
  [587, { state: 'positive', targetOpacity: 0.7 }],
  [588, { state: 'positive', targetOpacity: 0.7 }],
  [593, { state: 'positive', targetOpacity: 0.6 }],
  [594, { state: 'positive', targetOpacity: 0.4 }],
  [595, { state: 'positive', targetOpacity: 0.1 }],
  [596, { state: 'positive', targetOpacity: 0.15 }],
  [597, { state: 'positive', targetOpacity: 0.3 }],
  [598, { state: 'positive', targetOpacity: 0.3 }],
  [599, { state: 'positive', targetOpacity: 0.4 }],
  [600, { state: 'positive', targetOpacity: 0.6 }],
  [606, { state: 'positive', targetOpacity: 0.7 }],
  [607, { state: 'positive', targetOpacity: 0.7 }],
  [608, { state: 'positive', targetOpacity: 0.7 }],
  [612, { state: 'positive', targetOpacity: 0.7 }],
  [613, { state: 'positive', targetOpacity: 0.7 }],
  [614, { state: 'positive', targetOpacity: 0.7 }],
  [616, { state: 'positive', targetOpacity: 0.3 }],
  [617, { state: 'positive', targetOpacity: 0.4 }],
  [623, { state: 'positive', targetOpacity: 0.6 }],
  [624, { state: 'positive', targetOpacity: 0.15 }],
  [625, { state: 'positive', targetOpacity: 0.3 }],
  [626, { state: 'positive', targetOpacity: 0.15 }],
  [627, { state: 'positive', targetOpacity: 0.3 }],
  [628, { state: 'positive', targetOpacity: 0.4 }],
  [641, { state: 'positive', targetOpacity: 0.6 }],
  [642, { state: 'positive', targetOpacity: 0.4 }],
  [649, { state: 'positive', targetOpacity: 0.6 }],
  [650, { state: 'positive', targetOpacity: 0.7 }],
  [651, { state: 'positive', targetOpacity: 0.7 }],
  [652, { state: 'positive', targetOpacity: 0.7 }],
  [667, { state: 'positive', targetOpacity: 0.3 }],
  [668, { state: 'positive', targetOpacity: 0.4 }],
  [669, { state: 'positive', targetOpacity: 0.6 }],
  [675, { state: 'positive', targetOpacity: 0.6 }],
  [676, { state: 'positive', targetOpacity: 0.7 }],
  [677, { state: 'positive', targetOpacity: 0.7 }],
]

export const STATIC_DEPTH_MAP: Array<[number, number]> = [
  [0, 0],
  [1, 1],
  [2, 2],
  [3, 3],
  [4, 3],
  [5, 4],
  [6, 5],
  [7, 6],
  [8, 7],
  [9, 7],
  [10, 5],
  [11, 6],
  [12, 7],
  [13, 8],
  [14, 7],
  [15, 8],
  [16, 5],
  [17, 6],
  [18, 7],
  [19, 8],
  [20, 7],
  [21, 8],
  [22, 5],
  [23, 6],
  [24, 7],
  [25, 8],
  [26, 7],
  [27, 7],
  [28, 7],
  [29, 8],
  [30, 5],
  [31, 6],
  [32, 7],
  [33, 8],
  [34, 8],
  [35, 5],
  [36, 4],
  [37, 5],
  [38, 6],
  [39, 7],
  [40, 8],
  [41, 5],
  [42, 5],
  [43, 6],
  [44, 7],
  [45, 7],
  [46, 7],
  [47, 7],
  [48, 4],
  [49, 5],
  [50, 2],
  [51, 3],
  [52, 4],
  [53, 5],
  [54, 6],
  [55, 7],
  [56, 7],
  [57, 8],
  [58, 8],
  [59, 7],
  [60, 8],
  [61, 6],
  [62, 7],
  [63, 8],
  [64, 7],
  [65, 8],
  [66, 8],
  [67, 7],
  [68, 8],
  [69, 8],
  [70, 7],
  [71, 5],
  [72, 6],
  [73, 7],
  [74, 7],
  [75, 8],
  [76, 8],
  [77, 8],
  [78, 7],
  [79, 5],
  [80, 5],
  [81, 4],
  [82, 5],
  [83, 6],
  [84, 7],
  [85, 7],
  [86, 7],
  [87, 8],
  [88, 7],
  [89, 6],
  [90, 7],
  [91, 8],
  [92, 7],
  [93, 8],
  [94, 7],
  [95, 8],
  [96, 8],
  [97, 4],
  [98, 5],
  [99, 6],
  [100, 7],
  [101, 7],
  [102, 7],
  [103, 7],
  [104, 8],
  [105, 8],
  [106, 5],
  [107, 5],
  [108, 6],
  [109, 7],
  [110, 8],
  [111, 7],
  [112, 7],
  [113, 6],
  [114, 7],
  [115, 8],
  [116, 7],
  [117, 8],
  [118, 5],
  [119, 5],
  [120, 6],
  [121, 7],
  [122, 7],
  [123, 8],
  [124, 8],
  [125, 6],
  [126, 7],
  [127, 8],
  [128, 8],
  [129, 7],
  [130, 8],
  [131, 7],
  [132, 3],
  [133, 4],
  [134, 5],
  [135, 5],
  [136, 6],
  [137, 7],
  [138, 7],
  [139, 7],
  [140, 8],
  [141, 8],
  [142, 8],
  [143, 7],
  [144, 4],
  [145, 5],
  [146, 6],
  [147, 7],
  [148, 8],
  [149, 7],
  [150, 8],
  [151, 4],
  [152, 5],
  [153, 6],
  [154, 7],
  [155, 7],
  [156, 7],
  [157, 8],
  [158, 3],
  [159, 4],
  [160, 5],
  [161, 5],
  [162, 6],
  [163, 7],
  [164, 7],
  [165, 8],
  [166, 7],
  [167, 8],
  [168, 7],
  [169, 6],
  [170, 7],
  [171, 7],
  [172, 6],
  [173, 7],
  [174, 8],
  [175, 8],
  [176, 7],
  [177, 6],
  [178, 7],
  [179, 8],
  [180, 7],
  [181, 7],
  [182, 8],
  [183, 8],
  [184, 5],
  [185, 4],
  [186, 5],
  [187, 6],
  [188, 7],
  [189, 7],
  [190, 8],
  [191, 5],
  [192, 6],
  [193, 7],
  [194, 7],
  [195, 8],
  [196, 7],
  [197, 6],
  [198, 7],
  [199, 8],
  [200, 8],
  [201, 7],
  [202, 8],
  [203, 6],
  [204, 7],
  [205, 8],
  [206, 7],
  [207, 8],
  [208, 7],
  [209, 8],
  [210, 5],
  [211, 6],
  [212, 7],
  [213, 7],
  [214, 8],
  [215, 8],
  [216, 6],
  [217, 7],
  [218, 8],
  [219, 7],
  [220, 2],
  [221, 3],
  [222, 4],
  [223, 5],
  [224, 4],
  [225, 3],
  [226, 4],
  [227, 5],
  [228, 6],
  [229, 7],
  [230, 8],
  [231, 7],
  [232, 4],
  [233, 3],
  [234, 4],
  [235, 2],
  [236, 3],
  [237, 4],
  [238, 3],
  [239, 4],
  [240, 5],
  [241, 5],
  [242, 6],
  [243, 7],
  [244, 8],
  [245, 7],
  [246, 5],
  [247, 5],
  [248, 1],
  [249, 1],
  [250, 2],
  [251, 3],
  [252, 4],
  [253, 5],
  [254, 6],
  [255, 5],
  [256, 4],
  [257, 5],
  [258, 6],
  [259, 7],
  [260, 8],
  [261, 8],
  [262, 7],
  [263, 3],
  [264, 3],
  [265, 4],
  [266, 4],
  [267, 2],
  [268, 2],
  [269, 3],
  [270, 4],
  [271, 5],
  [272, 6],
  [273, 7],
  [274, 8],
  [275, 8],
  [276, 7],
  [277, 8],
  [278, 5],
  [279, 6],
  [280, 7],
  [281, 6],
  [282, 7],
  [283, 7],
  [284, 5],
  [285, 6],
  [286, 7],
  [287, 8],
  [288, 8],
  [289, 7],
  [290, 7],
  [291, 8],
  [292, 4],
  [293, 5],
  [294, 6],
  [295, 7],
  [296, 8],
  [297, 5],
  [298, 6],
  [299, 7],
  [300, 8],
  [301, 7],
  [302, 8],
  [303, 7],
  [304, 5],
  [305, 6],
  [306, 7],
  [307, 8],
  [308, 8],
  [309, 7],
  [310, 8],
  [311, 7],
  [312, 8],
  [313, 8],
  [314, 5],
  [315, 6],
  [316, 7],
  [317, 8],
  [318, 7],
  [319, 8],
  [320, 8],
  [321, 7],
  [322, 7],
  [323, 3],
  [324, 4],
  [325, 4],
  [326, 5],
  [327, 6],
  [328, 7],
  [329, 8],
  [330, 7],
  [331, 8],
  [332, 7],
  [333, 7],
  [334, 8],
  [335, 8],
  [336, 6],
  [337, 7],
  [338, 8],
  [339, 7],
  [340, 5],
  [341, 4],
  [342, 5],
  [343, 4],
  [344, 5],
  [345, 2],
  [346, 3],
  [347, 4],
  [348, 3],
  [349, 4],
  [350, 5],
  [351, 6],
  [352, 7],
  [353, 7],
  [354, 8],
  [355, 4],
  [356, 5],
  [357, 5],
  [358, 1],
  [359, 2],
  [360, 3],
  [361, 4],
  [362, 4],
  [363, 5],
  [364, 5],
  [365, 6],
  [366, 7],
  [367, 8],
  [368, 7],
  [369, 8],
  [370, 7],
  [371, 8],
  [372, 7],
  [373, 8],
  [374, 4],
  [375, 5],
  [376, 5],
  [377, 3],
  [378, 2],
  [379, 3],
  [380, 4],
  [381, 5],
  [382, 6],
  [383, 7],
  [384, 7],
  [385, 8],
  [386, 8],
  [387, 7],
  [388, 8],
  [389, 8],
  [390, 4],
  [391, 5],
  [392, 6],
  [393, 7],
  [394, 6],
  [395, 7],
  [396, 7],
  [397, 8],
  [398, 8],
  [399, 5],
  [400, 6],
  [401, 7],
  [402, 7],
  [403, 8],
  [404, 3],
  [405, 4],
  [406, 5],
  [407, 4],
  [408, 4],
  [409, 2],
  [410, 3],
  [411, 4],
  [412, 5],
  [413, 5],
  [414, 4],
  [415, 2],
  [416, 3],
  [417, 4],
  [418, 5],
  [419, 5],
  [420, 5],
  [421, 4],
  [422, 5],
  [423, 5],
  [424, 5],
  [425, 6],
  [426, 7],
  [427, 8],
  [428, 6],
  [429, 7],
  [430, 4],
  [431, 3],
  [432, 4],
  [433, 5],
  [434, 6],
  [435, 7],
  [436, 8],
  [437, 7],
  [438, 5],
  [439, 6],
  [440, 7],
  [441, 7],
  [442, 7],
  [443, 8],
  [444, 7],
  [445, 5],
  [446, 6],
  [447, 7],
  [448, 8],
  [449, 8],
  [450, 7],
  [451, 8],
  [452, 7],
  [453, 7],
  [454, 7],
  [455, 8],
  [456, 6],
  [457, 7],
  [458, 8],
  [459, 8],
  [460, 7],
  [461, 8],
  [462, 8],
  [463, 7],
  [464, 8],
  [465, 7],
  [466, 8],
  [467, 8],
  [468, 8],
  [469, 5],
  [470, 6],
  [471, 7],
  [472, 7],
  [473, 6],
  [474, 7],
  [475, 8],
  [476, 8],
  [477, 8],
  [478, 8],
  [479, 7],
  [480, 7],
  [481, 5],
  [482, 1],
  [483, 1],
  [484, 2],
  [485, 3],
  [486, 3],
  [487, 4],
  [488, 5],
  [489, 5],
  [490, 6],
  [491, 7],
  [492, 8],
  [493, 7],
  [494, 8],
  [495, 8],
  [496, 5],
  [497, 4],
  [498, 5],
  [499, 6],
  [500, 7],
  [501, 8],
  [502, 7],
  [503, 8],
  [504, 7],
  [505, 8],
  [506, 8],
  [507, 7],
  [508, 8],
  [509, 7],
  [510, 8],
  [511, 5],
  [512, 2],
  [513, 3],
  [514, 4],
  [515, 5],
  [516, 6],
  [517, 7],
  [518, 8],
  [519, 5],
  [520, 6],
  [521, 7],
  [522, 4],
  [523, 5],
  [524, 5],
  [525, 6],
  [526, 7],
  [527, 8],
  [528, 8],
  [529, 8],
  [530, 7],
  [531, 8],
  [532, 5],
  [533, 6],
  [534, 7],
  [535, 7],
  [536, 8],
  [537, 8],
  [538, 7],
  [539, 8],
  [540, 8],
  [541, 7],
  [542, 4],
  [543, 5],
  [544, 5],
  [545, 6],
  [546, 7],
  [547, 8],
  [548, 7],
  [549, 3],
  [550, 4],
  [551, 5],
  [552, 6],
  [553, 7],
  [554, 8],
  [555, 8],
  [556, 7],
  [557, 8],
  [558, 7],
  [559, 8],
  [560, 5],
  [561, 6],
  [562, 7],
  [563, 8],
  [564, 8],
  [565, 7],
  [566, 8],
  [567, 7],
  [568, 7],
  [569, 7],
  [570, 3],
  [571, 4],
  [572, 5],
  [573, 6],
  [574, 7],
  [575, 8],
  [576, 8],
  [577, 8],
  [578, 8],
  [579, 7],
  [580, 7],
  [581, 6],
  [582, 7],
  [583, 8],
  [584, 8],
  [585, 7],
  [586, 6],
  [587, 7],
  [588, 8],
  [589, 7],
  [590, 8],
  [591, 8],
  [592, 7],
  [593, 5],
  [594, 4],
  [595, 1],
  [596, 2],
  [597, 3],
  [598, 3],
  [599, 4],
  [600, 5],
  [601, 6],
  [602, 7],
  [603, 7],
  [604, 8],
  [605, 8],
  [606, 6],
  [607, 7],
  [608, 8],
  [609, 7],
  [610, 7],
  [611, 7],
  [612, 6],
  [613, 7],
  [614, 8],
  [615, 7],
  [616, 3],
  [617, 4],
  [618, 5],
  [619, 6],
  [620, 7],
  [621, 7],
  [622, 7],
  [623, 5],
  [624, 2],
  [625, 3],
  [626, 2],
  [627, 3],
  [628, 4],
  [629, 5],
  [630, 6],
  [631, 7],
  [632, 8],
  [633, 8],
  [634, 8],
  [635, 7],
  [636, 7],
  [637, 8],
  [638, 8],
  [639, 8],
  [640, 7],
  [641, 5],
  [642, 4],
  [643, 5],
  [644, 6],
  [645, 7],
  [646, 7],
  [647, 8],
  [648, 8],
  [649, 5],
  [650, 6],
  [651, 7],
  [652, 8],
  [653, 7],
  [654, 7],
  [655, 6],
  [656, 7],
  [657, 8],
  [658, 8],
  [659, 8],
  [660, 6],
  [661, 7],
  [662, 7],
  [663, 7],
  [664, 8],
  [665, 8],
  [666, 8],
  [667, 3],
  [668, 4],
  [669, 5],
  [670, 5],
  [671, 6],
  [672, 7],
  [673, 7],
  [674, 7],
  [675, 5],
  [676, 6],
  [677, 7],
]
export const STATIC_MAX_DEPTH: number = 8

export const STATIC_LINEAGE: Array<[number, string]> = [
  [0, 'A'],
  [1, 'AA'],
  [2, 'AAA'],
  [3, 'AAAA'],
  [4, 'AAAB'],
  [5, 'AAABA'],
  [6, 'AAABAA'],
  [7, 'AAABAAA'],
  [8, 'AAABAAAA'],
  [9, 'AAABAAAB'],
  [10, 'AAABAB'],
  [11, 'AAABABA'],
  [12, 'AAABABAA'],
  [13, 'AAABABAAA'],
  [14, 'AAABABAB'],
  [15, 'AAABABABA'],
  [16, 'AAABAC'],
  [17, 'AAABACA'],
  [18, 'AAABACAA'],
  [19, 'AAABACAAA'],
  [20, 'AAABACAB'],
  [21, 'AAABACABA'],
  [22, 'AAABAD'],
  [23, 'AAABADA'],
  [24, 'AAABADAA'],
  [25, 'AAABADAAA'],
  [26, 'AAABADAB'],
  [27, 'AAABADAC'],
  [28, 'AAABADAD'],
  [29, 'AAABADADA'],
  [30, 'AAABAE'],
  [31, 'AAABAEA'],
  [32, 'AAABAEAA'],
  [33, 'AAABAEAAA'],
  [34, 'AAABAEAAB'],
  [35, 'AAABAF'],
  [36, 'AAABB'],
  [37, 'AAABBA'],
  [38, 'AAABBAA'],
  [39, 'AAABBAAA'],
  [40, 'AAABBAAAA'],
  [41, 'AAABBB'],
  [42, 'AAABBC'],
  [43, 'AAABBCA'],
  [44, 'AAABBCAA'],
  [45, 'AAABBCAB'],
  [46, 'AAABBCAC'],
  [47, 'AAABBCAD'],
  [48, 'AAABC'],
  [49, 'AAABCA'],
  [50, 'AAB'],
  [51, 'AABA'],
  [52, 'AABAA'],
  [53, 'AABAAA'],
  [54, 'AABAAAA'],
  [55, 'AABAAAAA'],
  [56, 'AABAAAAB'],
  [57, 'AABAAAABA'],
  [58, 'AABAAAABB'],
  [59, 'AABAAAAC'],
  [60, 'AABAAAACA'],
  [61, 'AABAAAB'],
  [62, 'AABAAABA'],
  [63, 'AABAAABAA'],
  [64, 'AABAAABB'],
  [65, 'AABAAABBA'],
  [66, 'AABAAABBB'],
  [67, 'AABAAABC'],
  [68, 'AABAAABCA'],
  [69, 'AABAAABCB'],
  [70, 'AABAAABD'],
  [71, 'AABAAB'],
  [72, 'AABAABA'],
  [73, 'AABAABAA'],
  [74, 'AABAABAB'],
  [75, 'AABAABABA'],
  [76, 'AABAABABB'],
  [77, 'AABAABABC'],
  [78, 'AABAABAC'],
  [79, 'AABAAC'],
  [80, 'AABAAD'],
  [81, 'AABAB'],
  [82, 'AABABA'],
  [83, 'AABABAA'],
  [84, 'AABABAAA'],
  [85, 'AABABAAB'],
  [86, 'AABABAAC'],
  [87, 'AABABAACA'],
  [88, 'AABABAAD'],
  [89, 'AABABAB'],
  [90, 'AABABABA'],
  [91, 'AABABABAA'],
  [92, 'AABABABB'],
  [93, 'AABABABBA'],
  [94, 'AABABABC'],
  [95, 'AABABABCA'],
  [96, 'AABABABCB'],
  [97, 'AABAC'],
  [98, 'AABACA'],
  [99, 'AABACAA'],
  [100, 'AABACAAA'],
  [101, 'AABACAAB'],
  [102, 'AABACAAC'],
  [103, 'AABACAAD'],
  [104, 'AABACAADA'],
  [105, 'AABACAADB'],
  [106, 'AABACB'],
  [107, 'AABACC'],
  [108, 'AABACCA'],
  [109, 'AABACCAA'],
  [110, 'AABACCAAA'],
  [111, 'AABACCAB'],
  [112, 'AABACCAC'],
  [113, 'AABACCB'],
  [114, 'AABACCBA'],
  [115, 'AABACCBAA'],
  [116, 'AABACCBB'],
  [117, 'AABACCBBA'],
  [118, 'AABACD'],
  [119, 'AABACE'],
  [120, 'AABACEA'],
  [121, 'AABACEAA'],
  [122, 'AABACEAB'],
  [123, 'AABACEABA'],
  [124, 'AABACEABB'],
  [125, 'AABACEB'],
  [126, 'AABACEBA'],
  [127, 'AABACEBAA'],
  [128, 'AABACEBAB'],
  [129, 'AABACEBB'],
  [130, 'AABACEBBA'],
  [131, 'AABACEBC'],
  [132, 'AABB'],
  [133, 'AABBA'],
  [134, 'AABBAA'],
  [135, 'AABBAB'],
  [136, 'AABBABA'],
  [137, 'AABBABAA'],
  [138, 'AABBABAB'],
  [139, 'AABBABAC'],
  [140, 'AABBABACA'],
  [141, 'AABBABACB'],
  [142, 'AABBABACC'],
  [143, 'AABBABAD'],
  [144, 'AABBB'],
  [145, 'AABBBA'],
  [146, 'AABBBAA'],
  [147, 'AABBBAAA'],
  [148, 'AABBBAAAA'],
  [149, 'AABBBAAB'],
  [150, 'AABBBAABA'],
  [151, 'AABBC'],
  [152, 'AABBCA'],
  [153, 'AABBCAA'],
  [154, 'AABBCAAA'],
  [155, 'AABBCAAB'],
  [156, 'AABBCAAC'],
  [157, 'AABBCAACA'],
  [158, 'AABC'],
  [159, 'AABCA'],
  [160, 'AABCAA'],
  [161, 'AABCAB'],
  [162, 'AABCABA'],
  [163, 'AABCABAA'],
  [164, 'AABCABAB'],
  [165, 'AABCABABA'],
  [166, 'AABCABAC'],
  [167, 'AABCABACA'],
  [168, 'AABCABAD'],
  [169, 'AABCABB'],
  [170, 'AABCABBA'],
  [171, 'AABCABBB'],
  [172, 'AABCABC'],
  [173, 'AABCABCA'],
  [174, 'AABCABCAA'],
  [175, 'AABCABCAB'],
  [176, 'AABCABCB'],
  [177, 'AABCABD'],
  [178, 'AABCABDA'],
  [179, 'AABCABDAA'],
  [180, 'AABCABDB'],
  [181, 'AABCABDC'],
  [182, 'AABCABDCA'],
  [183, 'AABCABDCB'],
  [184, 'AABCAC'],
  [185, 'AABCB'],
  [186, 'AABCBA'],
  [187, 'AABCBAA'],
  [188, 'AABCBAAA'],
  [189, 'AABCBAAB'],
  [190, 'AABCBAABA'],
  [191, 'AABCBB'],
  [192, 'AABCBBA'],
  [193, 'AABCBBAA'],
  [194, 'AABCBBAB'],
  [195, 'AABCBBABA'],
  [196, 'AABCBBAC'],
  [197, 'AABCBBB'],
  [198, 'AABCBBBA'],
  [199, 'AABCBBBAA'],
  [200, 'AABCBBBAB'],
  [201, 'AABCBBBB'],
  [202, 'AABCBBBBA'],
  [203, 'AABCBBC'],
  [204, 'AABCBBCA'],
  [205, 'AABCBBCAA'],
  [206, 'AABCBBCB'],
  [207, 'AABCBBCBA'],
  [208, 'AABCBBCC'],
  [209, 'AABCBBCCA'],
  [210, 'AABCBC'],
  [211, 'AABCBCA'],
  [212, 'AABCBCAA'],
  [213, 'AABCBCAB'],
  [214, 'AABCBCABA'],
  [215, 'AABCBCABB'],
  [216, 'AABCBCB'],
  [217, 'AABCBCBA'],
  [218, 'AABCBCBAA'],
  [219, 'AABCBCBB'],
  [220, 'AAC'],
  [221, 'AACA'],
  [222, 'AACAA'],
  [223, 'AACAAA'],
  [224, 'AACAB'],
  [225, 'AACB'],
  [226, 'AACBA'],
  [227, 'AACBAA'],
  [228, 'AACBAAA'],
  [229, 'AACBAAAA'],
  [230, 'AACBAAAAA'],
  [231, 'AACBAAAB'],
  [232, 'AACBB'],
  [233, 'AACC'],
  [234, 'AACCA'],
  [235, 'AAD'],
  [236, 'AADA'],
  [237, 'AADAA'],
  [238, 'AADB'],
  [239, 'AADBA'],
  [240, 'AADBAA'],
  [241, 'AADBAB'],
  [242, 'AADBABA'],
  [243, 'AADBABAA'],
  [244, 'AADBABAAA'],
  [245, 'AADBABAB'],
  [246, 'AADBAC'],
  [247, 'AADBAD'],
  [248, 'AB'],
  [249, 'AC'],
  [250, 'ACA'],
  [251, 'ACAA'],
  [252, 'ACAAA'],
  [253, 'ACAAAA'],
  [254, 'ACAAAAA'],
  [255, 'ACAAAB'],
  [256, 'ACAAB'],
  [257, 'ACAABA'],
  [258, 'ACAABAA'],
  [259, 'ACAABAAA'],
  [260, 'ACAABAAAA'],
  [261, 'ACAABAAAB'],
  [262, 'ACAABAAB'],
  [263, 'ACAB'],
  [264, 'ACAC'],
  [265, 'ACACA'],
  [266, 'ACACB'],
  [267, 'ACB'],
  [268, 'ACC'],
  [269, 'ACCA'],
  [270, 'ACCAA'],
  [271, 'ACCAAA'],
  [272, 'ACCAAAA'],
  [273, 'ACCAAAAA'],
  [274, 'ACCAAAAAA'],
  [275, 'ACCAAAAAB'],
  [276, 'ACCAAAAB'],
  [277, 'ACCAAAABA'],
  [278, 'ACCAAB'],
  [279, 'ACCAABA'],
  [280, 'ACCAABAA'],
  [281, 'ACCAABB'],
  [282, 'ACCAABBA'],
  [283, 'ACCAABBB'],
  [284, 'ACCAAC'],
  [285, 'ACCAACA'],
  [286, 'ACCAACAA'],
  [287, 'ACCAACAAA'],
  [288, 'ACCAACAAB'],
  [289, 'ACCAACAB'],
  [290, 'ACCAACAC'],
  [291, 'ACCAACACA'],
  [292, 'ACCAB'],
  [293, 'ACCABA'],
  [294, 'ACCABAA'],
  [295, 'ACCABAAA'],
  [296, 'ACCABAAAA'],
  [297, 'ACCABB'],
  [298, 'ACCABBA'],
  [299, 'ACCABBAA'],
  [300, 'ACCABBAAA'],
  [301, 'ACCABBAB'],
  [302, 'ACCABBABA'],
  [303, 'ACCABBAC'],
  [304, 'ACCABC'],
  [305, 'ACCABCA'],
  [306, 'ACCABCAA'],
  [307, 'ACCABCAAA'],
  [308, 'ACCABCAAB'],
  [309, 'ACCABCAB'],
  [310, 'ACCABCABA'],
  [311, 'ACCABCAC'],
  [312, 'ACCABCACA'],
  [313, 'ACCABCACB'],
  [314, 'ACCABD'],
  [315, 'ACCABDA'],
  [316, 'ACCABDAA'],
  [317, 'ACCABDAAA'],
  [318, 'ACCABDAB'],
  [319, 'ACCABDABA'],
  [320, 'ACCABDABB'],
  [321, 'ACCABDAC'],
  [322, 'ACCABDAD'],
  [323, 'ACCB'],
  [324, 'ACCBA'],
  [325, 'ACCBB'],
  [326, 'ACCBBA'],
  [327, 'ACCBBAA'],
  [328, 'ACCBBAAA'],
  [329, 'ACCBBAAAA'],
  [330, 'ACCBBAAB'],
  [331, 'ACCBBAABA'],
  [332, 'ACCBBAAC'],
  [333, 'ACCBBAAD'],
  [334, 'ACCBBAADA'],
  [335, 'ACCBBAADB'],
  [336, 'ACCBBAB'],
  [337, 'ACCBBABA'],
  [338, 'ACCBBABAA'],
  [339, 'ACCBBABB'],
  [340, 'ACCBBB'],
  [341, 'ACCBC'],
  [342, 'ACCBCA'],
  [343, 'ACCBD'],
  [344, 'ACCBDA'],
  [345, 'ACD'],
  [346, 'ACDA'],
  [347, 'ACDAA'],
  [348, 'ACDB'],
  [349, 'ACDBA'],
  [350, 'ACDBAA'],
  [351, 'ACDBAAA'],
  [352, 'ACDBAAAA'],
  [353, 'ACDBAAAB'],
  [354, 'ACDBAAABA'],
  [355, 'ACDBB'],
  [356, 'ACDBBA'],
  [357, 'ACDBBB'],
  [358, 'AD'],
  [359, 'ADA'],
  [360, 'ADAA'],
  [361, 'ADAAA'],
  [362, 'ADAAB'],
  [363, 'ADAABA'],
  [364, 'ADAABB'],
  [365, 'ADAABBA'],
  [366, 'ADAABBAA'],
  [367, 'ADAABBAAA'],
  [368, 'ADAABBAB'],
  [369, 'ADAABBABA'],
  [370, 'ADAABBAC'],
  [371, 'ADAABBACA'],
  [372, 'ADAABBAD'],
  [373, 'ADAABBADA'],
  [374, 'ADAAC'],
  [375, 'ADAACA'],
  [376, 'ADAACB'],
  [377, 'ADAB'],
  [378, 'ADB'],
  [379, 'ADBA'],
  [380, 'ADBAA'],
  [381, 'ADBAAA'],
  [382, 'ADBAAAA'],
  [383, 'ADBAAAAA'],
  [384, 'ADBAAAAB'],
  [385, 'ADBAAAABA'],
  [386, 'ADBAAAABB'],
  [387, 'ADBAAAAC'],
  [388, 'ADBAAAACA'],
  [389, 'ADBAAAACB'],
  [390, 'ADBAB'],
  [391, 'ADBABA'],
  [392, 'ADBABAA'],
  [393, 'ADBABAAA'],
  [394, 'ADBABAB'],
  [395, 'ADBABABA'],
  [396, 'ADBABABB'],
  [397, 'ADBABABBA'],
  [398, 'ADBABABBB'],
  [399, 'ADBABB'],
  [400, 'ADBABBA'],
  [401, 'ADBABBAA'],
  [402, 'ADBABBAB'],
  [403, 'ADBABBABA'],
  [404, 'ADBB'],
  [405, 'ADBBA'],
  [406, 'ADBBAA'],
  [407, 'ADBBB'],
  [408, 'ADBBC'],
  [409, 'ADC'],
  [410, 'ADCA'],
  [411, 'ADCAA'],
  [412, 'ADCAAA'],
  [413, 'ADCAAB'],
  [414, 'ADCAB'],
  [415, 'ADD'],
  [416, 'ADDA'],
  [417, 'ADDAA'],
  [418, 'ADDAAA'],
  [419, 'ADDAAB'],
  [420, 'ADDAAC'],
  [421, 'ADDAB'],
  [422, 'ADDABA'],
  [423, 'ADDABB'],
  [424, 'ADDABC'],
  [425, 'ADDABCA'],
  [426, 'ADDABCAA'],
  [427, 'ADDABCAAA'],
  [428, 'ADDABCB'],
  [429, 'ADDABCBA'],
  [430, 'ADDAC'],
  [431, 'ADDB'],
  [432, 'ADDBA'],
  [433, 'ADDBAA'],
  [434, 'ADDBAAA'],
  [435, 'ADDBAAAA'],
  [436, 'ADDBAAAAA'],
  [437, 'ADDBAAAB'],
  [438, 'ADDBAB'],
  [439, 'ADDBABA'],
  [440, 'ADDBABAA'],
  [441, 'ADDBABAB'],
  [442, 'ADDBABAC'],
  [443, 'ADDBABACA'],
  [444, 'ADDBABAD'],
  [445, 'ADDBAC'],
  [446, 'ADDBACA'],
  [447, 'ADDBACAA'],
  [448, 'ADDBACAAA'],
  [449, 'ADDBACAAB'],
  [450, 'ADDBACAB'],
  [451, 'ADDBACABA'],
  [452, 'ADDBACAC'],
  [453, 'ADDBACAD'],
  [454, 'ADDBACAE'],
  [455, 'ADDBACAEA'],
  [456, 'ADDBACB'],
  [457, 'ADDBACBA'],
  [458, 'ADDBACBAA'],
  [459, 'ADDBACBAB'],
  [460, 'ADDBACBB'],
  [461, 'ADDBACBBA'],
  [462, 'ADDBACBBB'],
  [463, 'ADDBACBC'],
  [464, 'ADDBACBCA'],
  [465, 'ADDBACBD'],
  [466, 'ADDBACBDA'],
  [467, 'ADDBACBDB'],
  [468, 'ADDBACBDC'],
  [469, 'ADDBAD'],
  [470, 'ADDBADA'],
  [471, 'ADDBADAA'],
  [472, 'ADDBADAB'],
  [473, 'ADDBADB'],
  [474, 'ADDBADBA'],
  [475, 'ADDBADBAA'],
  [476, 'ADDBADBAB'],
  [477, 'ADDBADBAC'],
  [478, 'ADDBADBAD'],
  [479, 'ADDBADBB'],
  [480, 'ADDBADBC'],
  [481, 'ADDBAE'],
  [482, 'AE'],
  [483, 'AF'],
  [484, 'AFA'],
  [485, 'AFAA'],
  [486, 'AFAB'],
  [487, 'AFABA'],
  [488, 'AFABAA'],
  [489, 'AFABAB'],
  [490, 'AFABABA'],
  [491, 'AFABABAA'],
  [492, 'AFABABAAA'],
  [493, 'AFABABAB'],
  [494, 'AFABABABA'],
  [495, 'AFABABABB'],
  [496, 'AFABAC'],
  [497, 'AFABB'],
  [498, 'AFABBA'],
  [499, 'AFABBAA'],
  [500, 'AFABBAAA'],
  [501, 'AFABBAAAA'],
  [502, 'AFABBAAB'],
  [503, 'AFABBAABA'],
  [504, 'AFABBAAC'],
  [505, 'AFABBAACA'],
  [506, 'AFABBAACB'],
  [507, 'AFABBAAD'],
  [508, 'AFABBAADA'],
  [509, 'AFABBAAE'],
  [510, 'AFABBAAEA'],
  [511, 'AFABBB'],
  [512, 'AFB'],
  [513, 'AFBA'],
  [514, 'AFBAA'],
  [515, 'AFBAAA'],
  [516, 'AFBAAAA'],
  [517, 'AFBAAAAA'],
  [518, 'AFBAAAAAA'],
  [519, 'AFBAAB'],
  [520, 'AFBAABA'],
  [521, 'AFBAABAA'],
  [522, 'AFBAB'],
  [523, 'AFBABA'],
  [524, 'AFBABB'],
  [525, 'AFBABBA'],
  [526, 'AFBABBAA'],
  [527, 'AFBABBAAA'],
  [528, 'AFBABBAAB'],
  [529, 'AFBABBAAC'],
  [530, 'AFBABBAB'],
  [531, 'AFBABBABA'],
  [532, 'AFBABC'],
  [533, 'AFBABCA'],
  [534, 'AFBABCAA'],
  [535, 'AFBABCAB'],
  [536, 'AFBABCABA'],
  [537, 'AFBABCABB'],
  [538, 'AFBABCAC'],
  [539, 'AFBABCACA'],
  [540, 'AFBABCACB'],
  [541, 'AFBABCAD'],
  [542, 'AFBAC'],
  [543, 'AFBACA'],
  [544, 'AFBACB'],
  [545, 'AFBACBA'],
  [546, 'AFBACBAA'],
  [547, 'AFBACBAAA'],
  [548, 'AFBACBAB'],
  [549, 'AFBB'],
  [550, 'AFBBA'],
  [551, 'AFBBAA'],
  [552, 'AFBBAAA'],
  [553, 'AFBBAAAA'],
  [554, 'AFBBAAAAA'],
  [555, 'AFBBAAAAB'],
  [556, 'AFBBAAAB'],
  [557, 'AFBBAAABA'],
  [558, 'AFBBAAAC'],
  [559, 'AFBBAAACA'],
  [560, 'AFBBAB'],
  [561, 'AFBBABA'],
  [562, 'AFBBABAA'],
  [563, 'AFBBABAAA'],
  [564, 'AFBBABAAB'],
  [565, 'AFBBABAB'],
  [566, 'AFBBABABA'],
  [567, 'AFBBABAC'],
  [568, 'AFBBABAD'],
  [569, 'AFBBABAE'],
  [570, 'AFBC'],
  [571, 'AFBCA'],
  [572, 'AFBCAA'],
  [573, 'AFBCAAA'],
  [574, 'AFBCAAAA'],
  [575, 'AFBCAAAAA'],
  [576, 'AFBCAAAAB'],
  [577, 'AFBCAAAAC'],
  [578, 'AFBCAAAAD'],
  [579, 'AFBCAAAB'],
  [580, 'AFBCAAAC'],
  [581, 'AFBCAAB'],
  [582, 'AFBCAABA'],
  [583, 'AFBCAABAA'],
  [584, 'AFBCAABAB'],
  [585, 'AFBCAABB'],
  [586, 'AFBCAAC'],
  [587, 'AFBCAACA'],
  [588, 'AFBCAACAA'],
  [589, 'AFBCAACB'],
  [590, 'AFBCAACBA'],
  [591, 'AFBCAACBB'],
  [592, 'AFBCAACC'],
  [593, 'AFBCAB'],
  [594, 'AFBCB'],
  [595, 'AG'],
  [596, 'AGA'],
  [597, 'AGAA'],
  [598, 'AGAB'],
  [599, 'AGABA'],
  [600, 'AGABAA'],
  [601, 'AGABAAA'],
  [602, 'AGABAAAA'],
  [603, 'AGABAAAB'],
  [604, 'AGABAAABA'],
  [605, 'AGABAAABB'],
  [606, 'AGABAAB'],
  [607, 'AGABAABA'],
  [608, 'AGABAABAA'],
  [609, 'AGABAABB'],
  [610, 'AGABAABC'],
  [611, 'AGABAABD'],
  [612, 'AGABAAC'],
  [613, 'AGABAACA'],
  [614, 'AGABAACAA'],
  [615, 'AGABAACB'],
  [616, 'AGAC'],
  [617, 'AGACA'],
  [618, 'AGACAA'],
  [619, 'AGACAAA'],
  [620, 'AGACAAAA'],
  [621, 'AGACAAAB'],
  [622, 'AGACAAAC'],
  [623, 'AGACAB'],
  [624, 'AGB'],
  [625, 'AGBA'],
  [626, 'AGC'],
  [627, 'AGCA'],
  [628, 'AGCAA'],
  [629, 'AGCAAA'],
  [630, 'AGCAAAA'],
  [631, 'AGCAAAAA'],
  [632, 'AGCAAAAAA'],
  [633, 'AGCAAAAAB'],
  [634, 'AGCAAAAAC'],
  [635, 'AGCAAAAB'],
  [636, 'AGCAAAAC'],
  [637, 'AGCAAAACA'],
  [638, 'AGCAAAACB'],
  [639, 'AGCAAAACC'],
  [640, 'AGCAAAAD'],
  [641, 'AGCAAB'],
  [642, 'AGCAB'],
  [643, 'AGCABA'],
  [644, 'AGCABAA'],
  [645, 'AGCABAAA'],
  [646, 'AGCABAAB'],
  [647, 'AGCABAABA'],
  [648, 'AGCABAABB'],
  [649, 'AGCABB'],
  [650, 'AGCABBA'],
  [651, 'AGCABBAA'],
  [652, 'AGCABBAAA'],
  [653, 'AGCABBAB'],
  [654, 'AGCABBAC'],
  [655, 'AGCABBB'],
  [656, 'AGCABBBA'],
  [657, 'AGCABBBAA'],
  [658, 'AGCABBBAB'],
  [659, 'AGCABBBAC'],
  [660, 'AGCABBC'],
  [661, 'AGCABBCA'],
  [662, 'AGCABBCB'],
  [663, 'AGCABBCC'],
  [664, 'AGCABBCCA'],
  [665, 'AGCABBCCB'],
  [666, 'AGCABBCCC'],
  [667, 'AGCB'],
  [668, 'AGCBA'],
  [669, 'AGCBAA'],
  [670, 'AGCBAB'],
  [671, 'AGCBABA'],
  [672, 'AGCBABAA'],
  [673, 'AGCBABAB'],
  [674, 'AGCBABAC'],
  [675, 'AGCBAC'],
  [676, 'AGCBACA'],
  [677, 'AGCBACAA'],
]

/**
 * Controls which chains animate first on page load.
 * Each entry is an index into STATIC_CHAINS (0 = longest chain, chains are sorted longest-first).
 * When this list is exhausted the animation falls back to the automatic priority pool.
 * Set to [] to use fully automatic selection.
 *
 * Example: [0, 5, 12] plays chain 0, then 5, then 12, then auto.
 */
export const CHAIN_PLAY_ORDER: number[] = []

export const STATIC_CHILDREN: Array<[number, number[]]> = [
  [0, [1, 248, 249, 358, 482, 483, 595]],
  [1, [2, 50, 220, 235]],
  [2, [3, 4]],
  [4, [5, 36, 48]],
  [5, [6, 10, 16, 22, 30, 35]],
  [6, [7]],
  [7, [8, 9]],
  [10, [11]],
  [11, [12, 14]],
  [12, [13]],
  [14, [15]],
  [16, [17]],
  [17, [18, 20]],
  [18, [19]],
  [20, [21]],
  [22, [23]],
  [23, [24, 26, 27, 28]],
  [24, [25]],
  [28, [29]],
  [30, [31]],
  [31, [32]],
  [32, [33, 34]],
  [36, [37, 41, 42]],
  [37, [38]],
  [38, [39]],
  [39, [40]],
  [42, [43]],
  [43, [44, 45, 46, 47]],
  [48, [49]],
  [50, [51, 132, 158]],
  [51, [52, 81, 97]],
  [52, [53, 71, 79, 80]],
  [53, [54, 61]],
  [54, [55, 56, 59]],
  [56, [57, 58]],
  [59, [60]],
  [61, [62, 64, 67, 70]],
  [62, [63]],
  [64, [65, 66]],
  [67, [68, 69]],
  [71, [72]],
  [72, [73, 74, 78]],
  [74, [75, 76, 77]],
  [81, [82]],
  [82, [83, 89]],
  [83, [84, 85, 86, 88]],
  [86, [87]],
  [89, [90, 92, 94]],
  [90, [91]],
  [92, [93]],
  [94, [95, 96]],
  [97, [98, 106, 107, 118, 119]],
  [98, [99]],
  [99, [100, 101, 102, 103]],
  [103, [104, 105]],
  [107, [108, 113]],
  [108, [109, 111, 112]],
  [109, [110]],
  [113, [114, 116]],
  [114, [115]],
  [116, [117]],
  [119, [120, 125]],
  [120, [121, 122]],
  [122, [123, 124]],
  [125, [126, 129, 131]],
  [126, [127, 128]],
  [129, [130]],
  [132, [133, 144, 151]],
  [133, [134, 135]],
  [135, [136]],
  [136, [137, 138, 139, 143]],
  [139, [140, 141, 142]],
  [144, [145]],
  [145, [146]],
  [146, [147, 149]],
  [147, [148]],
  [149, [150]],
  [151, [152]],
  [152, [153]],
  [153, [154, 155, 156]],
  [156, [157]],
  [158, [159, 185]],
  [159, [160, 161, 184]],
  [161, [162, 169, 172, 177]],
  [162, [163, 164, 166, 168]],
  [164, [165]],
  [166, [167]],
  [169, [170, 171]],
  [172, [173, 176]],
  [173, [174, 175]],
  [177, [178, 180, 181]],
  [178, [179]],
  [181, [182, 183]],
  [185, [186, 191, 210]],
  [186, [187]],
  [187, [188, 189]],
  [189, [190]],
  [191, [192, 197, 203]],
  [192, [193, 194, 196]],
  [194, [195]],
  [197, [198, 201]],
  [198, [199, 200]],
  [201, [202]],
  [203, [204, 206, 208]],
  [204, [205]],
  [206, [207]],
  [208, [209]],
  [210, [211, 216]],
  [211, [212, 213]],
  [213, [214, 215]],
  [216, [217, 219]],
  [217, [218]],
  [220, [221, 225, 233]],
  [221, [222, 224]],
  [222, [223]],
  [225, [226, 232]],
  [226, [227]],
  [227, [228]],
  [228, [229, 231]],
  [229, [230]],
  [233, [234]],
  [235, [236, 238]],
  [236, [237]],
  [238, [239]],
  [239, [240, 241, 246, 247]],
  [241, [242]],
  [242, [243, 245]],
  [243, [244]],
  [249, [250, 267, 268, 345]],
  [250, [251, 263, 264]],
  [251, [252, 256]],
  [252, [253, 255]],
  [253, [254]],
  [256, [257]],
  [257, [258]],
  [258, [259, 262]],
  [259, [260, 261]],
  [264, [265, 266]],
  [268, [269, 323]],
  [269, [270, 292]],
  [270, [271, 278, 284]],
  [271, [272]],
  [272, [273, 276]],
  [273, [274, 275]],
  [276, [277]],
  [278, [279, 281]],
  [279, [280]],
  [281, [282, 283]],
  [284, [285]],
  [285, [286, 289, 290]],
  [286, [287, 288]],
  [290, [291]],
  [292, [293, 297, 304, 314]],
  [293, [294]],
  [294, [295]],
  [295, [296]],
  [297, [298]],
  [298, [299, 301, 303]],
  [299, [300]],
  [301, [302]],
  [304, [305]],
  [305, [306, 309, 311]],
  [306, [307, 308]],
  [309, [310]],
  [311, [312, 313]],
  [314, [315]],
  [315, [316, 318, 321, 322]],
  [316, [317]],
  [318, [319, 320]],
  [323, [324, 325, 341, 343]],
  [325, [326, 340]],
  [326, [327, 336]],
  [327, [328, 330, 332, 333]],
  [328, [329]],
  [330, [331]],
  [333, [334, 335]],
  [336, [337, 339]],
  [337, [338]],
  [341, [342]],
  [343, [344]],
  [345, [346, 348]],
  [346, [347]],
  [348, [349, 355]],
  [349, [350]],
  [350, [351]],
  [351, [352, 353]],
  [353, [354]],
  [355, [356, 357]],
  [358, [359, 378, 409, 415]],
  [359, [360, 377]],
  [360, [361, 362, 374]],
  [362, [363, 364]],
  [364, [365]],
  [365, [366, 368, 370, 372]],
  [366, [367]],
  [368, [369]],
  [370, [371]],
  [372, [373]],
  [374, [375, 376]],
  [378, [379, 404]],
  [379, [380, 390]],
  [380, [381]],
  [381, [382]],
  [382, [383, 384, 387]],
  [384, [385, 386]],
  [387, [388, 389]],
  [390, [391, 399]],
  [391, [392, 394]],
  [392, [393]],
  [394, [395, 396]],
  [396, [397, 398]],
  [399, [400]],
  [400, [401, 402]],
  [402, [403]],
  [404, [405, 407, 408]],
  [405, [406]],
  [409, [410]],
  [410, [411, 414]],
  [411, [412, 413]],
  [415, [416, 431]],
  [416, [417, 421, 430]],
  [417, [418, 419, 420]],
  [421, [422, 423, 424]],
  [424, [425, 428]],
  [425, [426]],
  [426, [427]],
  [428, [429]],
  [431, [432]],
  [432, [433, 438, 445, 469, 481]],
  [433, [434]],
  [434, [435, 437]],
  [435, [436]],
  [438, [439]],
  [439, [440, 441, 442, 444]],
  [442, [443]],
  [445, [446, 456]],
  [446, [447, 450, 452, 453, 454]],
  [447, [448, 449]],
  [450, [451]],
  [454, [455]],
  [456, [457, 460, 463, 465]],
  [457, [458, 459]],
  [460, [461, 462]],
  [463, [464]],
  [465, [466, 467, 468]],
  [469, [470, 473]],
  [470, [471, 472]],
  [473, [474, 479, 480]],
  [474, [475, 476, 477, 478]],
  [483, [484, 512]],
  [484, [485, 486]],
  [486, [487, 497]],
  [487, [488, 489, 496]],
  [489, [490]],
  [490, [491, 493]],
  [491, [492]],
  [493, [494, 495]],
  [497, [498, 511]],
  [498, [499]],
  [499, [500, 502, 504, 507, 509]],
  [500, [501]],
  [502, [503]],
  [504, [505, 506]],
  [507, [508]],
  [509, [510]],
  [512, [513, 549, 570]],
  [513, [514, 522, 542]],
  [514, [515, 519]],
  [515, [516]],
  [516, [517]],
  [517, [518]],
  [519, [520]],
  [520, [521]],
  [522, [523, 524, 532]],
  [524, [525]],
  [525, [526, 530]],
  [526, [527, 528, 529]],
  [530, [531]],
  [532, [533]],
  [533, [534, 535, 538, 541]],
  [535, [536, 537]],
  [538, [539, 540]],
  [542, [543, 544]],
  [544, [545]],
  [545, [546, 548]],
  [546, [547]],
  [549, [550]],
  [550, [551, 560]],
  [551, [552]],
  [552, [553, 556, 558]],
  [553, [554, 555]],
  [556, [557]],
  [558, [559]],
  [560, [561]],
  [561, [562, 565, 567, 568, 569]],
  [562, [563, 564]],
  [565, [566]],
  [570, [571, 594]],
  [571, [572, 593]],
  [572, [573, 581, 586]],
  [573, [574, 579, 580]],
  [574, [575, 576, 577, 578]],
  [581, [582, 585]],
  [582, [583, 584]],
  [586, [587, 589, 592]],
  [587, [588]],
  [589, [590, 591]],
  [595, [596, 624, 626]],
  [596, [597, 598, 616]],
  [598, [599]],
  [599, [600]],
  [600, [601, 606, 612]],
  [601, [602, 603]],
  [603, [604, 605]],
  [606, [607, 609, 610, 611]],
  [607, [608]],
  [612, [613, 615]],
  [613, [614]],
  [616, [617]],
  [617, [618, 623]],
  [618, [619]],
  [619, [620, 621, 622]],
  [624, [625]],
  [626, [627, 667]],
  [627, [628, 642]],
  [628, [629, 641]],
  [629, [630]],
  [630, [631, 635, 636, 640]],
  [631, [632, 633, 634]],
  [636, [637, 638, 639]],
  [642, [643, 649]],
  [643, [644]],
  [644, [645, 646]],
  [646, [647, 648]],
  [649, [650, 655, 660]],
  [650, [651, 653, 654]],
  [651, [652]],
  [655, [656]],
  [656, [657, 658, 659]],
  [660, [661, 662, 663]],
  [663, [664, 665, 666]],
  [667, [668]],
  [668, [669, 670, 675]],
  [670, [671]],
  [671, [672, 673, 674]],
  [675, [676]],
  [676, [677]],
]
